var products = {
  aiartwork: {
    imageParams: {
      ver: 'v1',
    },
    styles: [
      'vertical',
      'horizontal'
    ],
    imageParamAsKey: 'angle',
    hasCustomImages: true,
    croppingAspectRatio: 2/3,
    croppingAspectRatios: {
      'ourhome': 1.595, // h
      'family': 2.2, // h (mask-2)
    },
    aspectRatioKey: 'angle',
    selectableImagesConfig: {
      countType: 'fixed',
      count: 1
    },
    uploadLimits: {
      min: 250000,
      max: 15000000
    }
  },
  beachchairs: {
    imageParams: {
      ver: 'v1'
    }
  },
  chaos: {
    imageParams: {
      ver: 'v1',
      style: 'chaos1', // default
      personsAmount: 4
    },
    styles: [
      'chaos1',
      'chaos2'
    ]
  },
  couplehands: {
    imageParams: {
      ver: 'v1'
    },
    styles: [
      'couplehands-style1',
      'couplehands-style2',
      'couplehands-style3',
      'couplehands-style4',
      'couplehands-style5'
    ]
  },
  familyhands: {
    imageParams: {
      ver: 'v3',
      style: 'heart', // default
    },
    styles: [
      'heart',
      'vertical'
    ]
  },
  familyboots: {
    imageParams: {
      ver: 'v1',
      personsAmount: 3
    }
  },
  familychucks: {
    imageParams: {
      ver: 'v1',
      personsAmount: 3
    }
  },
  familyhearts: {
    imageParams: {
      ver: 'v1',
      personsAmount: 2,
      style: 'pier'
    },
    styles: [
      'pier',
      'pier-bw',
      'wood'
    ]
  },
  familyhearts2: {
    imageParams: {
      ver: 'v1',
      personsAmount: 3
    }
  },
  familytree: {
    imageParams: {
      ver: 'v1',
      personsAmount: 4
    },
    styles: [
      'familytree_grandchildren',
      'familytree_family'
    ]
  },
  familytree_upload: {
    imageParams: {
      ver: 'v1',
      personsAmount: 4
    },
    styles: [
      'familytree_upload_family',
      'familytree_upload_grandchildren'
    ],
    hasCustomImages: true,
    croppingAspectRatio: 1.11,
    imageParamAsKey: 'style',
    selectableImagesConfig: {
      countType: 'dynamic',
      imageParam: 'personsAmount',
      isSortable: true,
      sortableSwap: true,
      infoCornerContent: 'index',
    },
    uploadLimits: {
      min: 250000,
      max: 20000000
    }
  },
  familytree2: {
    imageParams: {
      ver: 'v1',
      personsAmount: 3
    }
  },
  heartmap: {
    imageParams: {
      ver: 'v2022',
      style: 'style_1'
    },
    styles: {
      style_1: 'Stil 1',
      style_2: 'Stil 2',
      style_3: 'Stil 3',
      style_4: 'Stil 4',
      style_5: 'Stil 5',
    },
    variantIds: {
      42483432751362: 'style_1',
      42483432816898: 'style_1',
      42483432882434: 'style_1',
      42483433013506: 'style_1',
      42483433079042: 'style_1',
      42494693835010: 'style_2',
      42494693966082: 'style_2',
      42494694097154: 'style_2',
      42494694293762: 'style_2',
      42494694424834: 'style_2',
      42494693867778: 'style_3',
      42494693998850: 'style_3',
      42494694129922: 'style_3',
      42494694326530: 'style_3',
      42494694457602: 'style_3',
      42494693900546: 'style_4',
      42494694031618: 'style_4',
      42494694195458: 'style_4',
      42494694359298: 'style_4',
      42494694490370: 'style_4',
      42494693933314: 'style_5',
      42494694064386: 'style_5',
      42494694260994: 'style_5',
      42494694392066: 'style_5',
      42494694523138: 'style_5'
    }
  },
  heartmap2: {
    imageParams: {
      ver: 'v2022',
      style: 'style_green',
      lnglat: '10.4541194,51.1642292',
      zoom: 4,
      initZoom: 4,
      maptone: 'colorized',
      mapstyle: 'streets',
      place_display: ''
    },
    styles: {
      style_green: 'grün',
      style_grey: 'grau',
      style_red: 'rot',
      style_blue: 'blau',
      style_white: 'weiß',
      style_cyan: 'cyan',
    },
    variantIds: {
      42526354931970: 'style_green',
      42526355095810: 'style_green',
      42526355259650: 'style_green',
      42526355423490: 'style_green',
      42526355587330: 'style_green',
      42557909762306: 'style_grey',
      42557912285442: 'style_grey',
      42557922279682: 'style_grey',
      42557913170178: 'style_grey',
      42557920379138: 'style_grey',
      42526354997506: 'style_red',
      42526355161346: 'style_red',
      42526355325186: 'style_red',
      42526355489026: 'style_red',
      42526355652866: 'style_red',
      42526355030274: 'style_blue',
      42526355194114: 'style_blue',
      42526355357954: 'style_blue',
      42526355521794: 'style_blue',
      42526355685634: 'style_blue',
      42526355063042: 'style_white',
      42526355226882: 'style_white',
      42526355390722: 'style_white',
      42526355554562: 'style_white',
      42526355718402: 'style_white',
      42526355030274: 'style_cyan',
      42526355194114: 'style_cyan',
      42526355357954: 'style_cyan',
      42526355521794: 'style_cyan',
      42526355685634: 'style_cyan'
    }
  },
  lettermask: {
    imageParams: {
      ver: 'v2022'
    },
    defaultTextline1: 'Danke, dass es dich gibt!',
    hasCustomImages: true,
    croppingAspectRatio: 189/235,
    croppingAspectRatioPerImage: [
      192/238,
      157/238,
      192/238,
      157/238,
    ],
    imageParamAsKey: 'word',
    selectableImagesConfig: {
      countType: 'dynamic',
      imageParam: 'word',
      infoCornerContent: 'letter',
      isSortable: true,
      sortableSwap: true
    },
    uploadLimits: {
      min: 250000,
      max: 15000000
    },
  },
  mothersday: {
    imageParams: {
      ver: 'v1'
    },
    styles: [
      'mothersday1',
      'mothersday2',
      'mothersday3',
    ]
  },
  mothersdaymask: {
    imageParams: {
      ver: 'v1'
    },
    styles: [
      'mothersday1',
      'mothersday2',
      'mothersday3',
      'mothersday4',
    ],
    hasCustomImages: true,
    croppingAspectRatio: 3/2,
    selectableImagesConfig: {
      countType: 'fixed',
      count: 1
    },
    croppingAspectRatios: {
      'mothersday1': 3/2,
      'mothersday2': 1/1,
      'mothersday3': 3/2,
      'mothersday4': 0.8,
    },
    aspectRatioKey: 'style',
    imageParamAsKey: 'style',
    uploadLimits: {
      min: 200000,
      max: 15000000
    },
  },
  newborn: {
    imageParams: {
      ver: 'v1'
    }
  },
  newborn2: {
    imageParams: {
      ver: 'v1'
    }
  },
  ourstory: {
    imageParams: {
      ver: 'v1'
    }
  },
  picturetree: {
    imageParams: {
      ver: 'v1'
    },/*
    styles: [
      'picturetree-mama',
      'picturetree-papa',
      /*'picturetree-mom',
      'picturetree-dad',
      'picturetree-familie',
      'picturetree-oma',
      'picturetree-opa',
      'picturetree-omaopa',
      'picturetree-urlaub',
      'picturetree-matura',
      'picturetree-dassindwir'
    ],*/
    //defaultTextline1: 'Danke, dass du immmer für uns da bist!',
    hasCustomImages: true,
    croppingAspectRatio: 1/1,
    croppingAspectRatioPerImage: [
      132/132,
      135/122,
      135/105,
      275/226,
      160/239,      
      269/180,
      147/180
    ],
    selectableImagesConfig: {
      countType: 'fixed',
      count: 7,
      isSortable: true,
      sortableSwap: true,
      infoCornerContent: 'index',
    },
    //imageParamAsKey: 'headline',
    //imageParamAsKey: 'style',
    uploadLimits: {
      min: 250000,
      max: 15000000
    }
  },
  polaroids: {
    imageParams: {
      ver: 'v1'
    },
    defaultTextline1: 'Familie ist, wo das Leben beginnt und die Liebe niemals endet.',
    hasCustomImages: true,
    croppingAspectRatio: 1/1,
    selectableImagesConfig: {
      countType: 'dynamic',
      imageParam: 'imageAmount',
      isSortable: true,
      sortableSwap: true,
      infoCornerContent: 'index',
    },
    uploadLimits: {
      min: 250000,
      max: 15000000
    }
  },
  simplebg: {
    imageParams: {
      ver: 'v1'
    },
    styles: [
      'simplebg-heartbaloons',
      'simplebg-rose1',
      'simplebg-rose2',
      'simplebg-roseheart',
      'simplebg-treeheart',
      'simplebg-treeheart-mother',
      'simplebg-youme',
      'simplebg-married1',
      'simplebg-married2',
      'simplebg-handinhand1',
      'simplebg-bike-signs',
      'simplebg-carved-names',
      'simplebg-watercolor-daisies',
      'simplebg-youme-roses',
      'simplebg-goldhearts1',
      'simplebg-goldhearts2',
      'simplebg-infinity1',
      'simplebg-tiptoes1'
    ]
  },
  simplemask: {
    imageParams: {
      ver: 'v1',
    },
    styles: [
      'simplemask-bestfriends',
    ],
    imageParamAsKey: 'style',
    hasCustomImages: true,
    croppingAspectRatio: 2/3,
    croppingAspectRatios: {
      'simplemask-bestfriends': 258/390
    },
    aspectRatioKey: 'style',
    selectableImagesConfig: {
      countType: 'fixed',
      count: 1
    },
    uploadLimits: {
      min: 250000,
      max: 15000000
    }
  },
  signpost: {
    imageParams: {
      ver: 'v3',
      //background: 'oceanview_2', // default/fallback
      personsAmount: 2
    },
    backgrounds: {
      pier_1: 'Pier',
      autumnroad_1: 'Herbststraße',
      beach_1: 'Palmenstrand',
      beach_2: 'Ozean',
      forestheart_1: 'Herbstwald',
      lighthouse_1: 'Leuchtturm',
      oceanview_1: 'Meerblick',
      oceanview_2: 'Strandweg',
      mountainlake_1: 'Bergsee',
      waterfalls_1: 'Wasserfälle',
      sunset_1: 'Sonnenuntergang',
      sunset_2: 'Abendsonne',
      mountainview_1: 'Bergpanorama',
      greenhills_1: 'Green Hills',
      mountainpath_1: 'Bergpfad',
      treeheart_1: 'Herzbaum',
      treeheart_2: 'Herzbaum',
      treeheart_2_mask: 'Euer Herzbaum',
      cloudheart_1: 'Wolkenherz',
      oldboat_1: 'Boot am Strand',
      mountainpath_2: 'Bergweg',
      winter_1: 'Winterlandschaft',
    },
    bgIsMask: false,
    croppingAspectRatio: 3/2,
    croppingAspectRatios: {
      'treeheart_2_mask': 4/3
    },
    aspectRatioKey: 'background',
    imageParamAsKey: 'background',
    selectableImagesConfig: {
      countType: 'fixed',
      count: 1
    },
    uploadLimits: {
      min: 300000,
      max: 15000000
    }
  },
  signpost2: {
    imageParams: {
      ver: 'v1',
      personsAmount: 3
    },
    backgrounds: {
      pier_1: 'Pier',
      autumnroad_1: 'Herbststraße',
      beach_1: 'Palmenstrand',
      beach_2: 'Ozean',
      forestheart_1: 'Herbstwald',
      lighthouse_1: 'Leuchtturm',
      oceanview_1: 'Meerblick',
      oceanview_2: 'Strandweg',
      oceanview_3: 'Unser Familienweg',
      mountainlake_1: 'Bergsee',
      waterfalls_1: 'Wasserfälle',
      sunset_1: 'Sonnenuntergang',
      sunset_2: 'Abendsonne',
      mountainview_1: 'Bergpanorama',
      greenhills_1: 'Green Hills',
      mountainpath_1: 'Bergpfad',
      treeheart_1: 'Herzbaum',
      treeheart_2: 'Herzbaum',
      treeheart_2_mask: 'Euer Herzbaum',
      cloudheart_1: 'Wolkenherz',
      oldboat_1: 'Boot am Strand',
      mountainpath_2: 'Bergweg',
      winter_1: 'Winterlandschaft',
    },
    additionalOptions: {
      oceanview_1: ['additional_option_butterflies','additional_option_text'],
      oceanview_2: ['additional_option_butterflies','additional_option_text'],
      oceanview_3: ['additional_option_butterflies','additional_option_text'],
    },
    bgIsMask: false,
    croppingAspectRatio: 3/2,
    croppingAspectRatios: {
      'treeheart_2_mask': 4/3
    },
    aspectRatioKey: 'background',
    imageParamAsKey: 'background',
    selectableImagesConfig: {
      countType: 'fixed',
      count: 1
    },
    uploadLimits: {
      min: 300000,
      max: 15000000
    }
  },
  streetsigncouple: {
    imageParams: {
      ver: 'v1'
    }
  },
  watercolor: {
    imageParams: {
      ver: 'v1',
    },
    imageParamAsKey: 'angle',
    hasCustomImages: true,
    croppingAspectRatio: 2/3,
    croppingAspectRatios: {
      'pets': 0.84,
      'cats': 0.84,
      'horses': 0.84,
      'couples': 0.84,
      'memorial': 0.78, // v
      'family': 1.56, // h (mask-h_3)
      'oilpainting': 0.84,
    },
    convertAspectRatios: {
      //'family': '16:9',
      //'family': '21:9',
      //'oilpainting': '3:4',
      'memorial': '2:3',
    },
    aspectRatioKey: 'angle',
    selectableImagesConfig: {
      countType: 'fixed',
      count: 1
    },
    uploadLimits: {
      min: 250000,
      max: 15000000
    }
  },
  wordcollage: {
    imageParams: {
      ver: 'v1'
    },
    styles: [
      'wordcollage-mama',
      'wordcollage-papa'
    ],
    hasCustomImages: true,
    croppingAspectRatio: 272/184,
    croppingAspectRatios: {
      'v1':272/184,
      'v2':272/367
    },
    aspectRatioKey: 'layout',
    imageParamAsKey: 'style',
    selectableImagesConfig: {
      countType: 'fixed',
      count: 8,
      isSortable: true,
      sortableSwap: true,
      infoCornerContent: 'index',
    },
    uploadLimits: {
      min: 250000,
      max: 15000000
    }
  },
  wordmask: {
    imageParams: {
      ver: 'v1'
    },
    hasCustomImages: true,
    croppingAspectRatio: 2/1,
    selectableImagesConfig: {
      countType: 'fixed',
      count: 1
    },
    uploadLimits: {
      min: 250000,
      max: 20000000
    }
  },
  zodiacsigns: {
    imageParams: {
      ver: 'v1',
      personsAmount: 3
    }
  },
  zuhause: {
    imageParams: {
      ver: 'v1',
      personsAmount: 2
    },
    styles: [
      'zuhause'
    ]
  },
  planner: {
    imageParams: {
      ver: 'v1',
      personsAmount: 4
    }
  },
}

var floatingFrames = {
  variants: {
      '30 x 20cm': {
        colors: {
          white: '43937207779595',
          black: '43937207746827',
          oak: '43937207845131',
          walnut: '43937207877899',
        },
        price: 19.95
      },
      '40 x 30cm': {
        colors: {
          white: '43937207943435',
          black: '43937207910667',
          oak: '43937208008971',
          walnut: '43937208041739',
        },
        price: 29.95
      },
      '60 x 40cm': {
        colors: {
          white: '43937208107275',
          black: '43937208074507',
          oak: '43937208172811',
          walnut: '43937208205579',
        },
        price: 34.95
      },
      '80 x 60cm': {
        colors: {
          white: '43937208271115',
          black: '43937208238347',
          oak: '43937208369419',
          walnut: '43937208402187',
        },
        price: 44.95
      },
      /********************* VERTICAL *****************/
      '20 x 30cm': {
        colors: {
          white: '44869698421003',
          black: '44869698388235',
          oak: '44869698453771',
          walnut: '44869698486539',
        },
        price: 19.95
      },
      '30 x 40cm': {
        colors: {
          white: '44869715919115',
          black: '44869715886347',
          oak: '44869715951883',
          walnut: '44869715984651',
        },
        price: 29.95
      },
      '40 x 60cm': {
        colors: {
          white: '44869716050187',
          black: '44869716017419',
          oak: '44869716082955',
          walnut: '44869716115723',
        },
        price: 34.95
      },
      '60 x 80cm': {
        colors: {
          white: '44869716181259',
          black: '44869716148491',
          oak: '44869716214027',
          walnut: '44869716246795',
        },
        price: 44.95
      },
  },
  sizeMapping: {
    '20 x 30cm': '30 x 20cm',
    '30 x 40cm': '40 x 30cm',
    '40 x 60cm': '60 x 40cm',
    '60 x 80cm': '80 x 60cm',
  }
}

var allowEditMode = false;

var customizationData = null;

var imageParams = {};

var timers = {};

var isTibProduct = false;

var server = 'preview.smileposter.de';

var imgRenderPath = '/img-render/';

var uploadFormData = null;

const isPreview = !!document.querySelector('iframe[src*="preview-bar"]');

function splog() {
  // log only on dev
  if (!$('#preview-bar-iframe').length) return;
  let arr = [];
  if (arguments.length > 1) {
    for (let i = 0; i < arguments.length; i++) {
      arr.push(arguments[i]);
    }
    console.debug(arr);  
  } else {
    console.debug(arguments[0]);
  }
}

function isVisible($elem) {
  return $elem.css('display') !== 'none'
}

function is_touch_enabled() {
	return ( 'ontouchstart' in window ) ||
		( navigator.maxTouchPoints > 0 ) ||
		( navigator.msMaxTouchPoints > 0 );
}

function spLocalStorageSet(name,data,type) {
  data = data || {};
  if (type == 'json') {
    window.localStorage.setItem(name,JSON.stringify(data));
  } else {
    window.localStorage.setItem(name,data);
  }
}

function spLocalStorageGet(name,type) {
  type = type || '';
  var data = window.localStorage.getItem(name);
  if (data) {
    if (type == 'json') {
      try {
        return JSON.parse(data);
      } catch(e) {
        console.log(e);
      }
    } else {
      return data;
    }
  }
  return false;
}

function spLocalStorageRemove(name) {
  localStorage.removeItem(name);
}

/**
 * returns image params object from local storage
 */
function getImageParamsFromCookie(cookieKey) {
  // As soon as a product is added to cart, imageParams are stored in a seperate cookie
  // (sp_image_params_cart_items) so that params like imageOrder can't get changed afterwards
  // If in editMode params are retrieved from this cookie
  var cartItemKey = getCurrentCartItemKey(),
      cookieName = cartItemKey ? 'sp_image_params_cart_items' : 'sp_image_params',
      imageParams = spLocalStorageGet(cookieName,'json') || {};

  if (cartItemKey) {
    if (!imageParams[cartItemKey]) {
      imageParams[cartItemKey] = {};
    }
    return imageParams[cartItemKey][cookieKey] || false;
  } else {
    return imageParams[cookieKey] || false;
  }
}

function setImageParamsToCookie(cookieKey,params) {
  var cartItemKey = getCurrentCartItemKey(),
      cookieName = cartItemKey ? 'sp_image_params_cart_items' : 'sp_image_params',
      imageParams = spLocalStorageGet(cookieName,'json') || {};

  if (cartItemKey) {
    if (!imageParams[cartItemKey]) {
      imageParams[cartItemKey] = {};
    }
    imageParams[cartItemKey][cookieKey] = params;  
  } else {
    imageParams[cookieKey] = params;    
  }
  
  spLocalStorageSet(cookieName,imageParams,'json');
}

function getImageParamsCookieKey() {
  var key = imageParams[customizationData.imageParamAsKey] ? imageParams.productType + '-' + imageParams[customizationData.imageParamAsKey] : imageParams.productType;
  return key;
}

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
     var context = this,
         args = arguments;

     var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
     };
     var callNow = immediate && !timeout;
     clearTimeout(timeout);
     timeout = setTimeout(later, wait);
     if (callNow) func.apply(context, args);
  };
};

function isPageType(pageType) {
  var path = window.location.pathname,
      search = '/'+pageType;

  if (path.indexOf('gutschein') > -1) {
    return pageType === 'giftcard';
  }

  if (pageType === 'index' && window.location.pathname == '/') {
    return true;
  }

  if (pageType === 'products') {
    search += '/';
  }
  return path.indexOf(search) > -1;
}

function isCustomImageProductPage() {
  return location.pathname.indexOf('products/personalisierte-leinwand-individuell') > -1;
}

function isPersonalizationOffProductPage() {
  return location.pathname.indexOf('products/leinwand-ohne-personalisierung') > -1;
}

var queryStringToObject = function(params) {
  params = new URLSearchParams(params);
  const result = {};
  for(const [key, value] of params.entries()) {
    result[key] = decodeURIComponent(value);
  }
  return result;
}

var objectToQueryString = function(object) {
  return new URLSearchParams(object).toString();
}

var stringToHash = function(string) {
  var hash = '';
  for (var i=0; i<string.length; i++) {
      var char = string.charCodeAt(i);
      hash = ((hash<<5)-hash)+char;
      hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
}
/*
var getUid__DEPR = function() {
    var uid = spLocalStorageGet('sp_uid') || '';
    if (uid) {
      return uid;
    }
    var nav = window.navigator;
    var screen = window.screen;
    uid = nav.mimeTypes.length;
    uid += nav.userAgent.replace(/\D+/g, '');
    uid += nav.plugins.length;
    uid += screen.height || '';
    uid += screen.width || '';
    uid += screen.pixelDepth || '';
    uid += new Date().getTime();
    return uid;
};
*/
var getUid = function() {
    var uid = spLocalStorageGet('sp_uid') || '';
    if (!uid) {
      var nav = window.navigator;
      var screen = window.screen;
      uid = nav.mimeTypes.length;
      uid += nav.userAgent.replace(/\D+/g, '');
      uid += nav.plugins.length;
      uid += screen.height || '';
      uid += screen.width || '';
      uid += screen.pixelDepth || '';
      uid += new Date().getTime();
    }
    $('[name="properties[_uid]"]').val(uid);
    return uid;
};

var numToMonth = function(num) {
  var lang = imageParams.lang || 'de',
      months = {
        'de': ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
        'en': ['January','February','March','April','May','June','July','August','September','October','November','December']
      };
  return months[lang][num-1] || num;
}

var addLeadingZero = function(num) {
  num = Number(num) || '';
  if (num) {
    num = num < 10 ? '0' + num : num;
  }
  return num;
}

var formatDateDE = function(dateString) { // e.g. 2019-7-21
  if (!dateString) return;

  var formattedDate = '',
      dateParts = dateString.split('-');

  if (dateParts.length == 1) {
    formattedDate = dateParts[0];
  } else if (dateParts.length == 2) {
    // is year?
    if (dateParts[0].length == 4) {
      // 2019-7 -> Juli 2019
      formattedDate = numToMonth(dateParts[1]) + ' ' + dateParts[0];
    } else {
      // 7-21 -> 21.07.
      formattedDate = addLeadingZero(dateParts[1]) + '.' + addLeadingZero(dateParts[0]) + '.';
    }
  } else {
    // 2019-7-21 -> 21.07.2019
    formattedDate = addLeadingZero(dateParts[2]) + '.' + addLeadingZero(dateParts[1]) + '.' + addLeadingZero(dateParts[0]);
  }

  return formattedDate;
}

var initPinchZoom = function(selector) {

  if (!is_touch_enabled()) {
    return;
  }

  var imageDivs = document.querySelectorAll(selector),
      initZoom = function(elem) {
        if (elem.classList.contains('pinch-zoom-initialized')) return;
        elem.classList.remove('image-zoom');
        elem.classList.add('pinch-zoom-initialized');
        /*if (PinchZoom) {
          new PinchZoom(elem, {
            draggableUnzoomed: false,
            minZoom: 1,
            maxZoom: 2.3,
            zoomOutFactor: 0
          });
        }*/
      };

  imageDivs.forEach(function(elem, i) {
    var img = elem.querySelector('img');
    if (img.complete) {
        initZoom(elem);
    } else {
      //console.log('WAIT FOR IMG.............');
      // we need to wait until img is loaded
      // so PinchZoom has the final img dimensions to work with
      img.onload = function() {
        initZoom(elem);
      }
    }
  });
}

var setProductTitle = function(motiv) {
  var titlePrefix = isPersonalizationOffProductPage() ? 'Leinwand' : 'Personalisierte Leinwand',
      title = titlePrefix + ' "' + motiv + '"';

  $('.product__title').html('<h1>'+title+'<h1>');
  $('#hidden_input_personalization_off_title').val(title);
}

var showHideInputFields = function(amount,containerSelector) {   
  $inputContainers = $(containerSelector).find('.input_container');
  $inputContainers.forEach(function(div,index) {
    var $div = $(div);
    if (index < amount) {
      $div.removeClass('disabled');
      $div.find('input').prop('disabled',false);
    } else {
      $div.addClass('disabled');
      $div.find('input').prop('disabled',true);
    }
  });
}

var showHideMultiColumnInputFields = function(config) {
  var containerSelector = config.containerSelector || '',
      amount = config.amount || 1,
      colSelectors = config.colSelectors || [];
    $(containerSelector).find('.input_container_multicol').forEach(function(container,index) {
      var pos = index + 1,
          enabled = index < amount;
        if (enabled) {
          $(container).show();
        } else {
          $(container).hide();
        }
      colSelectors.forEach(function(colSelector){       
        var $inputConainer = $(container).find(colSelector+pos);
        if (enabled) {
          $inputConainer.removeClass('disabled');
        } else {
          $inputConainer.addClass('disabled');
        }
      });
    });
}

var showHideHiddenOptions = function(amount,containerSelector) {
  $inputContainers = $(containerSelector).find('.hidden_options_swatches_row');
  $inputContainers.forEach(function(div,index) {
    var $div = $(div);
    if (index < amount) {
      $div.removeClass('disabled');
    } else {
      $div.addClass('disabled');
    }
  });
}

var activateSwatch = function($currentTarget) {
  var swatchType = $currentTarget.data('type') || '';
  $('[data-type="'+swatchType+'"].active').removeClass('active');
  $currentTarget.addClass('active');
}

var handlePersonsSwatch = function(config) {

  config = config || {};

  var $currentTarget = config.currentTarget,
      updatePreviewImage = config.updatePreviewImage || false,
      imageParam = $currentTarget.data('imageparam') || 'personsAmount',
      containerClass = config.containerClass || '.persons_names',
      $container = $(containerClass),
      personsMax = $container.find('.input_container').length;

  activateSwatch($currentTarget);

  imageParams[imageParam] = $currentTarget.data('amount');

  for(var i=1; i<=personsMax; i++) {
    var nameParam = 'name' + i,
        $div = $container.find('.' + nameParam);
    if (i<=imageParams[imageParam]) {
      $div.removeClass('disabled');
      $div.find('input').prop('disabled',false).prop('required',true);
    } else {
      $div.addClass('disabled');
      $div.find('input').prop('disabled',true).prop('required',false);
    }
  }

  if (updatePreviewImage) {
  	fetchPreviewImage();
  }
};

var handleDirectionSwatch = function(config) {

  config = config || {};

  var $currentTarget = config.currentTarget,
      updatePreviewImage = config.updatePreviewImage || false,
      setHiddenInputDirection = function() {
        var directionTranslated = {
              none: 'ohne Spitze',
              left: 'links',
              right: 'rechts',
              nd: 'ohne Spitzen', // signpost2
              lr: 'links/rechts', // signpost2
            },
            defaultDirection = 'links/rechts',
            translation = directionTranslated[imageParams.direction] || defaultDirection;
        $('#hidden_input_direction').val(translation);
      };

  activateSwatch($currentTarget);

  imageParams.direction = $currentTarget.data('direction');

  setHiddenInputDirection();

  if (updatePreviewImage) {
  	fetchPreviewImage();
  }
};

var handleBackgroundSwatch = function(config) {

  config = config || {};
  
  var $currentTarget = config.currentTarget,
      updatePreviewImage = config.updatePreviewImage || false; 
  
  activateSwatch($currentTarget);

  var bg = $currentTarget.data('background'),
      productId = $currentTarget.data('productid'),
      motiv = $currentTarget.data('name');

  if (updatePreviewImage) {
    
    if (bg === 'custom') {
    } else {
      imageParams.background = bg;
    }

    fetchPreviewImage();
  }

  $('#hidden_input_background').val(motiv);

  setProductTitle(motiv);

  // customization allwowed: new product data is fetchted according to selected background
  // no customization: we always keep the same product data
  if (isPersonalizationOffProductPage()) {
    return;
  }
  
  // fetch product json for selected background
  fetch('//'+server+'/orders/fetchVariantsJson.php?productId='+productId, {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
  .then((response) => {
    response.json().then((responseJson) => {
      //console.log(responseJson);
      // update inline json inside variants component
      $('#variant-picker-container').find('[type="application/json"]').html(JSON.stringify(responseJson));

      // in case swatches are used for "size" selection
      $variantSwatches = $('#variant-picker-container').find('variant-radios');

      var currentOption = null;

      if ($variantSwatches.length) {
        // get current selected option, e.g. 30 x 20
        currentOption = $variantSwatches.find('input[name="Größe"]:checked').val();
      }

	  // find variant according to current option      
      var newVariant = responseJson.filter(function(variant) {
        return variant.option1 === currentOption;
      })[0];

      // update hidden input field
      $('[name="id"]').val(newVariant.id);

      var url = responseJson[0].productHandle ? '/products/' + responseJson[0].productHandle : '';

      if (url) {
        // update data-url in variant picker element (variant-selects or variant-radios)
        // this url is used to fetch new price wehen variant (Größe) is changed
        $('#variant-picker-container').find('variant-selects,variant-radios').data('url',url);

        // update url
        window.history.replaceState({ }, '', `${url}?variant=${newVariant.id}`);
      }
    });
  });  
};

var handleVariantSwatch = function(config) {

  config = config || {};

  var $currentTarget = config.currentTarget,
      updatePreviewImage = config.updatePreviewImage || false;

  activateSwatch($currentTarget);

  var param = $currentTarget.data('param'),
      value = $currentTarget.data('value'),
      name = $currentTarget.data('name'),
      hiddenInputId = '#'+$currentTarget.data('hiddeninputid');

  $(hiddenInputId).val(name);
  imageParams[param] = value;

  // in case swatches are used for "size" selection
  $variantSwatches = $('variant-radios .product-form__input.Stil');

  if ($variantSwatches.length && $variantSwatches.find('input[type=radio]:checked').val() != name) {
    $variantSwatches.find('input[type=radio]:checked').prop('checked', false);
  	$variantSwatches.find('input[type=radio][value="'+name+'"]').prop('checked','checked');
  	$variantSwatches.find('input[type=radio]').change();
  }

  // in case input selects are used for "size" selection
  $variantSelects = $('variant-selects .product-form__input.Stil select');
  
  // attention currently untested, needs to be checked if going back to selects
  if ($variantSelects.length && $variantSelects != name) {
  	$variantSelects.find('option').removeAttr('selected');
  	$variantSelects.find('[value="'+name+'"]').attr('selected','selected');
  	$variantSelects.change();
  }
  
  if (updatePreviewImage) fetchPreviewImage();
};

var handleSwatch = function(config) {

  config = config || {};

  var $currentTarget = config.currentTarget,
      updatePreviewImage = config.updatePreviewImage || false,
      updateImageParamsOnly = config.updateImageParamsOnly || false,
      type = $currentTarget.data('type'),
      value = $currentTarget.data('value'),
      label = $currentTarget.data('label');

  activateSwatch($currentTarget);

  $('#hidden_input_' + type).val(label);

  if (typeof value === 'undefined' || typeof type === 'undefined' || value === 'undefined' || type === 'undefined') {
    delete imageParams[type];
  } else {
    imageParams[type] = value;
  }

  if (updatePreviewImage && !updateImageParamsOnly) {
  	fetchPreviewImage();
  }

  if (updateImageParamsOnly) {
    setImageParamsToCookie(getImageParamsCookieKey(),objectToQueryString(imageParams));
  }
};

var initSwatchEvents = function() {

  $('.sp_options-container').on('click', '.swatch', function(event) {

    var $currentTarget = $(event.currentTarget),
        updateImageParamsOnly = $currentTarget.data('update_params_only');

    if ($currentTarget.hasClass('disabled')) return;
    if ($currentTarget.data('type') == 'floatingFrame') return;
    if ($currentTarget.data('type') == 'hidden_options_toggle') return;
    if ($currentTarget.data('customswatchhandle') == '1') return;

    if ($currentTarget.data('type') == 'personsAmount') {
      showHideInputFields($currentTarget.data('value'),'.persons_names');
    }

    if ($currentTarget.data('type') == 'eventsAmount') { // ourstory
      showHideInputFields($currentTarget.data('value'),'.events');
    }

    // close hidden option after selection
    closeHiddenOptionsOverlay();

    handleSwatch({
      currentTarget:$currentTarget,
      updatePreviewImage:true,
      updateImageParamsOnly:updateImageParamsOnly || false
    });
  });
}

var prefillInputFields = function() {

  $('.input_container').each(function(i,div) {
    $(div).find('input').each(function(i,input) {
    var imageparam = $(input).data('imageparam');
      if (imageParams[imageparam] && imageParams[imageparam] !== 'undefined') {
        $(input).val(imageParams[imageparam]);
      }
    });
  });
}

var prefillInputFieldsDecoded = function(selector) {
  selector = selector || '.input_container'; 
  $(selector).each(function(i,div) {
    $(div).find('input').each(function(i,input) {
    var imageparam = $(input).data('imageparam');
      if (imageParams[imageparam] && imageParams[imageparam] !== 'undefined') {
        $(input).val(decodeURIComponent(imageParams[imageparam]));
      }
    });
  });
}

var initObservedSelects = function() {
  $(document).on('change', 'select[data-observed]',function(event) {
    var name = $(this).attr('name'),
        label = event.currentTarget.options[event.currentTarget.selectedIndex].text,
        val = $(this).val() || '';
    imageParams[name] = val;
    updateHiddenFieldForSelect(event.currentTarget);
    fetchPreviewImage();
  });
  $('select[data-observed="1"]').each(function(i,select) {
    var imageParam = imageParams[$(select).attr('name')] || '';

    if (imageParam) {
      $(select).val(imageParam);
    }
    updateHiddenFieldForSelect(select);
  });
}

var toggleHiddenOptionsOverlay = function($hiddenOptionsContainer) {
  $hiddenOptionsContainer.toggleClass('show');
  $('body').toggleClass('hidden-options-show');
  $('body').toggleClass('overflow-hidden');
}

var openHiddenOptionsOverlay = function($hiddenOptionsContainer) {
  $hiddenOptionsContainer.addClass('show');
  $('body').addClass('hidden-options-show');
  $('body').addClass('overflow-hidden');
}

var closeHiddenOptionsOverlay = function() {
  $('.hidden_options_container').removeClass('show');
  $('body').removeClass('hidden-options-show');
  $('body').removeClass('overflow-hidden');
}

var handleHiddenOptions = function() {

  var $container = $('.hidden_options_container');

  var validateNameInput = function($nameInputContainer,$hiddenOptionsContainer) {

    if (!$nameInputContainer.length || !isVisible($nameInputContainer)) {
      return true;
    }

    if (!$nameInputContainer.find('input').val()) {
      $nameInputContainer.addClass('error');
    	var h = $hiddenOptionsContainer.get(0).scrollHeight;
      $hiddenOptionsContainer[0].scrollTo({
        top: h,
        behavior: 'smooth'
      });
      return false;
    }

    $nameInputContainer.removeClass('error');
    return true;
  };

  $container.each(function(index,elem) {

    var $toggle = $(elem).find('.hidden_options_toggle'),
        $close = $(elem).find('.hidden_options_close'),
        $closeBtn = $(elem).find('.hidden_options_close_btn'),
        $overlay = $(elem).find('.hidden_options_overlay'),
        $swatches = $(elem).find('.hidden_options_swatches'),
        $scrollContainer = $(elem).find('.hidden_options_swatches_content'),
        $nameInputContainer = $('.hidden_options_kidsname.kidsname'+(index+1)+' .kidsNameInput');

    $toggle.on('click', function() {
      toggleHiddenOptionsOverlay($(elem));
    });
  
    $close.on('click touchend', function(event) {
      event.stopPropagation();
      closeHiddenOptionsOverlay();
      return false; // prevent clicking/tapping element underneath overlay
    });

    $closeBtn.on('click touchend', function(event) {
      event.stopPropagation();
      if (validateNameInput($nameInputContainer,$scrollContainer)) {
        closeHiddenOptionsOverlay();
      }
      return false; // prevent clicking/tapping element underneath overlay
    });
  
    $overlay.on('mousedown touchstart', function() {
      event.preventDefault();
      event.stopPropagation();
      closeHiddenOptionsOverlay();
    });
  }); 
}

/**
 * Whenever an input field changes we update all other imageparams as well
 * to make sure auto-filled input fields are also regarded
 */
var allIntputFieldsToImageParams = function() { 
  $('input[data-imageparam]:not(:disabled),textarea[data-imageparam]:not(:disabled)').each(function(index,inputField) {
    imageParams[$(inputField).data('imageparam')] = encodeURIComponent($(inputField).val().trim());
  });
}

var toggleCustomTextArea = function(showfield) {
  showfield = showfield || '';
  var $field = $('#custom_text_textarea_container[data-hiddenfield="'+showfield+'"');
  if ($field.length) {
    $('#custom_text_textarea_container').show();
  } else {
    $('#custom_text_textarea_container').hide();
  }
}

var toggleMultipleCustomTextAreas = function(showfield) {
  showfield = showfield || '';
  var $field = $('.custom_text_textarea_container[data-hiddenfield="'+showfield+'"');
  $('.custom_text_textarea_container').hide(); 
  $('.custom_text_textarea_container').find('input').prop('disabled',true); 
  if ($field.length) {
    $field.show();
    $field.find('input').prop('disabled',false);  
  }
}

var updateHiddenFieldForSelect = function(select) {
    if (!select) return;
    var text = select.options[select.selectedIndex].value ? select.options[select.selectedIndex].text : '';
    if ($(select).val() == 'custom') {
      text = $('#custom_text_textarea').val();
    }
    $('#hidden_input_' + $(select).attr('name')).val(text);
}

var initTextSelectChangeEvent = function(config) {
  config = config || {};
  
  $('#text_type_select').on('change', function() {
    imageParams.text = $(this).val();
    if (config.multipleFields) {
      toggleMultipleCustomTextAreas(this.options[this.selectedIndex].dataset.showfield);
    } else {
      toggleCustomTextArea(this.options[this.selectedIndex].dataset.showfield);
    }
    fetchPreviewImage();
    updateHiddenFieldForSelect(this);
  });

  $('#custom_text_textarea').on('input', function() {
    $('#hidden_input_text_type_select').val($(this).val());
  });

  updateHiddenFieldForSelect($('#text_type_select')[0]);
}

var initDatePicker = function(config) {
  
    config = config || {};

    var dates = {},
        fetchPreviewOnDatePartChange = config.fetchPreviewOnDatePartChange || false;

    $('.input_container_date_selects').find('select').on('change', function() {

        var value = $(this).val(),
            dateType = $(this).data('datetype'),
            dateParam = 'date' + $(this).data('index');
    
        dates[dateParam] = dates[dateParam] || {'day':'','month':'','year':''}; 
        dates[dateParam][dateType] = value;

        if (fetchPreviewOnDatePartChange) {

            if (dates[dateParam].day) imageParams.day = dates[dateParam].day;
            if (dates[dateParam].month) imageParams.month = dates[dateParam].month;
            if (dates[dateParam].year) imageParams.year = dates[dateParam].year;

            var day = imageParams.day < 10 ? '0' + imageParams.day : imageParams.day,
                month = imageParams.month < 10 ? '0' + imageParams.month : imageParams.month,
                year = imageParams.year || '',          
                date = day && month && year ? [day,month,year].join('.') : '';

            $('#hidden_input_date').val(date);

            if (config.fetchPreviewImage) {
              fetchPreviewImage();
            }
        } else {

          var doNothing = false;

          if (dates[dateParam].day && dates[dateParam].month) {

            imageParams[dateParam] = dates[dateParam].month + '-' + dates[dateParam].day;
      
            if (dates[dateParam].year) {
      
              imageParams[dateParam] = dates[dateParam].year + '-' + imageParams[dateParam];
      
              if (config.closeOnYearSelected && dateType == 'year') {
                closeHiddenOptionsOverlay();
              }
            }

          // allow "year and month only"
          } else if (config.allowMonthAndYear && !dates[dateParam].day && dates[dateParam].month && dates[dateParam].year) {

            imageParams[dateParam] = dates[dateParam].year+'-'+dates[dateParam].month;

          // allow "year only"
          } else if (!dates[dateParam].day && !dates[dateParam].month && dates[dateParam].year) {

            imageParams[dateParam] = dates[dateParam].year;
           
          // make date "resetable"
          } else if (!dates[dateParam].day && !dates[dateParam].month && !dates[dateParam].year) {

            imageParams[dateParam] = '';

          // e.g. when only day and year are selected
          } else {
            doNothing = true;
          }

          if (!doNothing) {

            if ($('#hidden_input_' + dateParam).length) $('#hidden_input_' + dateParam).val(formatDateDE(imageParams[dateParam]));

            if (config.fetchPreviewImage) {
              fetchPreviewImage();
            }
          }
        }
    });

    $('.input_container_date_selects').find('select').each(function() {
        var index = $(this).data('index'),
            dateType = $(this).data('datetype'),
            dateParam = 'date' + index,
            date = imageParams[dateParam] || '',
            dateParts = {
              day: imageParams.day || '',
              month: imageParams.month || '',
              year: imageParams.year || ''
            };

        if (date) {

            var dateParts = date.split('-'),
                firstDatePartIsYear = dateParts[0].length == 4,
                day = firstDatePartIsYear ? dateParts[2] : dateParts[1],
                month = firstDatePartIsYear ? dateParts[1] : dateParts[0];

            dates[dateParam] = {
             'day': day || '',
             'month': month || '',
             'year': firstDatePartIsYear ? dateParts[0] : ''           
            };

            $(this).val(dates[dateParam][dateType]);
        } else {
          $(this).val(dateParts[dateType]);
        }
    });
}

var activateHiddenOptions = function() {
  $('.hidden_options_container').each(function(i,div) {
    $(div).find('.swatch').each(function(i,swatch) {
      if (imageParams[$(swatch).data('type')] == $(swatch).data('value')) {
        handleSwatch({currentTarget:$(swatch)});
      } else {
      }
    });
  });
}

function validateFile(file) {

  var valid = true,
      msg = '',
      uploadLimits = customizationData.uploadLimits || {},
      sizeLimitMin = uploadLimits.min || 500000, // 0,5 megabyte
      sizeLimitMax = uploadLimits.max || 15000000; // 15 megabyte
  
  $('.upload_box_error-msg').hide();

  if (file.type !== 'image/jpeg') {
    msg = 'Falsches Dateiformat. Zulässig sind nur jpg/jpeg Dateien';
    valid = false;
  }

  if (file.size > sizeLimitMax) {
    sizeLimitMax = sizeLimitMax / 1000000;
    msg = 'Die Datei ist zu groß. Maximal Dateigröße sind '+sizeLimitMax+' MB';
    valid = false;
  }

  if (file.size < sizeLimitMin) {
    sizeLimitMin = sizeLimitMin / 1000;
    msg = 'Die Datei ist zu klein. Minimale Dateigröße sind '+sizeLimitMin+' KB';
    valid = false;
  }

  if (!valid) {
    $('.upload_box_error-msg').find('.msg').html(msg);
    $('.upload_box_error-msg').show();
  }
  
  return valid;
}

/**
 * highlights all used images, e.g. 4 images for "MAMA"
 */
function highlightActiveThumbs() {
  var divs = $('#uploaded_thumbs').find('.uploaded_thumb'),
      selectableImagesConfig = customizationData.selectableImagesConfig,
      selectableImagesCount = selectableImagesConfig.count || 0,
      imageParamValue = '',
      letters = [];

  if (selectableImagesConfig.countType == 'dynamic') {
    imageParamValue = imageParams[selectableImagesConfig.imageParam];

    if (isNaN(imageParamValue)) {
      letters =  imageParamValue.split('');
      selectableImagesCount = letters.length;
    } else {
      selectableImagesCount = imageParamValue;
    }
  }
  
  divs.forEach(function(div,index) {
      if (index < selectableImagesCount) {
        div.classList.add('active');
        if (selectableImagesConfig.infoCornerContent == 'letter') {
          div.querySelector('.image_container--info-corner').textContent = letters[index].toUpperCase();
        }
        if (selectableImagesConfig.infoCornerContent == 'index') {
          div.querySelector('.image_container--info-corner').textContent = index + 1;
        }
      } else {
        div.classList.remove('active');
        div.querySelector('.image_container--info-corner').textContent = '';
      }
      div.dataset.imgPos = index;
  });
}

function displayUploadedImageThumbs() {

  var display = function(imageList) {
    
    var uploadedImagesContainer = document.getElementById('uploaded_thumbs');
    
    if (!uploadedImagesContainer) return;

    // clone node to get rid of all previously events set by "Sortable.js"
    uploadedImagesContainer.parentNode.replaceChild(uploadedImagesContainer.cloneNode(true),uploadedImagesContainer);

    // re-init container
    uploadedImagesContainer = document.getElementById('uploaded_thumbs');

    // emty container
    uploadedImagesContainer.textContent = '';

    imageList.forEach(function(image,i) {
      const tpl = document.getElementById('uploaded_thumb_tpl')
                    .querySelector('.uploaded_thumb')
                    .cloneNode(true);

      if (!image) {
        tpl.dataset.fileid = '';
        uploadedImagesContainer.appendChild(tpl);
        return;
      }

      if (!customizationData.selectableImagesConfig.isSortable) {
        if (imageParams.customBackground && imageParams.customBackground == image) {
          tpl.classList.add('active');
        } else if (imageParams.customBackground != image) {
          tpl.classList.remove('active');
        }
      }

      tpl.dataset.fileid = image;
      tpl.dataset.imgPos = i;

      const imgEl = tpl.querySelector('.image_container img');
      //const baseUrl = 'https://' + server + '/utils/thumb.php'
      const baseUrl = 'https://' + server + '/uploads/getImage.php'
        + '?uid=' + getUid()
        + '&type=thumb'
        + '&file=' + encodeURIComponent(image)
        + '&productDir=' + encodeURIComponent(getProductDir())
        + '&cartItemKey=' + encodeURIComponent(getCurrentCartItemKey());

      // kleiner Helfer zum Cache busten
      const withBuster = () => baseUrl + '&r=' + Date.now();

      // Optional: zuerst einen Platzhalter setzen (verhindert "broken image")
      imgEl.src = 'https://' + server + '/products-v2/_resc/debugPixel.png';
      imgEl.classList.add('hidden');

      // Retry-Logik nur wenn 202/404 auftreten (img error)
      let retries = 20; // ~20 Sekunden
      let timer = null;

      function tryLoad() {
        imgEl.src = withBuster(); // neuer Versuch
      }

      imgEl.addEventListener('error', () => {
        if (retries-- > 0) {
          // nur neu versuchen wenn die Kachel sichtbar ist (spart Traffic)
          if ('IntersectionObserver' in window) {
            const io = new IntersectionObserver((entries) => {
              if (entries[0].isIntersecting) {
                io.disconnect();
                timer = setTimeout(tryLoad, 1000);
              }
            }, {rootMargin: '200px'});
            io.observe(imgEl);
          } else {
            timer = setTimeout(tryLoad, 1000);
          }
        } else {
          imgEl.src = 'https://' + server + '/products-v2/_resc/debugPixel.png';
        }
      });

      // wenn’s klappt: aufräumen
      imgEl.addEventListener('load', () => {
        imgEl.classList.remove('hidden');
        if (timer) clearTimeout(timer);
      });

      // erster echter Versuch
      tryLoad();

      uploadedImagesContainer.appendChild(tpl);
    });

    /*
    imageList.forEach(function(image,i) {

      var tpl = document.getElementById('uploaded_thumb_tpl').querySelector('.uploaded_thumb').cloneNode(true);

      if (image) {
        if (!customizationData.selectableImagesConfig.isSortable) {
          if (imageParams.customBackground && imageParams.customBackground == image) {
            tpl.classList.add('active');
          } else if (imageParams.customBackground != image) {
            tpl.classList.remove('active');
          }
        }
      	tpl.dataset.fileid = image;
        tpl.dataset.imgPos = i;

        tpl.querySelector('.image_container').querySelector('img').src = 'https://'+server+'/utils/thumb.php?uid='+getUid()+'&type=thumb&file='+image+'&productDir='+getProductDir()+'&cartItemKey='+getCurrentCartItemKey()+'&r='+Date.now();

      } else if (!image) {
        tpl.dataset.fileid = '';
      }
	    uploadedImagesContainer.appendChild(tpl);
    });
    */

    // thumbs are sortable, e.g. lettermask
    if (imageList.length && customizationData.selectableImagesConfig.isSortable) {
      imageParams.imageOrder = imageList.join('|');
      uploadedImagesContainer.classList.add('is-sortable');
      document.getElementById('uploaded_thumbs_container').classList.add('is-sortable');
      new Sortable(uploadedImagesContainer, {
        swap: customizationData.selectableImagesConfig.sortableSwap || false,
        filter: '.image_controlls',
        preventOnFilter: false,
        delay: 40,
        delayOnTouchOnly: true,
        onStart: function (evt) {},
        onEnd: function (evt) {
          if (evt.newIndex == evt.oldIndex) return; // if position elemten is still the same after dragging -> do nothing
          highlightActiveThumbs();
          var files = [];
          evt.from.querySelectorAll('.uploaded_thumb').forEach(function(elem,i) {
            files.push(elem.dataset.fileid);
          });
          imageParams.imageOrder = files.join('|');
          fetchPreviewImage();
        }
      });

      highlightActiveThumbs();

    // thumbs are NOT sortable
    } else {

      $(uploadedImagesContainer).on('click', '.uploaded_thumb', function(event) {

        // don't activate thumb if delete was clicked
        if ($(event.target).parent('.image_delete').length || $(event.target).is('.image_delete')) return;

        var $currentTarget = $(event.currentTarget);

        if ($currentTarget.is('.active')) return;

		    imageParams.customBackground = $currentTarget.data('fileid');

        $('.uploaded_thumb').removeClass('active');

        $currentTarget.addClass('active');

        fetchPreviewImage();
      });
    }
  }

  // in some occasions uid might be empty -> fill it
  imageParams.uid = getUid();

  $.ajax({
    url: 'https://'+server+'/uploads/getUploadedImagesList.php',
    dataType: 'json',
    cache: false,
    data: {
      uid: getUid(),
      imageOrder: imageParams.imageOrder,
      cartItemKey: getCurrentCartItemKey(),
      aiStyle: imageParams.aiStyle ? imageParams.aiStyle : ''
    },
    type: 'post',
    crossDomain: true,
    complete: function(data) {},
    success: function(response) {
      var imageList = response.imageList;
      display(imageList);
      if (imageList.length) {
        $('#uploaded_thumbs_container').addClass('visible');
      } else {
        $('#uploaded_thumbs_container').removeClass('visible');
      }
    },
    error: function(xhr, ajaxOptions, thrownError) {
      console.log(thrownError);
    }
  });
}

function updateImageOrder(pos,newValue) {
  var order = imageParams.imageOrder.split('|');
  order[pos] = newValue;          
  imageParams.imageOrder = order.join('|');
}

/**
 * Uploaded images are stored in corresponding directories
 * e.g. /thumbs/picturetree
 * e.g. /thumbs/lettermask-papa
 */
function getProductDir() {
  var productDir = imageParams.productType; 
  return imageParams[customizationData.imageParamAsKey] ? productDir + '-' + imageParams[customizationData.imageParamAsKey] : productDir;
}

/**
 * Cropper aspect ratio needs to be adjusted, based on
 * - productType
 * - an imageParam e.g. style or background
 * - image position (each image has it's own ratio), @see picturetree
 */
function getCroppingAspectRatio(imgPos) {
  // based on productType, also setting default
  var croppingAspectRatio = customizationData.croppingAspectRatio ? customizationData.croppingAspectRatio : 3/2;

  // based on image position (1,2,3,...)
  if (customizationData.croppingAspectRatioPerImage) {
    croppingAspectRatio = customizationData.croppingAspectRatioPerImage[imgPos];
  }

  var aspectRatioKey      = customizationData.aspectRatioKey || '', // e.g. angle
      aspectRatioVal      = imageParams[aspectRatioKey] || '',      // e.g. family
      //croppingAspectRatio = customizationData.croppingAspectRatios[aspectRatioVal] || croppingAspectRatio;
      croppingAspectRatio = customizationData?.croppingAspectRatios?.[aspectRatioVal] ?? croppingAspectRatio;

  //console.log('croppingAspectRatio', croppingAspectRatio);

  return croppingAspectRatio;
}


function getConvertAspectRatio() {

  var convertAspectRatio  = customizationData.convertAspectRatio ? customizationData.convertAspectRatio : '',
      aspectRatioKey      = customizationData.aspectRatioKey || '',// e.g. angle
      aspectRatioVal      = imageParams[aspectRatioKey] || '';     // e.g. family

  // different ratio per angle?
  convertAspectRatio = customizationData.convertAspectRatios?.[aspectRatioVal] || convertAspectRatio;

  if (!convertAspectRatio) {
    convertAspectRatio = imageParams.orientation == 'v' ? '2:3' : '3:2';
  }

  if (imageParams.forceConvertAspectRatio) {
    convertAspectRatio = imageParams.forceConvertAspectRatio;
  }
  
  console.log('convertAspectRatio', convertAspectRatio);

  return convertAspectRatio;
}


/**
 * If user pinch zoomed and then opens modal, close btns might be out of viewport
 * Since the cropper area captures the pinch gesture there is no way to make the close/submit btn re-appear
 * therefore we zoom out, and restore zoom settings "on modal closed"
 */
function setViewportMetaZoom(action) {
  var viewportmeta = document.querySelector('meta[name="viewport"]');
  action = action || '';
  if (action == 'reset') {
    viewportmeta.setAttribute('content', "initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0");
  }
  if (action == 'restore') {
    viewportmeta.setAttribute('content',"initial-scale=1.0,minimum-scale=1.0");
  }
}

function checkServerImageFileSize(imagesToCheck) {
    const url = 'https://' + server + '/uploads/getImageFileSize.php';

    // GET-Parameter serialisieren → imagesToCheck[]=a&imagesToCheck[]=b
    const params = new URLSearchParams();
    params.append('uid',getUid());
    imagesToCheck.forEach(img => params.append('imagesToCheck[]', img));

    return fetch(url + '?' + params.toString(), {
        method: 'GET'
    })
    .then(response => {
        if (!response.ok) {
            throw new Error("Server returned " + response.status);
        }
        return response.json(); // JSON auslesen
    });
}

function setFailedImages(newFailedImages) {
  if (!Array.isArray(newFailedImages) || newFailedImages.length === 0) return;

  var cookieName  = 'sp_failed_images';
  var currentList = spLocalStorageGet(cookieName, 'json') || [];

  // sicherstellen, dass currentList ein Array ist
  if (!Array.isArray(currentList)) {
    currentList = [];
  }

  var merged = [...new Set([...currentList, ...newFailedImages])];

  spLocalStorageSet(cookieName, merged, 'json');
}


function initFileUpload() {

  if (!isPageType('products')) {
    return;
  }

  if (!customizationData.hasCustomImages && !isCustomImageProductPage()) {
    return;
  }

  trackCustomEvent('hasImageUploadForm',imageParams.productType);  

  document.querySelector('#upload_form').classList.remove('hidden');

  const infoBox = document.querySelector('.upload_box--external-browser-info');
  const msgSpan = infoBox.querySelector('.upload_box--external-browser-info-msg');
  const link = infoBox.querySelector('.open-external');
  const ua = navigator.userAgent || '';
  const isFB = /FBAN|FBAV/i.test(ua), isIG = /Instagram/i.test(ua);
  const isInApp = isFB || isIG;
  const isIOS = /iPad|iPhone|iPod/i.test(ua);
  let msg = 'Sollten Facebook oder Instagram';

  if (isFB) {
    msg = 'Sollte Facebook';
  } else if (isIG) {
    msg = 'Sollte Instagram';
  }
  msg += ' den Upload blockieren, <a href="" class="open-external" target="_blank">klicke hier</a> oder oben rechts auf die drei Punkte und wähle "In externem Browser öffnen".';
  msgSpan.innerHTML = msg;

  let transportUidParam = location.search ? '&' : '?';
  transportUidParam += 'transportUid='+getUid() 

  const dest = 'https://'+server+'.smileposter.de/?return=' + encodeURIComponent(location.href.split('#')[0]+transportUidParam);

  // 1) „Fetter“ Intent mit mehr Metadaten (klappt auf vielen Pixel/Samsung)
  const intentFat =
    "intent://" + dest.replace(/^https?:\/\//,'') +
    "#Intent;scheme=https;action=android.intent.action.VIEW;" +
    "category=android.intent.category.BROWSABLE;" +
    "package=com.android.chrome;" +
    "component=com.android.chrome/com.google.android.apps.chrome.IntentDispatcher;" +
    "S.com.android.browser.application_id=com.android.chrome;" +
    "S.browser_fallback_url=" + encodeURIComponent(dest) + ";end;";

  // 2) Ältere Chrome-Syntax (manche Geräte akzeptieren die eher)
  const chromeLegacy = "googlechrome://navigate?url=" + encodeURIComponent(dest);

  // 3) Plain HTTPS (falls alles blockiert, bleibt der Nutzer wenigstens nicht “ohne Action”)
  const httpsPlain = dest;

  function tryOpen(url){
    // Muss aus einem User-Gesture heraus aufgerufen werden
    const w = window.open(url, "_blank", "noopener");
    // Manche WebViews geben null zurück -> Fallback
    setTimeout(() => {
      // wenn nichts passierte, harter Redirect (manche WebViews öffnen dann extern)
      if (!w) location.href = url;
    }, 400);
  }

  infoBox.addEventListener("click", function(){
    //alert('Du wirst jetzt weitergeleitet');
    tryOpen(intentFat);
    setTimeout(() => tryOpen(chromeLegacy), 800);
    setTimeout(() => tryOpen(httpsPlain), 1600);
  });

  if (isInApp && !isIOS) {
    $('.upload_box__input').on('click', function() {
      infoBox.classList.remove('hidden');
    });
  }

  if (customizationData.selectableImagesConfig.count > 1 || customizationData.selectableImagesConfig.countType == 'dynamic') {
    document.querySelector('.uploaded_thumbs_info.hidden').classList.remove('hidden');
    document.querySelector('.upload_box_container_headline--multi-image').classList.remove('hidden');
    if (customizationData.selectableImagesConfig.count > 1) {
      $('.sp_image_upload_min-amount').html(customizationData.selectableImagesConfig.count);
    }
  } else {
    document.querySelector('.upload_box_container_headline--single-image').classList.remove('hidden');
  }
  
  //console.log('::::::::: displayUploadedImageThumbs')
  displayUploadedImageThumbs();
  
  // feature detection for drag&drop upload
  var isAdvancedUpload = function() {
    var div = document.createElement( 'div' );
    return ( ( 'draggable' in div ) || ( 'ondragstart' in div && 'ondrop' in div ) ) && 'FormData' in window && 'FileReader' in window;
  }();

  // we want to avoide accidently deleting images when (swipe)scrolling
  var scrollTriggered = false;
  window.onscroll = function (e) { scrollTriggered = true; } 
  $('#uploaded_thumbs_container').on('touchstart mousedown', function(event) { scrollTriggered = false; });


  var uploadBoxContainer = document.querySelector('.upload_box_container'),
      uploadForm = uploadBoxContainer.querySelector('form.upload_box'),
      fileInput = uploadBoxContainer.querySelector('#fileInput'),
      dropArea = uploadBoxContainer.querySelector('.drop-area'),
      uid = getUid(),
      droppedFiles = false,
      imageList = [],
      uploadCountSuccess = 0,
      imageSizeTotal = 0;
      triggerFormSubmit = function(files) {
        files = files || [];
        imageList = [];       
        for(var i=0; i<files.length; i++) {
          imageList[i] = files[i];
        }
        var event = new Event('submit',{
          cancelable: true
        });         
        uploadForm.dispatchEvent(event);
      },
      finalizeUpload = function(data,status) {
        uploadBoxContainer.classList.remove('is-uploading');
        uploadForm.reset();
        $('.uploaded_thumb').removeClass('active');
        //console.log(data.latestUpload);
        imageParams.customBackground = data.latestUpload;
        imageParams.forceCacheRefresh = Date.now();
        fetchPreviewImage();
        displayUploadedImageThumbs();
        imageList = [];
        uploadCountSuccess = 0;
        imageSizeTotal = 0;
        uploadForm.reset();
        UploadUI.reset();
        if (status == 'error') {
          uploadBoxContainer.classList.add('process-error');
          //UploadUI.error();
        }

        var imagesToCheck = [];
        imagesToCheck.push(imageParams.customBackground);

        checkServerImageFileSize(imagesToCheck)
          .then(function(response) {
            //console.log('FAILED OR NOT?')
            //console.log(response);
            if (response && Array.isArray(response.failedImages)) {
              setFailedImages(response.failedImages);
            }
          })
          .catch(function(err) {
            console.error("Image check failed:", err);
          });
      };

  var delayedUpscaling = true;

  async function aiConvert(data) {
    try {
      const payload = {
        aiStyle: imageParams.aiStyle,
        aspectRatio: getConvertAspectRatio(),
        uid: getUid(),
        imageFileName: data.latestUpload,
        uploadedImage: data.uploadedImage,
        productDir: getProductDir(),
        cartItemKey: getCurrentCartItemKey(),
        paths: data.paths,
        basePath: data.basePath,
        targetPath: data.targetPath,
        delayedUpscaling: delayedUpscaling,
        //dev: isPreview ? '1' : '',
        //engine: '',
        //modelId: 'g25',
        modelId: 'g35',
      };

      if (isPreview) console.log(payload);

      UploadUI.setStep('progressing');
      UploadUI.startAutoBar();

      const fd = new FormData();
      fd.append('payload', JSON.stringify(payload));

      const res = await fetch('https://'+server+'/uploads/process/enqueue.php', {
        method: 'POST',
        body: fd,
      });

      if (!res.ok) throw new Error(`enqueue failed: ${res.status}`);
      const {ok, job_id, error} = await res.json();
      if (!ok) throw new Error(error || 'enqueue error');

      // optional: Polling bis ready
      await pollJob(job_id);

      finalizeUpload(data,'success');

    } catch (e) {
      console.error('Process enqueue/poll error:', e);
      finalizeUpload(data,'error');
    }
  }

  async function pollJob(id, timeoutMs=180000, intervalMs=2000){
    const start = Date.now();
    while (Date.now() - start < timeoutMs){
      const r = await fetch('https://'+server+'/uploads/process/status.php?id='+encodeURIComponent(id));
      const j = await r.json();
      console.log('working');
      //console.log('status',j); // ← queued/working/done/failed
      imageParams.imageProcessStatus = j.status;
      if (j.status === 'done') return true;
      if (j.status === 'failed') return true; // worker might send "failed" though image has been processed fine
      //if (j.status === 'failed') throw new Error('AI job failed');
      await new Promise(rs => setTimeout(rs, intervalMs));
    }
    throw new Error('AI job timeout');
  }


  // drag&drop files if the feature is available
  if (isAdvancedUpload) {

    // letting the CSS part to know drag&drop is supported by the browser
    uploadForm.classList.add('has-advanced-upload');

    ['drag','dragstart','dragend','dragover','dragenter','dragleave','drop'].forEach( function( event ) {
      uploadForm.addEventListener(event, function(e) {
        // preventing the unwanted behaviours
        e.preventDefault();
        e.stopPropagation();
      });
    });

    ['dragover','dragenter'].forEach(function(event) {
      uploadForm.addEventListener(event, function() {
        uploadForm.classList.add('is-dragover');
      });		
    });

    ['dragleave','dragend','drop'].forEach(function(event){
      uploadForm.addEventListener(event, function() {
        uploadForm.classList.remove('is-dragover');
      });
    });
  }

  // here we only handle "crop after upload" image (e.g. familytree)
  if (fileInput) {

    if (isAdvancedUpload) {
      dropArea.addEventListener('drop', function(e) {
        triggerFormSubmit(e.dataTransfer.files);
      });
    }

    // automatically submit the form on file select
    fileInput.addEventListener('change', function(e) {
      triggerFormSubmit(fileInput.files);
    });

    // Firefox focus bug fix for file input
    fileInput.addEventListener('focus', function(){ fileInput.classList.add('has-focus'); });
    fileInput.addEventListener('blur', function(){ fileInput.classList.remove('has-focus'); });
  }

  const handleUploadProgress = function(image,index) {
      var valid = true;
      //console.log(image);

      // check if (cropped) image has already been added @see sp_cropper.js
      // looks like blob (crop) size is larger than the size of the original image
      if (!image.alreadyAppended) {
        valid = validateFile(image);
        uploadFormData.append('image',image);
      }

      imageSizeTotal += image.size;

      uploadFormData.append('uid',uid);
      uploadFormData.append('productDir',getProductDir());
      uploadFormData.append('cartItemKey',getCurrentCartItemKey());
      if (imageParams.aiStyle) {
        uploadFormData.append('aiStyle',imageParams.aiStyle);
      }
      if (imageParams.nn) {
        uploadFormData.append('nn',imageParams.n);
      }     
      uploadFormData.append('aiConvertVersion',imageParams.aiConvertVersion || 'stable');

      if (!valid) {
        uploadBoxContainer.classList.remove('is-uploading');
        return;
      }

      spLocalStorageSet('sp_uid',uid);

      var ajax = new XMLHttpRequest();

      ajax.upload.addEventListener('progress', function(event) {

        if (!event.lengthComputable) return;

        // save loaded data amount for every initiated upload
        imageList[index].loaded = event.loaded;

        var imageSizeLoaded = 0;

        // sum amount of already loaded data
        imageList.forEach(function(image,index) {
          imageSizeLoaded += image.loaded;
        });

        if (isNaN(imageSizeLoaded)) return;

        var percentComplete = Math.floor((imageSizeLoaded / imageSizeTotal) * 100);

        // catch possible error
        if (percentComplete > 100) {
          console.log('percentComplete > 100!!!');
          percentComplete = 100;
        }
        //console.log(imageSizeLoaded,imageSizeTotal,percentComplete);
        UploadUI.updateProgressBar(percentComplete);

      }, false);

      ajax.addEventListener("readystatechange", function(event) {
        if (ajax.readyState === XMLHttpRequest.DONE) {
          const status = ajax.status;
          if ((status === 0 || (status >= 200 && status < 400)) && ajax.responseText) {
            var response = JSON.parse(ajax.responseText);
            //console.log(response);
            imageParams.uid = uid;
            uploadCountSuccess++;
            if (uploadCountSuccess == imageList.length) {
              UploadUI.updateProgressBar(0);
              if (imageParams.aiStyle) {
                aiConvert(response);
              } else {
                // mark all thumbs as not active
                $('.uploaded_thumb').removeClass('active');
                // set background to last uploaded image
                imageParams.customBackground = response.latestUpload;
                // recreate thumbs list (and highlight last uploaded image)
                displayUploadedImageThumbs();
                // show last uploaded image
                fetchPreviewImage();
                // reset values
                imageList = [];
                uploadCountSuccess = 0;
                imageSizeTotal = 0;
                uploadBoxContainer.classList.remove('is-uploading');
                uploadForm.reset();
              }
              trackCustomEvent('imageUploadEnd',imageParams.productType);
            }
            
          } else {
            // Oh no! There has been an error with the request!
            trackCustomEvent('imageUploadError',imageParams.productType);
          }
        }
      });

      ajax.addEventListener('error', function() { console.log('Image upload: error') }, false);
      ajax.addEventListener('abort', function() { console.log('Image upload: abort') }, false);       
      ajax.open('POST', 'https://'+server+'/uploads/index.php');
      ajax.send(uploadFormData);

      // clear previous formdata
      uploadFormData = new FormData();
  }

  // if the form was submitted
  uploadForm.addEventListener('submit', function(e) {
    e.preventDefault();

    // preventing the duplicate submissions if the current one is in progress
    if (uploadBoxContainer.classList.contains('is-uploading')) return false;

    UploadUI.start();

    trackCustomEvent('imageUploadStart',imageParams.productType);

    uploadBoxContainer.classList.add('is-uploading');
    uploadBoxContainer.classList.remove('process-error');
    uploadForm.classList.remove('is-error');

    uploadFormData = uploadFormData || new FormData();

    // image might have already been appended in sp_cropper.js
    var appendedImage = uploadFormData.get('image') || '';

    if (appendedImage) {
      imageList = [appendedImage];
      imageList[0].alreadyAppended  = true;
    }

    imageList.forEach(function(image,index) {
      handleUploadProgress(image,index);
    });

    return false;      
    // SUBMIT END
  });

  // ===============================================================
  // Cropper (v1)
  // ===============================================================
  var myCropper = null,
      allCroppingDetails = {},
      currentImageFile = '',
      currentlyDeleting = '',
      cropperImage = $('#cropper-image')[0],
      cropperModal = document.getElementById('PopupModal__cropper'),
      cropperSpinner = cropperModal.getElementsByClassName('cropper-spinner');
  
  $('#image_crop').on('click touchend', function() {
    $.ajax({
      url: 'https://'+server+'/uploads/cropImage.php',
      dataType: 'json',
      cache: false,
      data: allCroppingDetails[currentImageFile],
      type: 'post',
      crossDomain: true,
      complete: function(data) {},
      success: function(response) {

        document.getElementById('PopupModal__cropper').hide();

        imageParams.forceCacheRefresh = new Date().getTime();

        fetchPreviewImage();

        displayUploadedImageThumbs();

        if (myCropper) myCropper.destroy();
        cropperImage.src = '';
        trackCustomEvent('imageCropped',imageParams.productType);
      },
      error: function(xhr, ajaxOptions, thrownError) {
        console.log(thrownError);
      }
    });
  });
 
  $('#uploaded_thumbs_container').on('click touchend', '.image_edit', function(event) {

    if (scrollTriggered) return;

    // reset and temporarily disable pinch zoom
    setViewportMetaZoom('reset');

    var imgData = this.closest('.uploaded_thumb').dataset || {};
    
    currentImageFile = imgData.fileid;

    cropperSpinner[0].classList.toggle('show');

    // fix for when modal auto-closes after opening
    cropperModal.style.pointerEvents = 'none';
    
    cropperModal.show();

    var croppingDetails = allCroppingDetails[currentImageFile] || {};

    cropperImage.onload = function(e) {
      if (myCropper) myCropper.destroy();
      myCropper = new Cropper(cropperImage, {
        aspectRatio: getCroppingAspectRatio(imgData.imgPos),
        autoCropArea: 1, // 100%
        viewMode: 2,
        data: croppingDetails, // set initial crop box
        crop(event) {
          croppingDetails = event.detail;
          //console.log(croppingDetails);
          croppingDetails.previewImageWidth = cropperImage.width;
          croppingDetails.uid = getUid();
          croppingDetails.fileid = currentImageFile;
          croppingDetails.productDir = getProductDir();
          croppingDetails.cartItemKey = getCurrentCartItemKey();
          allCroppingDetails[currentImageFile] = croppingDetails;
        },
        ready() {
          cropperSpinner[0].classList.remove('show');
          cropperModal.style.pointerEvents = '';
        }
      });
    }
    
    cropperImage.crossOrigin = 'anonymous'; // prevent cors issues
    cropperImage.src = 'https://'+server+'/uploads/files/'+getUid()+'/nonCroppedPreview/'+currentImageFile+'?r='+Date.now();//?not-from-cache-please';
  });

  $('#uploaded_thumbs_container').on(is_touch_enabled() ? 'touchend' : 'click', '.uploaded_thumb .image_delete', function(event) {

    if (scrollTriggered) return;

    var $thumbElem = $(this).parents('.uploaded_thumb'),
        fileid = $thumbElem.data('fileid'),
        isActiveElem = $thumbElem.is('.active');
    
    // relevant for lettermask, not relevant for custom backgrounds
    if (imageParams.imageOrder) {

      var imageOrder = imageParams.imageOrder.split('|'),
          newImageOrder = [];

      // remove deleted image from imageParams.imageOrder
      imageOrder.forEach(function(image,i) {
        if (image == fileid) return;
        newImageOrder.push(image);
      });

      imageParams.imageOrder = newImageOrder.join('|');
    }

    if (isActiveElem) {
      // activate the element next to the deleted one
      $thumbElem.next().addClass('active');
      imageParams.customBackground = $thumbElem.next().data('fileid') || '';
      fetchPreviewImage();
    }

    // remove thumb from dom
    $thumbElem.remove();

    // delete from server in the background
    $.ajax({
      url: "https://"+server+"/uploads/deleteFile.php",
      dataType: 'json',
      cache: false,
      data: {
        uid: getUid(),
        fileid: fileid,
        productDir: getProductDir(),
        cartItemKey: getCurrentCartItemKey()
      },
      type: 'post',
      crossDomain: true,
      complete: function(data) {
        //currentlyDeleting = '';
      },
      success: function(response) {
        console.log(response);
      },
      error: function(xhr, ajaxOptions, thrownError) {
        console.log(thrownError);
      }
    });
  });

  document.querySelector("body").addEventListener('modalClosed', function(e) {
    setViewportMetaZoom('restore');
  },false);
}

function handleBottomATC() {

  if (!isPageType('products') || !is_touch_enabled() || window.innerWidth >= 990) return;

  var $body = $('body'),
      $atcBtn = $('button.product-form__submit'),
      $atcBtnClone = $atcBtn.clone(),
      cartBtnCloneOnClick = function(event) {
        event.preventDefault();
        document.querySelector('cart-drawer').open();
      },
      updateCartBtnClone = function() {
        var $cartBtnClone = $('#cart-icon-bubble').clone();
        $cartBtnClone.addClass('cart_btn_clone');
        $cartBtnClone.on('click',cartBtnCloneOnClick);
        $('#sp_cart-btn-container').html($cartBtnClone);
        if ($cartBtnClone.find('.cart-count-bubble').length) {
          $cartBtnClone.removeClass('hidden');
        } else {
          $cartBtnClone.addClass('hidden');
        }
      };

  updateCartBtnClone();

  // observe cartBtnClone aka cart bubble
  const observer = new MutationObserver(updateCartBtnClone).observe(document.getElementById("cart-icon-bubble"),{ attributes: true, childList: true, subtree: true });

  // add atc button
  $atcBtnClone.addClass('atc_btn_clone');
  $('#sp_sticky_atc_container').append($atcBtnClone);
}

function offerHint() {

  if ($('.halloween-offer').length) return;
  
  var container = document.getElementById('offer-hint'),
      outputElem = document.getElementById('offer-hint-output');

  if (!container) return;
  
  var cookieName = 'sp_visits',
      data = spLocalStorageGet(cookieName,'json') || {},
      today = new Date().toISOString().split('T')[0];

  data.firstVisit = data.firstVisit || today;
  data.lastVisit = today;
  data.productViews = data.productViews || 0;
  data.productViews++;

  spLocalStorageSet(cookieName,data,'json');

  // only display hint on first day
  if (data.firstVisit != data.lastVisit) return;

  var datum = new Date(),
      weekday = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag","Samstag"][datum.getDay()],
      output = 'Das Angebot endet ' + weekday + ', den ' + datum.getDate() + '.' + (datum.getMonth()+1) + '.' + datum.getFullYear();
  outputElem.textContent = output;
  container.style.display = 'block';
}

function copyDiscountCode(codeId) {
  var codes = {
    'm10': 'MINUS10'
  };
  const copyToClipboard = discount => {
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      $('.sp_copy-discount-code--icon.'+codeId).html('✔');
      return navigator.clipboard.writeText(discount);
    }
    return Promise.reject('The Clipboard API is not available.');
  };
  copyToClipboard(codes[codeId] || codeId);
  if ($('cart-drawer').length) {
    $('cart-drawer')[0].open();
  }
}

function captureSentryMsg(type,msg) {
  if (typeof Sentry === 'undefined') return;
  Sentry.configureScope(function (scope) {
    scope.setTag('CUSTOM_MSG_' + type, msg);
  });
  Sentry.captureMessage(type);
}

function clarityTrack(key,value) {
  if (typeof clarity !== 'function') return;
  key = key || '';
  if (!key) return;
  clarity('set', key, value);
}

function trackCustomEvent(key,value) {
  key = key || '';
  value = value || '';
  splog(key,value);
  clarityTrack(key,value);
  //captureSentryMsg(key,value);
}

function initCustomEventTracking() {
  if (typeof clarity !== 'function') return;

  document.querySelectorAll('[data-type="floatingFrame"]').forEach(function(elem) {
    elem.addEventListener('click', function(){ trackCustomEvent('floatingFrameSwatchClicked'); });    
  });

  document.addEventListener('removeItem', function(data) {
    trackCustomEvent('cartRemoveItem',data.detail.ariaLabel);
  });

  document.querySelectorAll('button[name="add"]').forEach(function(elem) {
    elem.addEventListener('click', function(){
      var value = elem.classList.contains('atc_btn_clone') ? 'sticyAtcBtn' : 'originalAtcBtn';
      if (document.querySelector('product-form').dataset.editLineItem) value += '-edit';
      trackCustomEvent('atcBtnClick', value);
    });
  });
}

function initTibProduct() {

  console.log('TEEINBLUE_LOADED',TEEINBLUE_LOADED);

  $tibForm = $('#tee-artwork-form');

  $('[id^=MediaGallery]').removeClass('initializing');
  //$('[id^=price-template]').hide();
  //$('#variant-picker-container').remove();
  //offer-hint

  var interv = setInterval(function() {
    //console.log('tee-artwork-form 2', $('#tee-artwork-form').length);
    //console.log('.tee-product-price 2', $('#tee-artwork-form').find('.tee-product-price').length);

    if ($('#tee-artwork-form').length) {
      $('#tee-artwork-form').find('.tee-product-price').after($('#price--caption'));  
      clearInterval(interv);
    }
  },100);

  $('#teeAtcButton').on('click', function(event) {
    event.preventDefault();
    console.log('yxvdfyxfbvfxv');
  });
  
   Shopify.onItemAdded = function(line_item) {
     console.log(line_item);
    /*
    Shopify.getCart();
    refresh #menu script here
    refresh cart.item.count script  in theme.liquid could be something like this, but it doesn't work: 
    $('#cart-total-items').update(cart.item_count);
    */
    //alert('ATC');
  };
}

// Auto-apply coupon code on add to cart
function applyCouponOnATC() {
  /*
  var code = 'SUMMER20',
      codeApplied = false; 
  $('button[name="add"]').each(function(index,elem) {
    $(elem).on('mousedown touchstart',function(event) {
      console.log('codeApplied:',codeApplied);
      if (codeApplied) return;
      codeApplied = true;
      console.log('ATC BTN CLICKED - APPLY COUPON');
      fetch('/discount/'+code);
    });
  });
  */

  /*
  if (new Date().toJSON().slice(0,10) == '2023-11-24') {
    fetch('/discount/BLACK15');
  }
  */
}

/*
function estimateDeliveryDate() {

  if (!document.getElementsByClassName('product customizer').length) {
    return;
  }
  
  var now = new Date(),
      deliveryDateMin = '',
      deliveryDateMax = '',
      durations = [
        [3,5], // so
        [2,4], // mo
        [2,4], // di
        [2,5], // mi
        [2,5], // do
        [4,6], // fr
        [4,6], // sa
      ];

  deliveryDateMin = new Date(now.getTime() + (durations[now.getDay()][0] *24*60*60*1000));
  deliveryDateMax = new Date(now.getTime() + (durations[now.getDay()][1] *24*60*60*1000));
  var options = { weekday: 'short', month: '2-digit', day: 'numeric' },
      dateMinFormatted = deliveryDateMin.toLocaleDateString('de-DE', options),
      dateMaxFormatted = deliveryDateMax.toLocaleDateString('de-DE', options),     
      node = document.querySelector('#deliveryDate'),
      nodeMin = node.querySelector('.date_min'),
      nodeMax = node.querySelector('.date_max');

  if (!nodeMin || !nodeMax) {
    return;
  }

  nodeMin.innerHTML = dateMinFormatted;
  nodeMax.innerHTML = dateMaxFormatted;
}
*/

function initTrustBox() {
  if (!isPageType('product')) return;

  var showTpReviews = true;

  var excludeByTag = [
    'polaroids',
    'familyhearts',
    'pier_1',
    'bw',
    'mountainpath_1',
    'treeheart_1',
    'mountainpath_2',
    'simplebg-goldhearts2',
    'chaos',
    'familyboots',
    'simplebg-married1',
    'simplebg-married2',
    'familyhearts2',
    'wordmask',
    'simplebg-bike-signs',
    'simplebg-rose1',
    'simplebg-rose2',
    'mothersday1',
    'mothersday2',
    'mothersday3',
    'simplebg-watercolor-daisies',
    'picturetree-mama',
    'simplebg-youme-roses',
    'wordcollage-mama',
    'wordcollage-papa',
    'watercolor',
    'familytree_upload'
  ];

  excludeByTag.forEach(function(tag) {
    if (customizationData.tags.includes(tag)) {
      showTpReviews = false;
    }
  });
  
  //console.log('customizationData.tags',customizationData.tags);

  if (showTpReviews) {
    $('#sp_trustBox-wrapper--product').removeClass('hidden');
    $('.sp_feedback-slider').addClass('hidden');
  } else {
    //$('.sp_feedback-slider').removeClass('hidden');
  }
  
  $('.sp_trustBox-wrapper--toggle-btn').on('click',function() {
    $('#sp_trustBox-wrapper--product').toggleClass('sp_trustBox--hide-reviews');
  });
}

var getCurrentCartItemKey = function() {
  return $('product-form').data('cart-item-key') || '';
}

/**
 * some params are allowed to exist in the cookie
 * but are not necessary in certain situations
 * e.g. 'background' is not needed on isCustomImageProductPage() but
 * might be needed when customer switches to non-CustomImageProductPage
 */
var getFilterImageParams = function() {

  // create copy of imageParams
  var filteredImageParams = Object.assign({},imageParams);

  /**
   * floating frame not available for 120x80
   * so we filter it from imageParams
   */
  var size = $('#variant-picker-container input:checked').val();
  if (!floatingFrames.variants[size]) {
    delete filteredImageParams.floatingFrame;
  }

  /**
   * regarding product type 'signpost'
   * @see funtion  description
   */
  if (imageParams.productType == 'signpost' || imageParams.productType == 'signpost2') {
    if (isCustomImageProductPage()) {
      delete filteredImageParams.background;
    } else if (customizationData.hasCustomImages) {
      // do nothing
    } else {
      delete filteredImageParams.uid;
      delete filteredImageParams.customBackground;
    }
  }

  /**
   * If user has a loooong list of uploaded images we reduce imageOrder to
   * an allowed size. Otherwise the url gets too long an the prev image is not being loaded
   * This regards e.g. familytree_upload
   */
  if (imageParams.imageOrder) {
    var maxAllowedImages = 20;
    filteredImageParams.imageOrder = imageParams.imageOrder.split('|').slice(0,20).join('|');
  }

  return filteredImageParams;
}

async function setCachedPreviewUrl(renderUrl) {
  var params = renderUrl.split("?")[1] || '';
  const apiUrl = 'https://'+server + '/utils/getImageCacheUrl.php?' + new URLSearchParams(params);
  const res = await fetch(apiUrl);
  const { cacheUrl } = await res.json();
  //console.log(cacheUrl);
  $('[name="properties[_cachedImageUrl]"]').val(cacheUrl);
}

var galleryPrepared = false;

function setGalleryCount(targetCount, root = document) {
  const viewers = root.querySelectorAll('slider-component[id^="GalleryViewer-template-"]');

  viewers.forEach((viewer) => {
    const viewerId = viewer.id; // GalleryViewer-template--123__main
    const baseId = viewerId.replace(/^GalleryViewer-/, ''); // template--123__main

    const galleryList = viewer.querySelector('ul[id^="Slider-Gallery-template-"]');
    if (!galleryList) return;

    const thumbnailsComponent = root.querySelector(`#GalleryThumbnails-${CSS.escape(baseId)}`);
    const thumbnailList = thumbnailsComponent
      ? thumbnailsComponent.querySelector('ul[id^="Slider-Thumbnails-template-"]')
      : null;

    let galleryAll = Array.from(galleryList.children).filter((li) => li.tagName === 'LI');
    let galleryEditable = galleryAll.filter((li) => !li.classList.contains('donot_remove'));
    let galleryProtected = galleryAll.filter((li) => li.classList.contains('donot_remove'));

    if (!galleryEditable.length) return;

    let thumbAll = thumbnailList
      ? Array.from(thumbnailList.children).filter((li) => li.tagName === 'LI')
      : [];
    let thumbEditable = thumbAll.filter((li) => !li.classList.contains('donot_remove'));
    let thumbProtected = thumbAll.filter((li) => li.classList.contains('donot_remove'));

    const galleryTemplate = galleryEditable[galleryEditable.length - 1];
    const thumbTemplate = thumbEditable.length ? thumbEditable[thumbEditable.length - 1] : null;

    while (galleryEditable.length < targetCount) {
      const clone = galleryTemplate.cloneNode(true);
      clone.classList.remove('is-active');
      galleryList.appendChild(clone);
      galleryEditable.push(clone);
    }

    while (thumbnailList && thumbEditable.length < targetCount && thumbTemplate) {
      const clone = thumbTemplate.cloneNode(true);
      clone.removeAttribute('aria-current');
      thumbnailList.appendChild(clone);
      thumbEditable.push(clone);
    }

    if (galleryEditable.length > targetCount) {
      galleryEditable.slice(targetCount).forEach((li) => li.remove());
      galleryEditable = galleryEditable.slice(0, targetCount);
    }

    if (thumbnailList && thumbEditable.length > targetCount) {
      thumbEditable.slice(targetCount).forEach((li) => li.remove());
      thumbEditable = thumbEditable.slice(0, targetCount);
    }

    galleryEditable.forEach((li, i) => {
      const shortId = `${baseId}-${i}`;
      li.id = `Slide-${shortId}`;
      li.setAttribute('data-media-id', shortId);
      li.classList.remove('is-active');
    });

    galleryProtected.forEach((li, idx) => {
      const i = galleryEditable.length + idx;
      const shortId = `${baseId}-${i}`;
      li.id = `Slide-${shortId}`;
      li.setAttribute('data-media-id', shortId);
      li.classList.remove('is-active');
    });

    galleryEditable.forEach((li) => galleryList.appendChild(li));
    galleryProtected.forEach((li) => galleryList.appendChild(li));

    if (thumbnailList) {
      thumbEditable.forEach((li, i) => {
        const shortId = `${baseId}-${i}`;

        li.id = `Slide-Thumbnail-${shortId}`;
        li.setAttribute('data-target', shortId);
        li.setAttribute('data-media-id', shortId);
        li.setAttribute('data-media-position', String(i + 1));

        const button = li.querySelector('button');
        if (button) {
          button.removeAttribute('aria-current');
          button.setAttribute('aria-label', `Bild ${i + 1} in Galerieansicht laden`);
          button.setAttribute('aria-controls', viewerId);
        }
      });

      thumbProtected.forEach((li, idx) => {
        const i = thumbEditable.length + idx;
        const shortId = `${baseId}-${i}`;

        li.id = `Slide-Thumbnail-${shortId}`;
        li.setAttribute('data-target', shortId);
        li.setAttribute('data-media-id', shortId);
        li.setAttribute('data-media-position', String(i + 1));

        const button = li.querySelector('button');
        if (button) {
          button.removeAttribute('aria-current');
          button.setAttribute('aria-label', `Bild ${i + 1} in Galerieansicht laden`);
          button.setAttribute('aria-controls', viewerId);
        }
      });

      thumbEditable.forEach((li) => thumbnailList.appendChild(li));
      thumbProtected.forEach((li) => thumbnailList.appendChild(li));
    }
  });
}

function clearGalleryActiveStates(root = document) {
  root.querySelectorAll('[data-media-id]').forEach((el) => {
    el.classList.remove('is-active');
  });

  root.querySelectorAll('[data-target] button').forEach((btn) => {
    btn.removeAttribute('aria-current');
  });
}

function rebindMediaGalleryThumbs(root = document) {
  root.querySelectorAll('media-gallery').forEach((gallery) => {
    const thumbnails = gallery.querySelector('[id^="GalleryThumbnails-"]');
    if (!thumbnails) return;

    thumbnails.querySelectorAll('[data-target]').forEach((item) => {
      const oldButton = item.querySelector('button');
      if (!oldButton) return;

      const newButton = oldButton.cloneNode(true);
      oldButton.replaceWith(newButton);

      newButton.addEventListener('click', (e) => {
        e.preventDefault();
        gallery.setActiveMedia(item.dataset.target, false);
      });
    });
  });
}

function reinitShopifySliders(root = document) {
  root.querySelectorAll('slider-component').forEach((slider) => {
    slider.slider = slider.querySelector('[id^="Slider-"]');
    slider.sliderItems = slider.querySelectorAll('[id^="Slide-"]');
    slider.prevButton = slider.querySelector('button[name="previous"]');
    slider.nextButton = slider.querySelector('button[name="next"]');

    if (!slider.slider || !slider.nextButton) return;

    if (typeof slider.initPages === 'function') slider.initPages();
    if (typeof slider.update === 'function') slider.update();
  });
}

function activateFirstGalleryItem(root = document) {
  root.querySelectorAll('media-gallery').forEach((gallery) => {
    const firstThumb = gallery.querySelector('[id^="GalleryThumbnails-"] [data-target]');
    if (firstThumb) {
      gallery.setActiveMedia(firstThumb.dataset.target, false);
    }
  });
}

function prepareGallery(root = document) {
  if (galleryPrepared) return;

  switch(imageParams.printProduct) {
    case 'passepartout':
      targetCount = 3;
      break;
    case 'blanket':
      targetCount = 4;
      break;     
    default:
      targetCount = 7;
  }
  setGalleryCount(targetCount, root);
  clearGalleryActiveStates(root);
  activateFirstGalleryItem(root);
  rebindMediaGalleryThumbs(root);
  reinitShopifySliders(root);
  galleryPrepared = true;
}


var fetchPreviewImage = function() {

    prepareGallery();

  	var clearTimer = function(timer) {
      if (timer && timer.interval) clearInterval(timer.interval);
  	};

    var initTimer = function(slide,index,url) {
      var timerId = 'timer_' + index,
          timeout = 2;

      timers[timerId] = timers[timerId] || {};
      clearTimer(timers[timerId]);
      timers[timerId].requests = timers[timerId].requests || 1;
      timers[timerId].time = 0;
      timers[timerId].interval = setInterval(function() {
        if (timers[timerId].time >= timeout) {
          clearTimer(timers[timerId]);
          // if fetching image fails 5x -> abort
          if (timers[timerId].requests > 5) {
            //splog('imgTimeoutErr: ' + timerId, $.param(imageParams));
            trackCustomEvent('imgTimeoutErr',timerId);
            return;
          }
          loadImage(slide,index,url);
          splog('fetchErrorReFetch_'+timerId,timers[timerId].requests);
          trackCustomEvent('fetchErrorReFetch_'+timerId,timers[timerId].requests);
          timers[timerId].requests++;
        }
        timers[timerId].time++;
      },1000);
    };

	var filteredImageParams = getFilterImageParams(),
        imageParamsQuery = objectToQueryString(filteredImageParams),
        //mockupVersion = customizationData.mockupVersion || '',
        imagesLoaded = 0,
        firstImage = 0,
        sliderComponent = document.querySelector('media-gallery'),
        slider = sliderComponent.elements.viewer,
        thumbnails = sliderComponent.elements.thumbnails.sliderItems,
        slides = slider.sliderItems,
        imagesToLoad = slides.length,
        galleryBtnCloseComponent = document.querySelector('#gallery-close-btn-component');

    if (galleryBtnCloseComponent) galleryBtnCloseComponent.notify('loading');
  
    // everytime preview images are updated, imageParams are stored in localStorage
    setImageParamsToCookie(getImageParamsCookieKey(),objectToQueryString(imageParams));

	  $('#hidden_input_imageparams').val($.param(filteredImageParams));
    //$('#hidden_input_imageParamsHash').val(stringToHash($.param(filteredImageParams)));

    async function loadImage(slide,index,url) {

      if (!url) return;

      /*if (!is_touch_enabled()) {
        url += '&quality=90';
      }*/

      var img = slide.querySelector('img'),
          thumbnailContainer = thumbnails[index],
          thumbnailImage = thumbnailContainer.querySelector('img'),
          zoomImgContainer = is_touch_enabled() ? null : slide.querySelector('.image-zoom'),
          showLoadingAnimation = true,
          loadingAnimationTimeout = 300;

      //console.log(sliderComponent.classList);
      //sliderComponent.classList.remove('initializing');

      // when image is coming from cache there is no need for a loading animation
      setTimeout(() => {
        if (showLoadingAnimation) {
          slide.classList.add('loading');
          thumbnailContainer.classList.add('loading');
        }
      }, loadingAnimationTimeout);

      initTimer(slide,index,url);
     
      // if customer image is currently shown
      // we always need to make sure we fetch the non chached version
      // this avoids a problem when customer uploads multiple images

      if (customizationData.hasCustomImages || isCustomImageProductPage()) {
        url += '&r=' + new Date().getTime();
      }

      img.removeAttribute('loading');
      img.removeAttribute('srcset');
      thumbnailImage.removeAttribute('srcset');

      var origSrc = img.src;

      await new Promise((resolve, reject) => {
        img.onload = resolve;
        img.onerror = reject;
        img.src = url;
      })
      .catch(() => {
        // if src does not exist (e.g. when there arew more product images than dynamic mockups)
        img.src = origSrc;
        // url is used below for thimbnail
        url = origSrc;
      });

      showLoadingAnimation = false;

      //console.log('IMG LOADING COMPLETE -> clearTimer ' + index);

      clearTimer(timers['timer_' + index]);

      // this migh appear as second loading in network inspector but it should come frome cache
      if (zoomImgContainer) zoomImgContainer.style.backgroundImage = "url('"+url+"')";

      thumbnailImage.removeAttribute('srcset');
      thumbnailImage.src = url;
      
      slide.classList.remove('loading');
      thumbnailContainer.classList.remove('loading');
      galleryBtnCloseComponent.notify('done');

      if (index == 0) {
        $('[name="properties[_cachedImageUrl]"]').val(url);
        $('#PopupModal__confirm-preview--image').attr('src',url);
        setCachedPreviewUrl(url);
      }

      imagesLoaded++;

      if (index == 0) {
        //splog('Gallery initilaized');
        sliderComponent.classList.remove('initializing');
      }
      
      if (imagesLoaded === imagesToLoad) {
        splog('ALL IMAGES LOADED');
        //if (galleryBtnCloseComponent) galleryBtnCloseComponent.notify('done');
        initPinchZoom('.pinch-zoom');
      }
    }

    // Goal: load active slide first
    var slideOrder = [];

    // find the currently active image
    var currentImageIndex = 0;

    // thumbnails are marked active when clicked or slide is swiped
    thumbnails.forEach(function(thumbnailSlide,index) {
      if (thumbnailSlide.querySelector('button').getAttribute('aria-current')) {
        currentImageIndex = index + 1;
      }
      // if slide is acive, put it in front of slideOrder array
      if (thumbnailSlide.querySelector('button').getAttribute('aria-current') && !slides[index].classList.contains('donot_remove')) {
        slideOrder.unshift(index);
      } else {
        slideOrder.push(index);
      }
    });

    slideOrder.forEach(function(index) {

      var slide = slides[index];

      // ignore additional images that are no mockups
      if ($(slide).hasClass('donot_remove')) {
        imagesToLoad--;
        return true;
      }

      //var url = 'https://'+server + imgRenderPath + '?' + imageParamsQuery + '&mockupVersion='+mockupVersion,
      var url = 'https://'+server + imgRenderPath + '?' + imageParamsQuery,
          cartItemKey = getCurrentCartItemKey();

      if (customizationData.hasImageUploadForm && cartItemKey) {
        url += '&cartItemKey=' + cartItemKey;
      }

      /*
      //if (imageParams.printProduct == 'passepartout') {
      if (imageParams.printProduct != 'canvas') { // 18.09.2025
        url += '&mockupIndex=' + (index+1);
      }

      if (imageParams.printProduct == 'canvas' || imageParams.printProduct == 'canvas-v2') {
        url += '&mockupIndex=' + (index+1);
      }
      */

      url += '&mockupIndex=' + (index+1);

      //console.log(url);

      loadImage(slide,index,url);
    });

    // in case current image is an "additional image" (no mockup), go back to first slide
    if (currentImageIndex > imagesToLoad) {
      sliderComponent.setActiveMedia(slider.sliderItems[firstImage].getAttribute('id').replace('Slide-',''));
    }
};


//======================================================================
// product related ui handling functions
//======================================================================
function initSharedUI(cookieParams) {

  var amountParam = $('.persons.swatches').data('imageparam') || 'personsAmount';

  var $petsOptionContainers = $('.additional_options.pets_options').find('.pets_option');

  var $textSelect = $('#text_type_select');

  var hasTextSelect = $('#text_type_select').length;
  
  var handleKidsPetsConstraints = function(source) {

    var maxPets = 4,
        maxKids = 6;

    if (source == 'kidsAmount') {

      if (imageParams.kidsType == 'twins') {
        switch(imageParams.kidsAmount) {
          case 2:
            maxPets = 5;
            break;
          case 3: 
          case 4:
            maxPets = 3;
            break;
          default:
        }

      } else {

        switch(imageParams.kidsAmount) {
          case 1: 
          case 2:
            maxPets = 6;
            break;
          case 3: 
            maxPets = 6;
            break;
          case 4:
          case 5:
            maxPets = 4;
            break;
          case 6: 
          case 7: 
            maxPets = 2;
            break;
          default:
            maxPets = 6;
        }
      }

      var maxPetsExceeded = imageParams.petsAmount && imageParams.petsAmount > maxPets;
      var $petsAmountSwatches = $('[data-type="petsAmount"]');

      $petsAmountSwatches.removeClass('disabled');

      if (maxPetsExceeded) {
        $petsAmountSwatches.removeClass('active');       
        delete imageParams.petsAmount;
      }
     
      $petsAmountSwatches.forEach(function(elem,index) {
        if (index > maxPets) {
          $(elem).addClass('disabled');
        } else if (index == maxPets) {
          //$(elem).addClass('active');
          //imageParams.petsAmount = index;
        }
      });
    }

    if (source == 'petsAmount') {
      
      switch(imageParams.petsAmount) {
        case 1: 
          maxKids = 6;
          break;
        case 2: 
          maxKids = 5;
          break;
        case 3: 
          maxKids = 3;
          break;
        case 4: 
          maxKids = 3;
          break;
        case 5: 
          maxKids = 1;
          break;
        default:
          maxKids = 6;
      }      
    }

    // hide/show pet options (paws) - START
    // hide all pet options
    $($petsOptionContainers).addClass('hidden');
    // disable all hidden input fields (properties)
    var $allHiddenPetsProperties = $('[id^="hidden_input_pet"]');
    $allHiddenPetsProperties.prop('disabled',true);
    $allHiddenPetsProperties.val('');

    for(var i=0; i<$($petsOptionContainers).length; i++) {
      var petId = i+1;
      if (i < imageParams.petsAmount) {
        $($petsOptionContainers[i]).removeClass('hidden');
        var $activeSwatch = $($petsOptionContainers[i]).find('[data-value="'+imageParams['pet'+petId]+'"]');
        $activeSwatch.addClass('active');
        // enable hidden input fields (properties) that are actually in use
        var $hiddenPetsProperty = $($petsOptionContainers[i]).find('[id="hidden_input_pet'+petId+'"]');
        $hiddenPetsProperty.prop('disabled',false);
        $hiddenPetsProperty.val($activeSwatch.data('label'));
      }        
    }
    // hide/show pet options (paws) - END
  }

  var showHideTwinsSkinToneOption = function() {
      if (imageParams.kidsType == 'twins') {
        $('.hidden_options_swatches_row.kids').addClass('disabled');
        $('.hidden_options_swatches_row.twins').addClass('disabled');
        $('.hidden_options_swatches_row.twins-'+imageParams.kidsAmount).removeClass('disabled');
      } else {
        $('.hidden_options_swatches_row.twins').addClass('disabled');
        showHideHiddenOptions(2 + parseInt(imageParams.kidsAmount || 0),'.hidden_options_swatches--skintone');
      }
  }

  var showHideStarkidBtn = function() {
      if (imageParams.kidsAmount && imageParams.kidsAmount > 0) {
        $('.hidden_options_toggle.starkidOptions').parents('.option_group').show();
      } else {
        $('.hidden_options_toggle.starkidOptions').parents('.option_group').hide();
      }
  }

  var showHideStarkidOption = function() {
    showHideHiddenOptions(parseInt(imageParams.kidsAmount || 0),'.hidden_options_swatches--starkid');
  }

  handleSwatch({currentTarget: $('.handsType.swatches').find('[data-value="'+ (imageParams.mainHandLeftGender || 'male') +'"]')});
  handleSwatch({currentTarget: $('.fontType.swatches').find('[data-value="'+ (imageParams.fontType || 'v1') +'"]')});
  handleSwatch({currentTarget: $('.tone.swatches').find('[data-value="'+ (imageParams.tone || 'color') +'"]')});
  handleSwatch({currentTarget: $('.skinTone.swatches').find('[data-value="'+ (imageParams.defaultSkinTone || '') +'"]')});
  handleSwatch({currentTarget: $('.frameColor.swatches').find('[data-value="'+ (imageParams.frameColor || 'oak') +'"]')});

  if (cookieParams) {

    $('.input_container').each(function(i,div) {
      $(div).find('input').each(function(i,input) {
		var imageparam = $(input).data('imageparam');
        if (imageParams[imageparam]) {
          $(input).val(imageParams[imageparam]);
        }
      });
    });

    // name inputs for parents and kids
    var nameInputAmount = 2 + parseInt(imageParams.kidsAmount || 0);

    // 'heart' is version with animal paws
    if (imageParams.style == 'heart') {

      handleSwatch({currentTarget: $('.kids_amount.swatches').find('[data-value="'+imageParams.kidsAmount+'"]')});
      handleSwatch({currentTarget: $('.kids_type.swatches').find('[data-value="'+imageParams.kidsType+'"]')});

      if (imageParams.kidsAmount >= 2 && imageParams.kidsAmount <= 4) {
        $('.kids_type_option').removeClass('hidden');
      }
      
      // pet amount swatches
      if (imageParams.petsAmount && $petsOptionContainers.length) {
        handleSwatch({currentTarget: $('.pets_amount.swatches').find('[data-value="'+imageParams.petsAmount+'"]')});        
        $($petsOptionContainers).addClass('hidden');  
      }

      handleKidsPetsConstraints('kidsAmount');

      // add name inputs for pets
      nameInputAmount += parseInt(imageParams.petsAmount || 0);
      
      // activate hidden options, e.g. skinTone
      activateHiddenOptions();

      // also shows skintone opptions according to amount of persons
      showHideTwinsSkinToneOption();

      showHideStarkidOption();
      
      if (imageParams.twinsSkinTone) {
        activateSwatch($('[data-type="twinsSkinTone"][data-value="'+imageParams.twinsSkinTone+'"]'));
      }
    }

    if (imageParams.productType == 'newborn') {
      handleSwatch({currentTarget: $('.persons.swatches').find('[data-amount="'+ imageParams.kidsAmount || 1 +'"]')});
      nameInputAmount = parseInt(imageParams.kidsAmount || 1);
    }

    if (hasTextSelect) {

      prefillInputFieldsDecoded();

      toggleCustomTextArea(imageParams.text);

      $textSelect.find('option[value="' + imageParams.text + '"]').attr('selected',true);

      if (imageParams.customText) {
        $('#custom_text_textarea').val(imageParams.customText);
      }
    }

    showHideInputFields(nameInputAmount,'.persons_names');
    
    fetchPreviewImage();
  }

  handleHiddenOptions();

  showHideStarkidBtn();

  // swatch events
  $('.sp_options-container').on('click', '.swatch', function(event) {

    var $currentTarget = $(event.currentTarget),
        swatchType = $currentTarget.data('type');

    if ($currentTarget.hasClass('disabled')) return;

    if (swatchType == 'floatingFrame') return;
    
    if (customizationData.imageParams.productType == 'familyhands') {

      // 'heart' is version with animal paws
      if (imageParams.style == 'heart') {

        var skinToneSwatches = [
          'mainHandLeftTone',
          'mainHandRightTone',
          'kid1Tone',
          'kid2Tone',
          'kid3Tone',
          'kid4Tone',
          'kid5Tone',
          'kid6Tone',
          'kid7Tone',
          'twinsSkinTone'
        ];

        if (swatchType === 'kidsAmount' || swatchType === 'petsAmount') {
  
          handleSwatch({
            currentTarget:$currentTarget,
            updatePreviewImage:false
          });
  
          handleKidsPetsConstraints(swatchType);
  
          showHideInputFields(2 + parseInt(imageParams.kidsAmount || 0) + parseInt(imageParams.petsAmount || 0),'.persons_names');

          showHideHiddenOptions(2 + parseInt(imageParams.kidsAmount || 0),'.hidden_options_swatches--skintone');

          if (swatchType === 'kidsAmount') {
            if (imageParams.kidsAmount > 1 && imageParams.kidsAmount <= 4) {
              $('.kids_type_option').removeClass('hidden');
            } else {
              $('.kids_type_option').addClass('hidden');
              imageParams.kidsType = '';
            }
            handleSwatch({currentTarget: $('.kids_type.swatches').find('[data-value="'+imageParams.kidsType+'"]')});

            showHideTwinsSkinToneOption();

            showHideStarkidOption();

            showHideStarkidBtn();
          }

          /*
          // pre-select first dog paw when petsAmount is clicked
          if (swatchType === 'petsAmount') {
            if (imageParams.petsAmount > 0) {
              for(var i=1; i<=imageParams.petsAmount; i++) {
                imageParams['pet'+i] = !imageParams['pet'+i] ? 'dog1' : imageParams['pet'+i];
                activateSwatch($('[data-type="pet'+i+'"][data-value="'+imageParams['pet'+i]+'"]'));
              }
            }
          }
          */

          fetchPreviewImage();

        } else if (swatchType === 'kidsType') {

          handleSwatch({
            currentTarget:$currentTarget,
            updatePreviewImage:true
          });

          showHideTwinsSkinToneOption();

          showHideStarkidOption();
          
        } else if (swatchType === 'defaultSkinTone') {

          // set chosen default color for all hands
          skinToneSwatches.forEach(function(swatch) {
            imageParams[swatch] = $currentTarget.data('value');
          });
         
          handleSwatch({
            currentTarget:$currentTarget,
            updatePreviewImage:true
          });
          
          activateHiddenOptions();

          if (imageParams.twinsSkinTone) {
            activateSwatch($('[data-type="twinsSkinTone"][data-value="'+imageParams.twinsSkinTone+'"]'));
          }

        } else if (skinToneSwatches.includes(swatchType)) {

          // whenever a single hand gets another color defaultSkinTone is deleted from imgaeParams
          delete imageParams.defaultSkinTone;

          $('.skinTone').find('.swatch').removeClass('active');
          
          handleSwatch({
            currentTarget:$currentTarget,
            updatePreviewImage:true
          });

        } else {
          // - paw type swatches (cats/dogs)
          // - frame color (passeartout)
          handleSwatch({
            currentTarget:$currentTarget,
            updatePreviewImage:true
          });
        }
  
      } else {
  
          // kidsAmount swatches
          handleSwatch({
            currentTarget:$currentTarget,
            updatePreviewImage:true
          });
  
          //howHideNameInputs(2 + parseInt(imageParams.kidsAmount || 0));
          showHideInputFields(2 + parseInt(imageParams.kidsAmount || 0),'.persons_names');
      }
    }

    if (customizationData.imageParams.productType == 'newborn' || customizationData.imageParams.productType == 'familyhearts') {

        handlePersonsSwatch({
          currentTarget:$currentTarget,
          updatePreviewImage:true
        });
    }

    if (customizationData.imageParams.productType == 'simplebg' || swatchType == 'frameColor') { // frameColor means passepartout frame color
        handleSwatch({
          currentTarget:$currentTarget,
          updatePreviewImage:true
        });
    }

  });

  if (hasTextSelect) {
    initTextSelectChangeEvent();
  }
}

function initChaosUI(cookieParams) {

  handlePersonsSwatch({currentTarget: $('.persons.swatches').find('[data-amount="'+ imageParams.personsAmount || 4 +'"]')});
  handleSwatch({currentTarget: $('.style.swatches').find('[data-value="'+ (imageParams.style || 'chaos1') +'"]')});
  
  if (cookieParams) {
    prefillInputFields();
    showHideInputFields(imageParams.personsAmount,'.persons_names');
    fetchPreviewImage();
  }

  // swatch events
  $('.sp_options-container').on('click', '.swatch', function(event) {

    var $currentTarget = $(event.currentTarget),
        swatchType = $currentTarget.data('type');

    if ($currentTarget.hasClass('disabled')) return;

    if (swatchType == 'floatingFrame') return;

    if (swatchType === 'persons_swatch') {
      handlePersonsSwatch({
        currentTarget:$currentTarget,
        updatePreviewImage:true
      });
      return;
    }

    handleSwatch({
      currentTarget:$currentTarget,
      updatePreviewImage:true
    });
  });

}

function initFamilytreeUI(cookieParams) {

  var hasTextSelect = $('#text_type_select').length;

  handlePersonsSwatch({currentTarget: $('.persons.swatches').find('[data-amount="'+ imageParams.personsAmount || 4 +'"]')});
  handleSwatch({currentTarget: $('.bg.swatches').find('[data-value="'+ (imageParams.bg || 'bg1') +'"]')});

  showHideMultiColumnInputFields({
    amount: imageParams.personsAmount,
    containerSelector: '.persons_names',
    colSelectors: ['.name','.dob']
  });
  
  if (cookieParams) {

    // we make sure the "&" stays
    imageParams.names = encodeURIComponent(imageParams.names);

    prefillInputFieldsDecoded();
    prefillInputFieldsDecoded('.input_container_sibling');

    if (hasTextSelect) {
      toggleCustomTextArea(imageParams.text);
  
      $('#text_type_select option[value="' + imageParams.text + '"]').attr('selected',true);
  
      if (imageParams.customText) {
        $('#custom_text_textarea').val(imageParams.customText);
      }
    }

    fetchPreviewImage();
  }

  if (hasTextSelect) {
    initTextSelectChangeEvent();
  }

  $('.sp_options-container').on('click', '.swatch', function(event) {

    var $currentTarget = $(event.currentTarget),
        swatchType = $currentTarget.data('type');

    if ($currentTarget.hasClass('disabled')) return;

    if (swatchType == 'floatingFrame') return;

    if (swatchType === 'persons_swatch') {

      handlePersonsSwatch({
        currentTarget:$currentTarget,
        updatePreviewImage:true
      });

      showHideMultiColumnInputFields({
        amount: imageParams.personsAmount,
        containerSelector: '.persons_names',
        colSelectors: ['.name','.dob']
      });

      if (imageParams.productType === 'familytree_upload') {
        highlightActiveThumbs();
      }
      
      return;
    }
    handleSwatch({
      currentTarget:$currentTarget,
      updatePreviewImage:true
    });
  });
}

function initFamilytree2UI(cookieParams) {

  handlePersonsSwatch({currentTarget: $('.persons.swatches').find('[data-amount="'+ imageParams.personsAmount || 3 +'"]')});
  
  if (cookieParams) {
    // we make sure the "&" stays
    imageParams.names = encodeURIComponent(imageParams.names);
    //prefillInputFields();
    prefillInputFieldsDecoded();

    toggleCustomTextArea(imageParams.text);

    $('#text_type_select option[value="' + imageParams.text + '"]').attr('selected',true);

    if (imageParams.customText) {
      $('#custom_text_textarea').val(imageParams.customText);
    }
    
    showHideInputFields(imageParams.personsAmount,'.persons_names');
    fetchPreviewImage();
  }

  //initSwatchEvents();

  initTextSelectChangeEvent();
  
  $('.sp_options-container').on('click', '.swatch', function(event) {

    var $currentTarget = $(event.currentTarget),
        swatchType = $currentTarget.data('type');

    if ($currentTarget.hasClass('disabled')) return;

    if (swatchType == 'floatingFrame') return;

    if (swatchType === 'persons_swatch') {
      handlePersonsSwatch({
        currentTarget:$currentTarget,
        updatePreviewImage:true
      });
      return;
    }
    handleSwatch({
      currentTarget:$currentTarget,
      updatePreviewImage:true
    });
  });
}

function initNewborn2UI(cookieParams) {

  handleHiddenOptions();

  handleSwatch({currentTarget: $('.symbol.swatches').find('[data-value="'+ (imageParams.symbol || 'bear-ballons') +'"]')});
  handleSwatch({currentTarget: $('.fontColor.swatches').find('[data-value="'+ (imageParams.fontColor || 'blue') +'"]')});

  if (cookieParams) {

    fetchPreviewImage();
    
    prefillInputFields();
  }

  //showHideInputFields(parseInt(imageParams.eventsAmount || 4),'.events');
  
  initSwatchEvents();

  initDatePicker({
    fetchPreviewImage: true
  });
}

function initFamilybootsUI(cookieParams) {

  handleHiddenOptions();

  handleSwatch({currentTarget: $('.persons.swatches').find('[data-value="'+ (imageParams.personsAmount || '3') +'"]')});
  //handleSwatch({currentTarget: $('.heartType.swatches').find('[data-value="'+ (imageParams.heartType || 'heart1') +'"]')});
  handleSwatch({currentTarget: $('.style.swatches').find('[data-value="'+ (imageParams.bg || '') +'"]')});

  if (cookieParams) {

    prefillInputFields();

    if (imageParams.familyname) $('input[data-imageparam="familyname"]').val(imageParams.familyname);

    $('#text_type_select option[value="' + imageParams.text + '"]').attr('selected',true);

    toggleMultipleCustomTextAreas(imageParams.text);
    
    // activate hidden options (symbols: heart, cat, dog)
    $('.hidden_options_container').each(function(i,div) {
      $(div).find('.swatch').each(function(i,swatch) {
        if (imageParams[$(swatch).data('type')] == $(swatch).data('value')) {
          handleSwatch({currentTarget:$(swatch)});
        }
      });
    });

    showHideInputFields(parseInt(imageParams.personsAmount || 3),'.persons_names');
    
    fetchPreviewImage();

  } else {
    // "Family + Familyname" is the default option, so the family name input must be visible
    toggleMultipleCustomTextAreas('familyname');
  }

  initSwatchEvents();

  initTextSelectChangeEvent({multipleFields:true});
}

function initFamilychucksUI(cookieParams) {

  handleHiddenOptions();

  handleSwatch({currentTarget: $('.persons.swatches').find('[data-value="'+ (imageParams.personsAmount || '3') +'"]')});
  handleSwatch({currentTarget: $('.style.swatches').find('[data-value="'+ (imageParams.bg || '') +'"]')});

  if (cookieParams) {

    prefillInputFields();

    if (imageParams.familyname) $('input[data-imageparam="familyname"]').val(imageParams.familyname);

    $('#text_type_select option[value="' + imageParams.text + '"]').attr('selected',true);

    toggleMultipleCustomTextAreas(imageParams.text);

    // activate hidden options (symbols: heart, cat, dog)
    $('.hidden_options_container').each(function(i,div) {
      $(div).find('.swatch').each(function(i,swatch) {
        if (imageParams[$(swatch).data('type')] == $(swatch).data('value')) {
          handleSwatch({currentTarget:$(swatch)});
        }
      });
    });

    showHideInputFields(parseInt(imageParams.personsAmount || 3),'.persons_names');
    
    fetchPreviewImage();
  }

  initSwatchEvents();

  initTextSelectChangeEvent({multipleFields:true});
}

function initOurstoryUI(cookieParams) {

  handleHiddenOptions();

  handleSwatch({currentTarget: $('.eventsAmount.swatches').find('[data-value="'+ (imageParams.eventsAmount || '4') +'"]')});

  if (cookieParams) {

    fetchPreviewImage();
    
    prefillInputFields();

    // activate hidden options
    $('.hidden_options_swatches').find('[data-type^="eventType"]').each(function(i,swatch) {
        var index = $(swatch).data('index'),
            eventType = $(swatch).data('eventtype'),
            showKidsnameInput = $(this).data('showkidsnameinput') || '',
            $kidsNameContainer = $('.hidden_options_kidsname.kidsname'+index).find('.kidsNameInput');

        if (index && eventType && imageParams['event'+index] == eventType) {
          activateSwatch($(swatch));
          if (showKidsnameInput) {
            $kidsNameContainer.addClass(showKidsnameInput);
            $kidsNameContainer.show();
          } else {
            $kidsNameContainer.hide();
          }
        }
    });

    $('.hidden_options_swatches').find('[data-type^="petOption"]').each(function(i,swatch) {

        var index = $(swatch).data('index'),
            petOption = $(swatch).data('value') || '';

        //if (petOption == imageParams['petOption'+index]) {
        if (petOption == imageParams['pawType'+index]) {
          activateSwatch($(swatch));
          $('.petOption').addClass('hidden');
          $('.petOption-'+petOption).removeClass('hidden');
        }
    });

    // activate paw color swatch on load
    $('.hidden_options_swatches').find('[data-type^="pawColor"]').each(function(i,swatch) {
        var index = $(swatch).data('index'),
            pawTypeColor = $(swatch).data('pawtypecolor'+index),
            pawColor = $(swatch).data('value');
        if (pawTypeColor == imageParams['pawType'+index] + imageParams['pawColor'+index]) {
          activateSwatch($(swatch));
        }
    });

    $('[data-imageparam^="kidsname"]').each(function(i,elem) {
      var imageParam = $(elem).data('imageparam');
      if (imageParams[imageParam]) {
        $(elem).val(imageParams[imageParam]);
      }
    });

    $('[id^="hidden_input_date"]').each(function(i,elem) {
      $(elem).val(formatDateDE(imageParams['date'+(i+1)]) || '');
    });
  }

  showHideInputFields(parseInt(imageParams.eventsAmount || 4),'.events');
  
  initSwatchEvents();

  initDatePicker({
    fetchPreviewImage: true,
    allowMonthAndYear: true
  });

  var defaultTexts = {
    'together': 'Gefunden',
    'engaged': 'Willst du?',
    'married': 'Ja, ich will!',
    'kids1': ' ist da',
    'kids1-rainbow': ' ist da',
    'kids2': ' ist da',
    'kids3': ' ist da',
    'kids2-rainbow': ' ist da',
    'twins': ' sind da',
    'twins-rainbow': ' sind da',
    'dog-kids0': ' ist da',
    'dog-kids1': ' ist da',
    'dog-kids2': ' ist da',
    'dog-kids3': ' ist da',
    'cat-kids0': ' ist da',
    'cat-kids1': ' ist da',
    'cat-kids2': ' ist da',
    'cat-kids3': ' ist da',
  }

  $('.input_fields.events').find('[id^="input_field_text"]').on('focus', function() {
      var index = $(this).data('index'),
          event = imageParams['event'+index];
      if (!event) {
        $(this).trigger('blur'); // close/hide virtual keyboard on mobile
        openHiddenOptionsOverlay($(this).parent().find('.hidden_options_container'));
      }   
  });

   $('.hidden_options_swatches').find('[data-type^="petOption"').on('click', function() {
     activateSwatch($(this));
     var index = $(this).data('index'),
         petOption =  $(this).data('value');

     $('.petOption').addClass('hidden');
     if (petOption != 'no') {
       $('.petOption-'+petOption).removeClass('hidden');
     }
  });
  
  $('.hidden_options_swatches').find('[data-type^="pawColor"').on('click', function() {
    activateSwatch($(this));
    var index = $(this).data('index');
    imageParams['pawColor'+index] = $(this).data('value');
    fetchPreviewImage();
  });
  
  $('.hidden_options_swatches').find('[data-type^="eventType"]').on('click', function() {

    activateSwatch($(this));

    var index = $(this).data('index'),
        eventType = $(this).data('eventtype'), // engaged, married, etc.
        defaultText = defaultTexts[eventType] || ' ',
        showKidsnameInput = $(this).data('showkidsnameinput') || '', // kid, twins
        pawType = $(this).data('pawtype') || '',
        $label = $('[for="input_field_kidsname'+index+'"]'),
        $kidsNameContainer = $('.hidden_options_kidsname.kidsname'+index).find('.kidsNameInput');

    if (showKidsnameInput) {
      $kidsNameContainer.show();
      $kidsNameContainer.removeClass('kid').removeClass('twins');
      var kidsName = imageParams['kidsname'+index] || '';
      if (kidsName) {
        defaultText = kidsName + defaultText;
      }
      $kidsNameContainer.addClass(showKidsnameInput); // kid or twins
      $label.text(defaultText);
    } else {
      $kidsNameContainer.hide();
    }

    $('[data-imageparam="'+'text'+index+'"]').val(defaultText);

    imageParams['event'+index] = eventType;
    imageParams['text'+index] = defaultText;

    if (pawType) {

      imageParams['pawType'+index] = pawType;

      if (imageParams['pawColor'+index]) {
        activateSwatch($('[data-pawTypeColor'+index+'="'+ pawType + imageParams['pawColor'+index] +'"]'));
      }
    } else {
       delete imageParams['pawType'+index];
       delete imageParams['pawColor'+index];
       $('[data-type^="pawColor"]').removeClass('active');
    }
    
    fetchPreviewImage();
  });
 
  $(document).on('input', '[id^="input_field_kidsname"]', debounce(function(event) {
    var index = $(this).data('index'),
        imageParam = $(this).data('imageparam'), // e.g. kidsname1
        targetInput = $(this).data('targetinput'), // e.g. text1
        $textInput = $('[data-imageparam="'+targetInput+'"]'),
        $label = $('[for="'+$(this).attr('id') +'"]'),
        kidsName = $(this).val() || '',
        output = kidsName ? kidsName + defaultTexts[imageParams['event'+index]] : '';

    $label.text(output);
    $textInput.val(output);
    imageParams[targetInput] = encodeURIComponent(output);
    imageParams[imageParam] = kidsName;

    if (output) {
      $('.hidden_options_kidsname.'+imageParam+' .kidsNameInput').removeClass('error');
    }
    fetchPreviewImage();
  },500));
  
  /*
  $(document).on('input', '[data-imageparam^="text"]', debounce(function(event) {
    var index = parseInt($(this).data('imageparam').replace('text',''));
    // If customer put in custom event title -> keep it
    // and don't in "Ben ist da"
    // only if customer is putting in kidsName -> then override previously entered text   
    console.log(index);
  },500));
  */
}

function initSimplemaskUI(cookieParams) {

  //handleSwatch({currentTarget: $('.bg.swatches').find('[data-value="'+ (imageParams.bg || 'grey') +'"]')});
  
  if (cookieParams) {
    prefillInputFieldsDecoded();
    /*toggleCustomTextArea(imageParams.text);
    $('#text_type_select option[value="' + imageParams.text + '"]').attr('selected',true);
    if (imageParams.customText) {
      $('#custom_text_textarea').val(imageParams.customText);
    }*/
    fetchPreviewImage();
  }
  //initSwatchEvents();
  //initTextSelectChangeEvent();
}

function initStreetsigncoupleUI(cookieParams) {

  if (cookieParams) {
    fetchPreviewImage();   
    prefillInputFields();
  }

  handleSwatch({currentTarget: $('.bg.swatches').find('[data-value="'+ (imageParams.bg || 'sky') +'"]')});
  handleSwatch({currentTarget: $('.dateStyle.swatches').find('[data-value="'+ (imageParams.dateStyle || 'year') +'"]')});
  handleSwatch({currentTarget: $('.tone.swatches').find('[data-value="'+ (imageParams.tone || 'bw') +'"]')});

  initSwatchEvents();

  initDatePicker({
    fetchPreviewImage: true,
    fetchPreviewOnDatePartChange: true
  });

  dateStyleHandle = function(dateStyle) {
    dateStyle = dateStyle || 'yearOnly';
    var day = parseInt(imageParams.day) || '',
        month = parseInt(imageParams.month) || '',
        year = parseInt(imageParams.year) || '';
    $('#option_group-date_selects').removeClass('full');
    $('#option_group-date_selects').removeClass('yearOnly');
    $('#option_group-date_selects').addClass(dateStyle);
    if (dateStyle == 'yearOnly') {
      $('#hidden_input_date').val('');
      $('#hidden_input_year').val(year);
    } else {
        day = day < 10 ? '0'+day : day;
        month = month < 10 ? '0'+month : month;
        $('#hidden_input_date').val(day && month && year ? [day,month,year].join('.') : '');
        $('#hidden_input_year').val('');
    }
  }

  $('.dateStyle').on('click', '.swatch', function() {
    dateStyleHandle($(this).data('value'));
  });

  $('.bg.swatches').on('click', '.swatch', function() {
    var value = $(this).data('value');
    // if bg swatch "sky-vintage" is clicked for the first time ignore if tone has been set to b/w before
    // do this only once / on first click
    if (!initStreetsigncoupleUI.overrideToneOption && value == 'sky-vintage') {
      initStreetsigncoupleUI.overrideToneOption = true;
      handleSwatch({currentTarget: $('.tone.swatches').find('[data-value="color"]')});
    }
  });

  dateStyleHandle(imageParams.dateStyle);
}

function initZodiacsignsUI(cookieParams) {

  handleHiddenOptions();

  handleSwatch({currentTarget: $('.persons.swatches').find('[data-value="'+ (imageParams.personsAmount || '3') +'"]')});
  handleSwatch({currentTarget: $('.tone.swatches').find('[data-value="'+ (imageParams.tone || 'blue') +'"]')});
  handleSwatch({currentTarget: $('.showFamily.swatches').find('[data-value="'+ (imageParams.showFamily || 1) +'"]')});
  //handleSwatch({currentTarget: $('.background.swatches').find('[data-value="'+ (imageParams.bg || '') +'"]')});

  if (cookieParams) {

    prefillInputFields();

    // activate hidden options (symbols: heart, cat, dog)
    $('.hidden_options_container').each(function(i,div) {
      $(div).find('.swatch').each(function(i,swatch) {
        if (imageParams[$(swatch).data('type')] == $(swatch).data('value')) {
          handleSwatch({currentTarget:$(swatch)});
        }
      });
    });

    showHideInputFields(parseInt(imageParams.personsAmount || 3),'.persons_names');
    
    fetchPreviewImage();
  }

  initSwatchEvents();

  initDatePicker({
    closeOnYearSelected: true,
    fetchPreviewImage: true
  });
}

function initFamilyhearts2UI(cookieParams) {

  handleHiddenOptions();

  handleSwatch({currentTarget: $('.persons.swatches').find('[data-value="'+ (imageParams.personsAmount || '3') +'"]')});
  handleSwatch({currentTarget: $('.heartType.swatches').find('[data-value="'+ (imageParams.heartType || 'heart1') +'"]')});
  handleSwatch({currentTarget: $('.colorScheme.swatches').find('[data-value="'+ (imageParams.colorScheme || 'red') +'"]')});

  if (cookieParams) {

    prefillInputFields();

    // activate hidden options (symbols: heart, cat, dog)
    $('.hidden_options_container').each(function(i,div) {
      $(div).find('.swatch').each(function(i,swatch) {
        if (imageParams[$(swatch).data('type')] == $(swatch).data('value')) {
          handleSwatch({currentTarget:$(swatch)});
        }
      });
    });

    showHideInputFields(parseInt(imageParams.personsAmount || 3),'.persons_names');
    
    fetchPreviewImage();
  }

  initSwatchEvents();
}

function initSignpostUI(cookieParams) {

  if (isPersonalizationOffProductPage()) {
    imageParams.personalizationOff = true;
    setProductTitle($('[data-background="'+imageParams.background+'"]').data('name'));
    $('#hidden_input_imageparams').val($.param(imageParams));
  } 

  //======================================================================
  // initialize ui elements
  //======================================================================
  if (cookieParams) {

    $('.input_container').each(function(i,div) {
      $(div).find('input').each(function(i,input) {
		var imageparam = $(input).data('imageparam');
        if (imageParams[imageparam]) {
          $(input).val(imageParams[imageparam]);
        }
      });
    });
    
    handlePersonsSwatch({currentTarget: $('.persons.swatches').find('[data-amount="'+imageParams.personsAmount+'"]')});

    fetchPreviewImage();    
  }

  if (imageParams.direction) {
    handleDirectionSwatch({currentTarget: $('.direction.swatches').find('[data-direction="'+imageParams.direction+'"]')});
  }

  if (imageParams.tone) {
    handleSwatch({currentTarget: $('.tone.swatches').find('[data-value="'+imageParams.tone+'"]')});
  }

  if (imageParams.spos === 'left') {
    $('#spos_left_switch').prop('checked',true)
    $('#hidden_input_spos').val('left');
  }

  $initialBackgroundSwatch = $('.background.swatches').find('[data-background="'+imageParams.background+'"]'); 
  $initialBackgroundSwatch.addClass('active');
  $initialBackgroundSwatch.removeClass('additional_swatch');
  $initialBackgroundSwatch.prependTo('.background.swatches');
  $($('[data-type="background_swatch"]')[10]).addClass('additional_swatch'); // 10 swatches are visible by default
  $('#hidden_input_background').val($initialBackgroundSwatch.data('name'));

  //======================================================================
  // setup event listeners
  //======================================================================
  $(document).on('click', '.background_picker .toggle_swatches_btn', function(event) {
    $(event.currentTarget).hide();
    $('.background_picker .swatches_container').slideDown();
  });

  $(document).on('click', '.swatch', function(event) {

    var $currentTarget = $(event.currentTarget);

    if ($currentTarget.data('type') === 'variant_swatch') {
      handleVariantSwatch({
        currentTarget:$currentTarget,
        updatePreviewImage:true
      });
    }

    if ($currentTarget.data('type') === 'background_swatch') {
      handleBackgroundSwatch({
        currentTarget:$currentTarget,
        updatePreviewImage:true
      });
    }
  
    if ($currentTarget.data('type') === 'persons_swatch') {
      handlePersonsSwatch({
        currentTarget:$currentTarget,
        updatePreviewImage:true
      });
    }

    if ($currentTarget.data('type') === 'direction_swatch') {
      handleDirectionSwatch({
        currentTarget:$currentTarget,
        updatePreviewImage:true
      });
    }

    if ($currentTarget.data('type') === 'tone') {
      handleSwatch({
        currentTarget:$currentTarget,
        updatePreviewImage:true
      });
    }
  });

  $('.background_swatch_more_toggle').on('click', function(){
    var isHidden = $('.background.swatches').hasClass('additional_swatch__hidden');
    if (isHidden) {
      $('.background.swatches').removeClass('additional_swatch__hidden');
      $(this).text($(this).data('hidetext'));
    } else {
      $('.background.swatches').addClass('additional_swatch__hidden');
      $(this).text($(this).data('showtext'));
    }
  });
}

function initSignpost2UI(cookieParams) {

  if (isPersonalizationOffProductPage()) {
    imageParams.personalizationOff = true;
    setProductTitle($('[data-background="'+imageParams.background+'"]').data('name'));
    $('#hidden_input_imageparams').val($.param(imageParams));
  } 

  //======================================================================
  // initialize ui elements
  //======================================================================
  if (cookieParams) {

    prefillInputFields();

    handlePersonsSwatch({currentTarget: $('.persons.swatches').find('[data-amount="'+imageParams.personsAmount+'"]')});
  
    if (imageParams.direction) {
      handleDirectionSwatch({currentTarget: $('.direction.swatches').find('[data-direction="'+imageParams.direction+'"]')});
    }
  
    if (imageParams.tone) {
      handleSwatch({currentTarget: $('.tone.swatches').find('[data-value="'+imageParams.tone+'"]')});
    }

    if (imageParams.textId) {
      $('#text_type_select option[value="' + imageParams.textId + '"]').attr('selected',true);
    }

    if (imageParams.butterflies) {
      handleSwatch({currentTarget: $('.butterflies.swatches').find('[data-value="'+ imageParams.butterflies +'"]')});
    }

    if (imageParams.frameColor) {
      handleSwatch({currentTarget: $('.frameColor.swatches').find('[data-value="'+ (imageParams.frameColor || 'oak') +'"]')});
    }
    
    fetchPreviewImage();
  }

  /*
  if (imageParams.spos === 'left') {
    $('#spos_left_switch').prop('checked',true)
    $('#hidden_input_spos').val('left');
  }
  */

  function toggleAdditionalOptions() {
    $('[class*="additional_option_"]').addClass('hidden');
    if (customizationData.additionalOptions[imageParams.background]) {
      customizationData.additionalOptions[imageParams.background].forEach(function(additionalOption) {
        $('.'+additionalOption).removeClass('hidden');
      });
    }
    if (imageParams.textId == 'empty') {
      $('.additional_option_butterflies').addClass('hidden');
    }
  }
  
  $initialBackgroundSwatch = $('.background.swatches').find('[data-background="'+imageParams.background+'"]'); 
  $initialBackgroundSwatch.addClass('active');
  $initialBackgroundSwatch.removeClass('additional_swatch');
  $initialBackgroundSwatch.prependTo('.background.swatches');
  $($('[data-type="background_swatch"]')[10]).addClass('additional_swatch'); // 10 swatches are visible by default
  $('#hidden_input_background').val($initialBackgroundSwatch.data('name'));

  toggleAdditionalOptions();

  //======================================================================
  // setup event listeners
  //======================================================================
  $(document).on('click', '.background_picker .toggle_swatches_btn', function(event) {
    $(event.currentTarget).hide();
    $('.background_picker .swatches_container').slideDown();
  });

  $(document).on('click', '.swatch', function(event) {

    var $currentTarget = $(event.currentTarget);

    if ($currentTarget.data('type') === 'variant_swatch') {
      handleVariantSwatch({
        currentTarget:$currentTarget,
        updatePreviewImage:true
      });
    }

    if ($currentTarget.data('type') === 'background_swatch') {
      handleBackgroundSwatch({
        currentTarget:$currentTarget,
        updatePreviewImage:true
      });
      toggleAdditionalOptions();
    }
  
    if ($currentTarget.data('type') === 'persons_swatch') {
      handlePersonsSwatch({
        currentTarget:$currentTarget,
        updatePreviewImage:true
      });
    }

    if ($currentTarget.data('type') === 'direction_swatch') {
      handleDirectionSwatch({
        currentTarget:$currentTarget,
        updatePreviewImage:true
      });
    }

    if ($currentTarget.data('type') === 'tone') {
      handleSwatch({
        currentTarget:$currentTarget,
        updatePreviewImage:true
      });
    }

    if ($currentTarget.data('type') === 'butterflies') {
      handleSwatch({
        currentTarget:$currentTarget,
        updatePreviewImage:true
      });
    }

    if ($currentTarget.data('type') === 'frameColor') {
      handleSwatch({
        currentTarget:$currentTarget,
        updatePreviewImage:true
      });
    }
  });


  $('.background_swatch_more_toggle').on('click', function(){
    var isHidden = $('.background.swatches').hasClass('additional_swatch__hidden');
    if (isHidden) {
      $('.background.swatches').removeClass('additional_swatch__hidden');
      $(this).text($(this).data('hidetext'));
    } else {
      $('.background.swatches').addClass('additional_swatch__hidden');
      $(this).text($(this).data('showtext'));
    }
  });

  $('#text_type_select').on('change', function() {
    imageParams.textId = $(this).val();
    fetchPreviewImage();
    if (imageParams.textId == 'empty') {
      $('.additional_option_butterflies').addClass('hidden');
    } else {
      $('.additional_option_butterflies').removeClass('hidden');
    }
  });
}

function initHeartmapUI(cookieParams,urlParams) {

  var mapBoxAccessToken = 'pk.eyJ1IjoiaGlsdmVuZG8iLCJhIjoiY2wwYzN3bHZsMTE5bjNkcXU2Ymd1bnNzMCJ9.gMk42aaXIl59UZdmY26JaQ';
  var map = null;
  var resultList = [];

  var autocompleteOpen = function() {

    // close outside 
    $(document).on('click.outsideAutocomplete', function(event) {
      if (!$(event.target).is('.place_query_result_item') && !$(event.target).is('#place_query')) {
          autocompleteClose();
      }
    });
    
    $('#place_query_result_list').show();
  }

  var autocompleteClose = function() {

    $(document).off('click.outsideAutocomplete');

    $('#place_query_result_list').hide();
  }

  var autocompleteSuggestionMapBoxAPI = function(inputParams,callback) {

    var config = {
      query: inputParams,
      countries: customizationData.imageParams.productType === 'heartmap' ? ['De'] : [],
      language: ['de'],
      autocomplete: true,
      limit: 5,
    };

    var geocodingClient = mapboxSdk({accessToken: mapBoxAccessToken});

    geocodingClient.geocoding.forwardGeocode(config)
    .send()
    .then(response => {
      const match = response.body;
      callback(match);
    });
  }

  var mapSearchEvent = function(event) {
    var $currentTarget = $(event.currentTarget),
        query = $currentTarget.val();
    if (query.length > 2) {
      autocompleteSuggestionMapBoxAPI(query,function(results) {
        resultList = results.features;
        //$('#place_query_result_list').html('');
        var resultListHtml = '';
        resultList.forEach(function(item,index) {
          resultListHtml += '<div class="place_query_result_item '+customizationData.imageParams.productType+'" data-index="'+index+'">'+item.place_name_de+'</div>';
        });
        $('#place_query_result_list').html(resultListHtml);
        autocompleteOpen();
      });
    } else {
      autocompleteClose();
    }
  }

  var getMapStyle = function() {

    var mapstyles = {
      'streets': 'mapbox/streets-v9',
      'satellite': 'mapbox/satellite-v9',
      'sat-streets': 'mapbox/satellite-streets-v11',
    };

    return  'mapbox://styles/' + (mapstyles[imageParams.mapstyle] || mapstyles['streets']);
  }
  
  var initMap = function() {

    //console.log(imageParams);
    
    mapboxgl.accessToken = mapBoxAccessToken;

    var config = {
      container: 'map',
      style: getMapStyle(),
      center: imageParams.lnglat ? imageParams.lnglat.split(',') : [13.38333, 52.51667],
      //language: ['de']
    }

    if (imageParams.pitch) config.pitch = imageParams.pitch;
    if (imageParams.bearing) config.bearing = imageParams.bearing;
    if (imageParams.zoom) config.zoom = imageParams.initZoom || 14;

    map = new mapboxgl.Map(config);

    if (!is_touch_enabled()) {
      map.addControl(new mapboxgl.NavigationControl({
          visualizePitch: true
      }),'bottom-right');
    }

    //$('#map_overlay').insertBefore('.mapboxgl-canvas-container');
    $('.mapboxgl-control-container').insertBefore('#map_overlay');
  }

  var setHeadline = function() {
    if (!$('#hidden_input_headline').length) return;
    var headline = '';
    if ($('#headline_custom').val()) {
      headline = $('#headline_custom').val();
    } else {
      headline = $('#headline_select').val();
    }
    if (!headline) return;   
    imageParams.headline = headline;
    $('#hidden_input_headline').val(headline);
  }
  
  $(document).on('keydown', '.on_input input[type="text"]', function(event) {
    // prevent submit when enter key is pressed
    if (event.originalEvent.which === 13 || event.originalEvent.keyCode === 13 || event.originalEvent.key === 'Enter') {
      event.preventDefault();
      return false;
    }
  });

  $(document).on('input', '.input_fields input[type="search"]', debounce(mapSearchEvent,500));

  $(document).on('focus', '.input_fields input[type="search"]', mapSearchEvent);

  $(document).on('click','.place_query_result_item.heartmap', function(event) {
    autocompleteClose();
    var place = resultList[$(this).data('index')];
    imageParams.lat = place.center[1];
    imageParams.lon = place.center[0];
    if (imageParams.lat && imageParams.lon) {
      imageParams.place_display = place.text_de;
      $('#place_display').val(place.text_de);
      $('.input_container.place_display').show();
      $('#place_query').val('');     
      setHeadline();
   	  fetchPreviewImage();
    }
  });

  $(document).on('click','.place_query_result_item.zuhause', function(event) {
    autocompleteClose();
    var place = resultList[$(this).data('index')];
    imageParams.lat = place.center[1];
    imageParams.lon = place.center[0];
    if (imageParams.lat && imageParams.lon) {
      imageParams.place_query = place.place_name_de;
      $('#place_query').val(imageParams.place_query);     
   	  fetchPreviewImage();
    }
  });
  
  $(document).on('click','.place_query_result_item.heartmap2', function(event) {
    autocompleteClose();
    var place = resultList[$(this).data('index')],
        lat = place.center[1],
        lon = place.center[0],
        placetype = place.place_type[0] || '',
        name = place.text_de,
        zoom = 14;

    switch(placetype) {
      case 'poi':
      case 'address':
        zoom = 16;
        break;
      case 'place':
        zoom = 13;
    }

    if (map && lat && lon) {
      map.setBearing(0);
      map.setPitch(0);
      map.setZoom(zoom);
      map.setCenter(new mapboxgl.LngLat(lon,lat));
      $('#place_query').val('');
      $('#place_display').val(name);
      $('.option_group.place_display').show();
      imageParams.place_display = name;
      setHeadline();
    }
  });

  $(document).on('click','#btn_confirm_location', function(event) {
    if (!map) return;
    var boundsArr = map.getBounds().toArray();
    boundsArr = boundsArr[0].concat(boundsArr[1]);
    // lets predict the zoom level on the server
    var viewportData = geoViewport.viewport(boundsArr,[1280,1280],0,20,512,true);   
    var center = map.getCenter();   
    imageParams.lnglat = center.lng + ',' + center.lat;
    imageParams.bearing = map.getBearing(); // messes up zoomlevel
    imageParams.pitch = map.getPitch();
    imageParams.zoom = imageParams.bearing || imageParams.pitch ? viewportData.zoom + 0.45 : viewportData.zoom;
    imageParams.initZoom = map.getZoom();
    fetchPreviewImage();
    document.getElementById('PopupModal__map').hide();
  });

  $(document).on('input', '.input_fields input[type="text"]', debounce(function(event) {
    var $currentTarget = $(event.currentTarget);
    if ($currentTarget.data('observed')) return;
    if ($currentTarget.val().trim()) imageParams[$currentTarget.attr('id')] = encodeURIComponent($currentTarget.val().trim());
    setHeadline();
   	fetchPreviewImage();
  },500));

  $(document).on('change', '#headline_select', function(event) {
	imageParams.headline = $('#headline_select').val();
    $('#headline_custom').val('');
    $('#hidden_input_headline').val(imageParams.headline);
    fetchPreviewImage();
  });

  $(document).on('click', '.swatch', function(event) {

    var $currentTarget = $(event.currentTarget);

    if ($currentTarget.data('type') === 'personsAmount') return;   
    if ($currentTarget.data('type') == 'floatingFrame') return;
    
    if ($currentTarget.data('type') === 'variant_swatch') {
      setHeadline();
      handleVariantSwatch({
        currentTarget:$currentTarget,
        updatePreviewImage:true
      });
      
    } else {
      setHeadline();
      handleSwatch({
        currentTarget:$currentTarget,
        updatePreviewImage:true
      });
    }

    if ($currentTarget.data('type') === 'mapstyle') {      
      if (map) map.setStyle(getMapStyle());
      // keep swatches on page and in modal in sync
      $('.swatch[data-type="mapstyle"]').removeClass('active');
      $('.swatch[data-type="mapstyle"][data-value="'+imageParams.mapstyle+'"]').addClass('active');
    }
  });

  $(document).on('click', '#btn_open_map_modal', function(event) {
    if (!map) initMap();
  });
  
  if (cookieParams) {

    prefillInputFields();

    var headlineOptionExists = false;
    $('#headline_select option').each(function() {
      if (this.value == cookieParams.headline) {
        headlineOptionExists = true;
        return false;
      }
    });
    
    if (headlineOptionExists) {
      $('#headline_select').val(cookieParams.headline);
      $('#headline_custom').val('');
    } else {
      $('#headline_custom').val(cookieParams.headline);
    }
    
    setHeadline();

    if (imageParams.place_display) {
      $('.input_container.place_display').show();
    }

    // center is turned to weired ¢er -> so we use lnglat instead   
    delete cookieParams.center;
    delete imageParams.center;

    showHideInputFields(imageParams.personsAmount,'.persons_names');

    handleSwatch({currentTarget: $('.persons.swatches').find('[data-value="'+ (imageParams.personsAmount || '2') +'"]')});
    handleSwatch({currentTarget: $('.tone.swatches').find('[data-value="'+ (imageParams.tone || 'bw') +'"]')});
    
    fetchPreviewImage();
  }

  initSwatchEvents();

  
  if (imageParams.productType == 'zuhause') return;

  
  // if variant id exists in url it overrides style saved in cookie
  if (urlParams.variant) {
    imageParams.style = customizationData.variantIds[urlParams.variant];
  }

  if (imageParams.mapstyle) {
    handleSwatch({currentTarget: $('.mapstyle.swatches').find('[data-value="'+imageParams.mapstyle+'"]')});
  }
  
  if (imageParams.maptone) {
    handleSwatch({currentTarget: $('.maptone.swatches').find('[data-value="'+imageParams.maptone+'"]')});
  }
  
  $initialVariantSwatch = $('.variant.swatches').find('[data-value="'+imageParams.style+'"]'); 
  // put current variant swatch at first position
  $initialVariantSwatch.prependTo('.variant.swatches');
  $('.variant.swatches').css({'opacity':1});

  handleVariantSwatch({
    currentTarget:$initialVariantSwatch,
    updatePreviewImage:false
  });
}

function initLettermaskUI(cookieParams) {

  $('.texts').find('input').each(function(i,input) {
    var imageparam = $(input).data('imageparam');
    if (imageParams[imageparam]) {
      $(input).val(imageParams[imageparam]);
    }
    // show refresh btn only when there is a custom textline
    if (imageparam == 'textline1') {
      $('#restoreDefaultTextline').css({display: $(input).val() == customizationData.defaultTextline1 ? 'none' : ''});
    }
  });

  imageParams.textline1 = imageParams.textline1 ? imageParams.textline1 : customizationData.defaultTextline1;
  
  if (cookieParams) {
    fetchPreviewImage();
    handleSwatch({currentTarget: $('.bg_style.swatches').find('[data-value="'+imageParams.bg+'"]')});
  }

  $(document).on('input','#input_field_textline1',function(event) {
    var val = $(event.currentTarget).val();
    $('#restoreDefaultTextline').css({display: val == customizationData.defaultTextline1 ? 'none' : ''});
  });

  $(document).on('click', '.bg_style .swatch', function(event) {
    imageParams.textline1 = $('#input_field_textline1').val();
    var $currentTarget = $(event.currentTarget);
    handleSwatch({
      currentTarget:$currentTarget,
      updatePreviewImage:true
    });
  });

  $('#restoreDefaultTextline').on('click', function(event) {
    if (imageParams.textline1 == customizationData.defaultTextline1) return;
    $(this).css({display: 'none'});
    $('#input_field_textline1').val(customizationData.defaultTextline1);
    imageParams.textline1 = customizationData.defaultTextline1;
    fetchPreviewImage();
  });
}

function initWatercolorUI(cookieParams) {

  handleSwatch({
    currentTarget: $('.aiStyle.swatches').find('[data-value="'+ (imageParams.aiStyle || '') +'"]'),
    updateImageParamsCookie: true
  });

  if (imageParams.angle == 'memorial') {
    handleSwatch({
      currentTarget: $('.customerImageTone.swatches').find('[data-value="'+ (imageParams.customerImageTone || 'bw') +'"]'),
      updateImageParamsCookie: true
    });
    handleSwatch({
      currentTarget: $('.textType.swatches').find('[data-value="'+ (imageParams.textType || 'singular') +'"]'),
      updateImageParamsCookie: true
    });
  }

  if (cookieParams) {
    prefillInputFieldsDecoded();
    toggleCustomTextArea(imageParams.text);
    $('#text_type_select option[value="' + imageParams.text + '"]').attr('selected',true);
    if (imageParams.customText) {
      $('#custom_text_textarea').val(imageParams.customText);
    }
    fetchPreviewImage();
  }
  initSwatchEvents();
  initTextSelectChangeEvent();
}

function initWorcollageUI(cookieParams) {

  handleSwatch({currentTarget: $('.subStyle.swatches').find('[data-value="'+ (imageParams.subStyle || 'wordcollage-mama') +'"]')});

  imageParams.layout = 'v1';
  customizationData.selectableImagesConfig.count = 8;
  if (customizationData.tags.includes('wordcollage-layout-v2')) {
    imageParams.layout = 'v2';
    customizationData.selectableImagesConfig.count = 4;
  }

  //$('.sp_image_upload_min-amount').html(customizationData.selectableImagesConfig.count);

  if (cookieParams) {

    prefillInputFieldsDecoded();

    toggleCustomTextArea(imageParams.text);

    $('#text_type_select option[value="' + imageParams.text + '"]').attr('selected',true);

    if (imageParams.customText) {
      $('#custom_text_textarea').val(imageParams.customText);
    }
    
    fetchPreviewImage();
  }

  initSwatchEvents();

  initTextSelectChangeEvent();
}

function initWordmaskUI(cookieParams) {

  handleSwatch({currentTarget: $('.persons.swatches').find('[data-value="'+ (imageParams.personsAmount || '2') +'"]')});
  handleSwatch({currentTarget: $('.tone.swatches').find('[data-value="'+ (imageParams.tone || 'color') +'"]')});

  if (cookieParams) {

    prefillInputFields();

    showHideInputFields(parseInt(imageParams.personsAmount || 3),'.persons_names');

    fetchPreviewImage();
  }

  initSwatchEvents();
}

function initMothersdaymaskUI(cookieParams) {

  handleSwatch({currentTarget: $('.bg.swatches').find('[data-value="'+ (imageParams.bg || 'mothersday4') +'"]')});
  //handleSwatch({currentTarget: $('.tone.swatches').find('[data-value="'+ (imageParams.tone || 'color') +'"]')});

  imageParams.person = 'mother';
  if (customizationData.tags.includes('mothersdaymask-father')) {
    imageParams.person = 'father';
  }
  
  if (cookieParams) {
    // we make sure the "&" stays
    imageParams.names = encodeURIComponent(imageParams.names);
    
    prefillInputFieldsDecoded();

    toggleCustomTextArea(imageParams.text);

    $('#text_type_select option[value="' + imageParams.text + '"]').attr('selected',true);

    if (imageParams.customText) {
      $('#custom_text_textarea').val(imageParams.customText);
    }

    fetchPreviewImage();
  }

  initSwatchEvents();

  initTextSelectChangeEvent();
}

function initPlannerUI(cookieParams) {
  handlePersonsSwatch({currentTarget: $('.persons.swatches').find('[data-amount="'+ imageParams.personsAmount || 4 +'"]')});
  //handleSwatch({currentTarget: $('.style.swatches').find('[data-value="'+ (imageParams.style || 'chaos1') +'"]')});
  
  if (cookieParams) {
    prefillInputFields();
    showHideInputFields(imageParams.personsAmount,'.persons_names');
    fetchPreviewImage();
  }

  // swatch events
  $('.sp_options-container').on('click', '.swatch', function(event) {

    var $currentTarget = $(event.currentTarget),
        swatchType = $currentTarget.data('type');

    if ($currentTarget.hasClass('disabled')) return;

    if (swatchType == 'floatingFrame') return;

    if (swatchType === 'persons_swatch') {
      handlePersonsSwatch({
        currentTarget:$currentTarget,
        updatePreviewImage:true
      });
      return;
    }
  });
}

function initPolaroidsUI(cookieParams) {

  var hasTextSelect = $('#text_type_select').length;

  handleSwatch({currentTarget: $('.imageAmount.swatches').find('[data-value="'+ (imageParams.imageAmount || 3) +'"]')});

  showHideMultiColumnInputFields({
    amount: imageParams.imageAmount,
    containerSelector: '.image_texts',
    colSelectors: ['.line1-','.line2-']
  });

  // set "Familienglück" as default headline
  if (!Object.hasOwn(imageParams, 'headline'))  imageParams.headline = 'Familienglück';

  // fill headline input field (with default value)
  prefillInputFieldsDecoded();
  prefillInputFieldsDecoded('.input_container_sibling');
  
  if (cookieParams) {

    // we make sure the "&" stays
    imageParams.names = encodeURIComponent(imageParams.names);

    if (hasTextSelect) {
      toggleCustomTextArea(imageParams.text);
  
      $('#text_type_select option[value="' + imageParams.text + '"]').attr('selected',true);
  
      if (imageParams.customText) {
        $('#custom_text_textarea').val(imageParams.customText);
      }
    }

    fetchPreviewImage();
  }

  if (hasTextSelect) {
    initTextSelectChangeEvent();
  }

  $('.sp_options-container').on('click', '.swatch', function(event) {

    var $currentTarget = $(event.currentTarget),
        swatchType = $currentTarget.data('type');

    if ($currentTarget.hasClass('disabled')) return;

    if (swatchType == 'floatingFrame') return;

    handleSwatch({
      currentTarget:$currentTarget,
      updatePreviewImage:true
    });

    if (swatchType === 'imageAmount') {
      showHideMultiColumnInputFields({
        amount: imageParams.imageAmount,
        containerSelector: '.image_texts',
        colSelectors: ['.line1-','.line2-']
      });

      highlightActiveThumbs();
    }
  });
}

//======================================================================
// self invoking functions
//======================================================================
(function(handleCartItems) {

    var $floatingFrameSwatches = $('.sp_product').find('.floatingFrame.swatches');
  
    //======================================================================
    // public functions
    //======================================================================
    handleCartItems.addToCart = function(body) {
      if (!body) return;
      body = JSON.stringify(body);
      return fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body });
    }

    handleCartItems.deleteFromCart = function(body) {
      if (!body) return;
      body = JSON.stringify(body);
      return fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }

    handleCartItems.generateCartItemKey = function() {
      return window.crypto.randomUUID();
    }
  
    handleCartItems.setCartItemKey = function(cartItemKey) {
      $('product-form').data('cart-item-key',cartItemKey);
      $('#hidden_input_cartItemKey').val(cartItemKey);
    }

    handleCartItems.setNewCartItemKey = function() {
      var newCartItemKey = handleCartItems.generateCartItemKey();
      handleCartItems.setCartItemKey(newCartItemKey);
      return newCartItemKey;
    }

    handleCartItems.getCurrentCartItemKey = function() {
      return $('product-form').data('cart-item-key') || '';
    }

    handleCartItems.isEditMode = function() {
      return handleCartItems.getCurrentCartItemKey() ? true : false;
    }

    handleCartItems.quitEditMode = function() {
      $('product-form').removeAttr('data-cart-item-key');
    }

    handleCartItems.getItemByCartItemKey = function(cartItems,cartItemKey) {
      var result = {};
      cartItems.forEach(function(item,index){
        if (item.properties && item.properties._cartItemKey == cartItemKey) {
          result = item;
          result.line = index;
        }
      });
      return result;
    }

    handleCartItems.fetchLineItem = async function(itemPos) {
      itemPos = itemPos || 1;
      var cartItem = '';
      await fetch('/cart.js')
      .then(response => response.json())
      .then((cartJson) => {
        cartJson.items.forEach(function(item,index) {
          if (index == itemPos-1) {
            cartItem = item;
          }
        });
        //cartItem = cartJson.items.filter((item,index) => index == itemPos-1)[0];
      });
      return cartItem;
    };

    handleCartItems.getLineItemByPos = function(items,itemPos) {
      itemPos = itemPos || 1;
      items = items || [];
      return items.filter((item,index) => index == itemPos-1)[0] || null;
    };

    handleCartItems.atcEventHandler = function(event,productIsNewlyAdedd,cartItemKey) {

     // non-edit-mode: stop here and and only add canvas (allow regular form submit (@see product-form.js))
      if (productIsNewlyAdedd) {
        return true;
      }

      // prevent regular form submit
      event.preventDefault();

      //----------
      // In "edit mode" previously added item (productPageLineItem)
      // needs to be removed from cart and then re-added along with selected floating frame
      // -> necessary to keep the order (1. canvas, 2. frame)
      //----------
      fetch('/cart.js')
      .then(response => response.json())
      .then((cartJson) => {

        // if cart has been cleared in other tab or when using
        // browser back after clearing cart -> just add canvas and frame
        if (!cartJson.items.length) {
          splog('add item (to empty cart)');
          $('product-form')[0].onSubmitHandler(event);
          return;
        }

        var currentProductPageItem = handleCartItems.getItemByCartItemKey(cartJson.items,cartItemKey),
            updates = {};
       
        currentProductPageItem.properties = currentProductPageItem.properties || {};

        // delete main product/canvas (productPageLineItem)
        updates[currentProductPageItem.key] = 0;

        // delete items           
        handleCartItems.deleteFromCart({
          updates: updates
        })
        .then(response => response.json())
        .then((state) => {
            // EDIT MODE: re-add item (with new properties)
            $('product-form')[0].onSubmitHandler(event);
        });
      });      
    }



    // Flag + Referenz auf den ursprünglichen ATC-Button
    var imageConfirmed = false;
    var $lastAtcButton = null;

    // wird aufgerufen, BEVOR wirklich in den Warenkorb gelegt wird
    handleCartItems.validateImageParamsBeforeAtc = function(event, $btn) {

      // do check only if it'S an "upload product"
      if (!imageParams.uid) return true;

      if (!imageParams.aiStyle) return true;

      var showModal = false,
          failedImages = spLocalStorageGet('sp_failed_images','json') || [];

      if (!imageParams.customBackground) {
        showModal = true;
      }

      if (failedImages.includes(imageParams.customBackground)) {
        showModal = true;
      }

      if (showModal) {
        // gemerkten Button speichern, damit wir später erneut "klicken" können
        $lastAtcButton = $btn;

        var atcConfirmationModal = document.getElementById('PopupModal__confirm-preview-image');
        atcConfirmationModal.show();

        return imageConfirmed; // ist beim ersten Klick false
      } else {
        return true;
      }
    };


    
    //======================================================================
    // EVENT LISTENERS
    //======================================================================

    //----------------------------------------------------------------------
    // ATC BUTTON CLICK EVENT
    // important to delegate event so it is fired before onSubmitHandler (@see product-form.js)
    //----------------------------------------------------------------------  
    $(document).on('click', 'button[name="add"]', function(event) {

      if (!allowEditMode) {
        // quit edit mode first
        handleCartItems.quitEditMode();
      }

      // for seome reason form validation needs to be triggered manually
      $('product-form form')[0].reportValidity();

      // do check only if it'S an "upload product"
      if (imageParams.uid) {
        // FALL 1: zweiter Klick, nachdem im Modal bestätigt wurde
        if (imageConfirmed) {
          // Flag zurücksetzen, danach normal weiterlaufen lassen
          imageConfirmed = false;
          return true; // Formular/Submithandler dürfen jetzt durchlaufen
        }

        if (!handleCartItems.validateImageParamsBeforeAtc(event, $(this))) {
          event.preventDefault();
          return false; // ATC hier abbrechen, bis der Kunde im Modal bestätigt
        }
      }


      // if atc button is clicked and edit mode is not active
      // we know, that the product is added (not edited)
      var productIsNewlyAdedd = !handleCartItems.isEditMode();
      
      // when not in edit mode -> generate new cart item key
      var cartItemKey = productIsNewlyAdedd ? handleCartItems.setNewCartItemKey() : handleCartItems.getCurrentCartItemKey();
      
      if (productIsNewlyAdedd) {

        // when item is added to cart, save imageParams in 'sp_image_params_cart_items' cookie
        setImageParamsToCookie(getImageParamsCookieKey(),imageParams);

        // if product uses customer images
        // handle save images to "cartItemKey directory"
        if (customizationData.hasImageUploadForm) {
          $.ajax({
            url: '//'+server+'/uploads/storeCartItemImages.php',
            dataType: 'json',
            cache: false,
            data: {
              uid: getUid(),
              productDir: getProductDir(),
              cartItemKey: cartItemKey
            },
            type: 'post',
            crossDomain: true,
            complete: function(data) {},
            success: function(response) {},
            error: function(xhr, ajaxOptions, thrownError) {
              console.log(thrownError);
            }
          });
        }
      } else {
        // set line to 1 because after editing, the item will appear as first cart item
        // so in case of page reload the first cart item is loaded
        const url = new URL(window.location.href),
              queryParams = Object.fromEntries(new URLSearchParams(url.search));
        queryParams.line = 1;       
        window.history.replaceState({},'',`${url.pathname}?${new URLSearchParams(queryParams).toString()}`);
      }
      
      if ($floatingFrameSwatches.length) {
        handleFloatingFrameSwatches.atcEventHandler(event,productIsNewlyAdedd,cartItemKey);
      } else {
        handleCartItems.atcEventHandler(event,productIsNewlyAdedd,cartItemKey);
      }
    });


    $(document).on('click', '#PopupModal__confirm-preview-image button[data-confirm-atc]', function(event) {
      event.preventDefault();

      // Kunde hat bestätigt
      imageConfirmed = true;

      // Modal schließen
      var atcConfirmationModal = document.getElementById('PopupModal__confirm-preview-image');
      atcConfirmationModal.hide && atcConfirmationModal.hide();

      // ursprünglichen ATC-Button erneut klicken → diesmal läuft der Code oben durch
      if ($lastAtcButton) {
        $lastAtcButton.trigger('click');
      }
    });

    //----------------------------------------------------------------------
    // ADD ADDITIONAL ITEM BUTTON CLICK EVENT
    // @see buy-buttons.liquid
    //----------------------------------------------------------------------
    $('#add-more').on('click', function(event) {
      // quit edit mode first
      handleCartItems.quitEditMode();
      // new cartItemKey is set afterwards
      $('button[name="add"]').click();
    });

})(window.handleCartItems = window.handleCartItems || {});

(function(handleFloatingFrameSwatches) {

    var $floatingFrameSwatches = $('.sp_product').find('.floatingFrame.swatches');

    //======================================================================
    // private functions
    //======================================================================
    var getSize = function() {
      return $('#variant-picker-container input:checked').val() || '';
    }

    var getColor = function() {
      return $floatingFrameSwatches.find('.active').data('color') || '';
    }

    var getPrice = function() {
      var size = getSize(),
          color = getColor();
      if (!size || !color) return '';
      return floatingFrames.variants[size] ? floatingFrames.variants[size]['price'] : '';
    }

    var formatPrice = function(price) {
      return '+ ' + new Intl.NumberFormat("de-DE", {style: "currency", currency: "EUR"}).format(price);
    }

    var handlePriceDisplay = function(output) {
      $priceContainer = $('.floating_frame_price_output');

      if (output) {
        $priceContainer.html(output);
        return;
      }     
      var price = getPrice(),
          //defaultPrice = 'ab 24,95 €';
          //defaultPrice = 'ab 29,95 €';
          //defaultPrice = 'ab 25,95 €';
          defaultPrice = 'ab 19,95 €';

      if (!price) {
        disableHiddenPropertyFields();
      }
      
      $priceContainer.html(price ? formatPrice(price) : defaultPrice);
    }

    var disableHiddenPropertyFields = function() {
      $('#hidden_input_bundleId').val('').prop('disabled',true);
      $('#hidden_input_bundleRole').val('').prop('disabled',true);
      $('#hidden_input_floatingFrameColor').val('').prop('disabled',true);
      $('#hidden_input_floatingFrameMockup').val('').prop('disabled',true);
    }
  
    var onSizeChangeHandle = function() {

      // if floating frame is not available for selected size
      if (!floatingFrames.variants[getSize()]) {

        $floatingFrameSwatches.find('.swatch').addClass('disabled');
        disableHiddenPropertyFields();
        handlePriceDisplay('Nicht verfügbar für dieses Format');

        // update preview image next time size changes
        onSizeChangeHandle.updateImageAfterSizeChange = true;

        // always fetch preview image for 120x80 if customer selected floating frame
        if (imageParams.floatingFrame) {
          fetchPreviewImage();
        }

      } else {

        $floatingFrameSwatches.find('.swatch').removeClass('disabled');
        handlePriceDisplay();

        // fetch preview image when swichting from e.g. 80x60 to 120x80
        // do not fetch if switching from e.g. 80x60 to 60x40
        if (imageParams.floatingFrame && onSizeChangeHandle.updateImageAfterSizeChange) {
          fetchPreviewImage();
        }

        // updating preview image not necessary
        onSizeChangeHandle.updateImageAfterSizeChange = false;
      }     
    }

    var addItemPlusFrame = function(event) {

      var bundleId = handleFloatingFrameSwatches.getNewBundleId(),
          floatingFrameVariantId = handleFloatingFrameSwatches.getVariantId();

      // if frame is available for selected format
      if (floatingFrameVariantId) {

        handleFloatingFrameSwatches.updateHiddenInputFields(bundleId);

        //console.log('STEP 1: ADD FRAME');
        handleCartItems.addToCart({
          id: floatingFrameVariantId,
          quantity: 1,
          properties: {
            '_color': getColor(),
            '_mockupType': 'frame',
            '_bundleRole': 'child',
            '_bundleId': bundleId
          },
        })
        .then(response => response.json())
        .then((state) => {
          //console.log('FRAME ADDED - NOW ADD CANVAS via $(product-form)[0].onSubmitHandler');
          $('product-form')[0].onSubmitHandler(event);
        });

      // if 120x80 is selected
      } else {
        //console.log('ADD PRODUCT WITHOUT FRAME (REGULAR SUBMIT)');
        $('product-form')[0].onSubmitHandler(event);
      }
    }

    //======================================================================
    // public functions
    //======================================================================
    handleFloatingFrameSwatches.getNewBundleId = function() {
      var timeStamp = Math.floor(Date.now()/1000);
      return 'bundle-' + timeStamp;
    }

    handleFloatingFrameSwatches.getVariantId = function(size,color) {
      size = size || getSize(),
      color = color || getColor();
      if (!size || !color) return false;
      if (!floatingFrames.variants[size]) return false;
      if (!floatingFrames.variants[size]['colors'][color]) return false;
      return floatingFrames.variants[size]['colors'][color];
    }
  
    handleFloatingFrameSwatches.onFloatingFrameSwatchClick = function($swatch) {

      if ($swatch.is('.disabled')) return;
  
      var color = $swatch.data('color');

      if (color) {
        imageParams.floatingFrame = color;
      } else {
        delete imageParams.floatingFrame;
      }
  
      activateSwatch($swatch);
      handlePriceDisplay();     
      fetchPreviewImage();

      // If we have enouph floating frame mockups there is no need to jump to the first image when changing frame color
      if (!(['canvas','canvas-v2'].includes(imageParams.printProduct) && imageParams.orientation === 'v')) {
        var sliderComponent = document.querySelector('media-gallery'),
            slider = sliderComponent.elements.viewer;
        sliderComponent.setActiveMedia(slider.sliderItems[0].getAttribute('id').replace('Slide-',''));
      }
    } 

    handleFloatingFrameSwatches.getItemByBundleId = function(items,bundleId,role) {
      var foundItem = null;
      items.forEach(function(item,index){
        if (item.properties && item.properties._bundleId == bundleId && item.properties._bundleRole == role) {
          foundItem = item;
        }
      });
      return foundItem;
    };

    handleFloatingFrameSwatches.updateHiddenInputFields = function(bundleId) {
        $('#hidden_input_bundleId').val(bundleId).prop('disabled',false);
        $('#hidden_input_bundleRole').val('parent').prop('disabled',false);
        $('#hidden_input_floatingFrameColor').val(getColor()).prop('disabled',false);
        //$('#hidden_input_floatingFrameMockup').val(floatingFrames.mockups[getColor()]).prop('disabled',false);
    }

    handleFloatingFrameSwatches.atcEventHandler = function(event,productIsNewlyAdedd,cartItemKey) {
      
      // if no frame is selcted or if frame is not available for selected canvas format
      if (!handleFloatingFrameSwatches.getVariantId()) {

        // unset previously set values
        disableHiddenPropertyFields();

        // non-edit-mode: stop here and and only add canvas (allow regular form submit (@see product-form.js))
        if (productIsNewlyAdedd) {
          return true;
        }
      }

      // prevent regular form submit
      event.preventDefault();

      //------------------------------------------------------------------------
      // In "non edit mode" we just add frame and canvas to cart
      //------------------------------------------------------------------------
      if (productIsNewlyAdedd) {
        addItemPlusFrame(event);
        return;
      }

      //------------------------------------------------------------------------
      // In "edit mode" previously added canvas (productPageLineItem)
      // needs to be removed from cart and then re-added along with selected floating frame
      // -> necessary to keep the order (1. canvas, 2. frame)
      //------------------------------------------------------------------------
      fetch('/cart.js')
      .then(response => response.json())
      .then((cartJson) => {
        // if cart has been cleared in other tab or when using
        // browser back after clearing cart -> just add canvas and frame
        if (!cartJson.items.length) {
          splog('addItemPlusFrame (to empty cart)');
          addItemPlusFrame(event);
          return;
        }

        var currentProductPageItem = handleCartItems.getItemByCartItemKey(cartJson.items,cartItemKey),
            updates = {},
            //itemsToDelete = [],
            productPageItemBundleId = '';
        
        currentProductPageItem.properties = currentProductPageItem.properties || {};

        // delete main product/canvas (productPageLineItem)
        updates[currentProductPageItem.key] = 0;
        
        // is there a bundleId?
        productPageItemBundleId = currentProductPageItem.properties._bundleId || '';

        // check if there is a child (floating frame) that needs to be deleted
        if (productPageItemBundleId) {
          var bundleChild = handleFloatingFrameSwatches.getItemByBundleId(cartJson.items,productPageItemBundleId,'child');
          if (bundleChild) updates[bundleChild.key] = 0;
        }
        
        // delete items           
        handleCartItems.deleteFromCart({
          updates: updates
        })
        .then(response => response.json())
        .then((state) => {
            // EDIT MODE: re-add canvas and frame
            addItemPlusFrame(event);
        });
      });
      
    }

    handleFloatingFrameSwatches.activateSwatch = function() {
      if ($floatingFrameSwatches.length && imageParams.floatingFrame) {     
        activateSwatch($floatingFrameSwatches.find('[data-color="'+ imageParams.floatingFrame +'"]'));
      }
    }

    //======================================================================
    // EVENT LISTENERS
    //======================================================================

    //------------------------------------------------------------------------
    // removeItem event
    // fired in cart.js when item gets removed we need to check if product
    // page needs to be synced accordingly
    //------------------------------------------------------------------------
    document.querySelector('cart-drawer').addEventListener('removeItem', (event) => {
      // only "floating frame (child) removement" is handled here
      if (event.detail.bundleRole == 'child') {
        if (handleCartItems.getCurrentCartItemKey() == event.detail.parentItem.properties._cartItemKey) {
          disableHiddenPropertyFields();
          delete imageParams.floatingFrame;
          activateSwatch($('.floatingFrame .swatch').first());
          handlePriceDisplay();
          fetchPreviewImage();
        }
      } else {
        if (event.detail.deletedCartItemKey == handleCartItems.getCurrentCartItemKey()) {
          handleCartItems.quitEditMode();
        }
      }
    });

    //------------------------------------------------------------------------
    // cartItemAdded event
    // fired in product-form.js when item is added to cart
    //------------------------------------------------------------------------
    if (document.querySelector('product-form')) {
      document.querySelector('product-form').addEventListener('cartItemAdded', (event) => {
        //console.log('**************************');
        //console.log('NEW PRODUCT ADDED');
        handleFloatingFrameSwatches.updateHiddenInputFields(event.detail.lastAddedItem.properties._bundleId || '');
      });
    }

    //----------------------------------------------------------------------
    // setup events (only on product page)
    //----------------------------------------------------------------------
    if (!$floatingFrameSwatches.length) return;

    $('#variant-picker-container').on('change','input',onSizeChangeHandle);

    $floatingFrameSwatches.on('click','.swatch',function() { handleFloatingFrameSwatches.onFloatingFrameSwatchClick($(this)); });

    //------------------------------------------------------------------------
    // update image in floatingFrame modal
    //------------------------------------------------------------------------
    $('[data-modal="#PopupModal__floatingFrameInfo"]').on('click', function(event) {

      if (!getImageParamsFromCookie(getImageParamsCookieKey())) return;

      $('#floatingFrameModalPreview').addClass('loading');

      var filteredImageParams = getFilterImageParams(),
            imageParamsQuery = objectToQueryString(filteredImageParams),
            frameColor = imageParams.floatingFrame || 'white',
            img = $('#floatingFrameModalPreviewImg')[0],
            src = 'https://'+server+'/?' + imageParamsQuery + '&mockupIndex=1';

      async function loadImage(src) {
        // update the source.
        img.src = src;
        // wait for it to load.
        await new Promise((resolve) => {
          img.onload = resolve;
        });        
        $('#floatingFrameModalPreview').removeClass('loading');
      }

      loadImage(src);
    });

    //======================================================================
    // Init
    //======================================================================
    onSizeChangeHandle();

})(window.handleFloatingFrameSwatches = window.handleFloatingFrameSwatches || {});

(function(handleFloatingFrameSwatchesInCart) {

  var lineItemId = '',
      itemToEdit = {},
      color = '',
      size = '',
      frameVariantId = '',
      latestBundleId = '',
      cartItems = null,
      itemToEditIsCurrentProductPage = false;

  function addItemPlusFrame() {

    // if frame is not available for selected format
    if (!frameVariantId) return;

    latestBundleId = handleFloatingFrameSwatches.getNewBundleId();

    handleFloatingFrameSwatches.updateHiddenInputFields(latestBundleId);

    //splog('STEP 1: ADD FRAME');
    handleCartItems.addToCart({
      id: frameVariantId,
      quantity: 1,
      properties: {
        '_color': color,
        '_mockupType': 'frame',
        '_bundleRole': 'child',
        '_bundleId': latestBundleId
      },
    })
    .then(response => response.json())
    .then((state) => {    
        //splog('STEP 2: ADD PRODUCT');
        itemToEdit.properties['_bundleRole'] = 'parent';
        itemToEdit.properties['_bundleId'] = latestBundleId;
        itemToEdit.properties['_floatingFrameColor'] = color;
      
        // add floatingFrame property (color) to itemToEdit.properties['_params']
        // used in "edit-link" data-params
        var _params = queryStringToObject(itemToEdit.properties['_params']);
        _params.floatingFrame = color;
        itemToEdit.properties['_params'] = objectToQueryString(_params);

        // update product image in cart - start
        itemToEdit.properties['_cachedImageUrl'] = 'https://'+server+'/?'+itemToEdit.properties['_params'];
        itemToEdit.properties['_cachedImageUrl'] += '&mockupIndex=1';
        // update product image in cart - end

        handleCartItems.addToCart({
          id: itemToEdit.variant_id,
          quantity: 1,
          properties: itemToEdit.properties,
          sections: cartItems.getSectionsToRender().map((section) => section.section)
        })
        .then(response => response.json())
        .then((state) => {
          //splog('DONE: ADDED FRAME AND CANVAS');
          cartItems.fetchCallback(lineItemId,'',JSON.stringify(state)); 
          cartItems.disableLoading(lineItemId);
          // if the item for which a frame was added is current
          // product page -> sync product page accordingly
          if (itemToEditIsCurrentProductPage) {
            handleFloatingFrameSwatches.onFloatingFrameSwatchClick($('.sp_options-container [data-type="floatingFrame"][data-color="'+color+'"]'));
          }
        });
    });
  }

  $('#CartDrawer').on('click','.sp_cart-item__add-frame-option .swatch', function() {

    // floating frame swatch in cart drawer
    var $frameSwatch = $(this);

    if ($frameSwatch.is('.disabled')) return;

    // get cartItems instance
    cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');

    var klickedSwatchCartItemKey = $frameSwatch.parents('.sp_cart-item').data('cartitemkey');

    itemToEditIsCurrentProductPage = klickedSwatchCartItemKey == handleCartItems.getCurrentCartItemKey();

    // id/position of the item to which we want to add a frame
    lineItemId = $frameSwatch.data('line-item');

    // show spinner
    cartItems.enableLoading(lineItemId);

    // frame color
    color = $frameSwatch.data('color');

    trackCustomEvent('pickFloatingFrameInCart', color);
    
    // fetch cart data
    fetch('/cart.js')
    .then(response => response.json())
    .then((cartJson) => {

      var updates = {};

      // item to which we want to add a frame
      itemToEdit = handleCartItems.getItemByCartItemKey(cartJson.items,klickedSwatchCartItemKey);
      
      // size of item to which we want to add a frame 
      size = itemToEdit.variant_title;

      // productId of selected frame
      frameVariantId = handleFloatingFrameSwatches.getVariantId(size,color);

      // if frame is not available for
      // selected format -> do nothing
      if (!frameVariantId) return;

      // delete main product (canvas) first
      // so canvas and frame re-appear in the right order
      // this also makes current _cartItemId void!!!
      updates[itemToEdit.key] = 0;

      handleCartItems.deleteFromCart({
        updates: updates
      })
      .then(response => response.json())
      .then((state) => {
          // now re-add canvas and frame
          addItemPlusFrame();
      });
    });   
  }); 

})();

(function initSentry() {
  if (typeof Sentry === 'undefined') return;
  Sentry.onLoad(function() {
    Sentry.init({
      //dsn: 'https://d24876e0de6f41429645cd57b86cb04f@o525658.ingest.sentry.io/5640139',
      dsn: "https://d24876e0de6f41429645cd57b86cb04f@o525658.ingest.us.sentry.io/5640139",
      //replaysSessionSampleRate: 0.1,
      //replaysOnErrorSampleRate: 1.0,
      tracesSampleRate: 1.0,
      integrations: []
      //integrations: [new Sentry.BrowserTracing()]
      //integrations: [new Sentry.BrowserTracing(),new Sentry.Replay()]
    });
  });  
})();

(function initSliders() {

  function initProductPageReviewSlider(containerId) {
  
    if (!$(containerId).length) return;
    
    var options = {
  	type: 'loop',
      gap: '0px'
    };
  
    if (isPageType('products') || isPageType('index')) {
  	options.perPage = 1;
      options.breakpoints = {
        749: {
          perPage: 2,
        },
        599: {
          perPage: 1,
        }
      }
    } else if (isPageType('cart')) {
  	options.perPage = 4;
      //options.autoplay = true;
      //options.interval = 5000;
      options.perMove = 1;
      options.breakpoints = {
        1024: {
          perPage: 3,
        },
        990: {
          perPage: 2,
        },
        640: {
          perPage: 1,
        },
      }
    } else {    
      return;
    }
  
    var splide = new Splide(containerId,options); 
    splide.mount();
  }
  
  function initTestimonialSlider(containerId) {

    if (!$(containerId).length) return;

    var options = {
      	type: 'loop',
          gap: '0px',
          perPage: 4,
          arrows: false,
          breakpoints: {
            1200: {
              perPage: 3,
            },
            800: {
              perPage: 2,
            },
            480: {
              perPage: 1,
            }
          }
        };
    
    var splide = new Splide(containerId,options); 
    splide.mount();
  }
  
  function initFeatureSlider(containerId) {

    if (!$(containerId).length) return;
    
    var splide = new Splide(containerId,{
      type: 'loop',
      gap: '0px',
      perPage: 4,
      autoplay: true,
      interval: 4000,
      pagination: false,
      arrows: false,
      breakpoints: {
        830: {
          perPage: 3,
        },
        590: {
          perPage: 2,
        },
        480: {
          perPage: 1,
        }
      }
    }); 
    splide.mount();
  }
  
  function initHeaderSlider(containerId) {
  
    if (!$(containerId).length) return;
    
    var splide = new Splide(containerId,{
      type: 'loop',
      gap: '0px',
      perPage: 1,
      autoplay: true,
      interval: 8000,
      //interval: 800000000,
      pagination: false,
      arrows: false
    }); 
    splide.mount();
  }
  
  function initIndexTestimonialSlider(containerId) {
  
    if (!$(containerId).length) return;
    
    var splide = new Splide(containerId,{
      type: 'loop',
      gap: '0px',
      perPage: 1,
      //autoplay: true,
      //interval: 2000,
      //pagination: false,
      arrows: false
    }); 
    splide.mount();
  }

  initProductPageReviewSlider('#sp_feedback-slider-splide');
  initTestimonialSlider('#sp_testimonial-slider-splide');
  initFeatureSlider('#sp_feature-slider-splide');
  initHeaderSlider('#sp_header-slider-splide');
  initIndexTestimonialSlider('#sp_index-feedback-slider-splide');
})();

(function happyCustomers() {
  $happyCustomersContainer = $('.happyCustomersNum');
  //if ($happyCustomersContainer.length) $happyCustomersContainer.html('53.273');
  //if ($happyCustomersContainer.length) $happyCustomersContainer.html('64.327');
  //if ($happyCustomersContainer.length) $happyCustomersContainer.html('70.000+');
  if ($happyCustomersContainer.length) $happyCustomersContainer.html('100.000');
})();

(function handleCartEvents() {
  
  $('#CartDrawer').on('click','.sp_cart-item__add-frame-toggle', function() {
    $container = $(this).parent('.sp_cart-item__add-frame-option');
    $container.toggleClass('show-infotext');
    trackCustomEvent('toggleFloatingFrameOptionInCart', $container.hasClass('show-infotext') ? 'open' : 'close');
  });

  if (!isPageType('product')) return;

  /*
  // for seome reason form validation needs to be triggered manually
  $('button[name="add"]').on('click', function(event) {
    $('product-form form')[0].reportValidity();
  });
  */

  // if variant (size) is changed in cart drawer we want to keep options on product page in sync
  $('#CartDrawer').on('change','.sp-cart__variant-select[name="size_select"]',function(event) {   
    // only sync if product page corresponds to updated cart item
    if ($(this).parents('.sp_cart-item').data('cartitemkey') != handleCartItems.getCurrentCartItemKey()) return;
    $('variant-radios').find('input[value="'+this.options[this.selectedIndex].dataset.varianttitle+'"]').prop('checked','checked');
    $('variant-radios').change();
    // re-enable frame swatches
    $('.floatingFrame.swatches').find('.swatch').removeClass('disabled');
  });
})();

(function initTaboola() {
  if (!isPageType('product') || window._tfa === undefined) return;
  $('button[name="add"]').on('click',function() {
    _tfa.push({notify: 'event', name: 'Add_To_Cart', id: 1593971});
  });
  $('button[name="checkout"]').on(is_touch_enabled()?'touchstart':'mousedown',function() {
    _tfa.push({notify: 'event', name: 'start_checkout', id: 1593971});
  });
})();


(function(){
  const elBox   = document.getElementById('uploadStatusBox');
  const elMsg   = document.getElementById('spWaitMsg');
  const elBar   = document.getElementById('spWaitBar');
  const elSteps = document.getElementById('spWaitSteps');
  const elFun   = document.getElementById('spWaitFun');
  const startProgress = 0;

  const stepMsgs = {
   processing: [
      "🔎 Das hat geklappt. Dein Bild wird analysiert…",
      "🖼️ Farben, Kontrast & Kanten werden optimiert.",
      "🎨 Stil-Effekte werden angewendet …",
      "✂️ Hintergrund wird bereinigt & störende Ränder entfernt.",
      "🧠 Details werden geschärft und Bildrauschen reduziert.",
      "📐 Größe wird für Vorschau und Druck vorbereitet.",
    ],
    preview: [
      "🖼️ Vorschau wird vorbereitet...",
      "✨ Gleich geschafft...",
      "🔄 Vorschau wird gerendert...",
      "👀 Hier ist Dein Vorschaubild",
    ],
  };
  const funFacts = [
    "💡 Tipp: Du kannst später Größe & Rahmen frei wählen.",
    //"🐱 Fun Fact: Katzen können bis zu 100 verschiedene Laute.",
    "🎨 Aquarell bedeutet wörtlich „mit Wasser verdünnte Farbe“.",
    "😺 Noch einen Moment - gleich siehst du das Ergebnis!",
    "📸 Wusstest du? Gute Beleuchtung kann ein Foto um bis zu 30% lebendiger wirken lassen.",
    //"✨ Jedes Bild wird einzeln optimiert - keine automatische Massenbearbeitung.",
    "🖼️ Fun Fact: Kunst im Wohnraum steigert nachweislich das Wohlbefinden.",
    "🐾 Haustierfotos gehören zu den meistgedruckten Motiven weltweit.",
    "🧠 Unser Gehirn verarbeitet Bilder 60.000x schneller als Text - deswegen wirkt Kunst sofort.",
  ];

  let funTimer = null;
  let stepTimer = null;
  let autoBarTimer = null;
  let currentStep = '';
  let progress = startProgress;
  let startedAt = 0;
  let isDone = false;
  let expectedMs = 25000; // Default 25s
  let maxMs = 60000;      // Default 60s

  function resetUi() {
    if(funTimer) clearInterval(funTimer);
    if(stepTimer) clearInterval(stepTimer);
    if(autoBarTimer) clearInterval(autoBarTimer);
    currentStep = '';
    progress = startProgress;
    startedAt = 0;
    isDone = false;
  }

  function setStepsUI(step){
    if (step == currentStep) return;
    [...elSteps.children].forEach((chip,idx)=>{
      chip.classList.toggle('is-active', chip.dataset.id === step);
    });
    startStepTexts(step);
    currentStep = step;
  }

  function startFunFacts(){
    let i = 0;
    if(funTimer) clearInterval(funTimer);
    elFun.textContent = funFacts[0];
    funTimer = setInterval(()=>{
      i = (i+1) % funFacts.length;
      elFun.textContent = funFacts[i];
    }, 3000);
  }

  function startStepTexts(step){
    let i = 0;
    if(stepTimer) clearInterval(stepTimer);
    if (!stepMsgs[step]) return;
    elMsg.textContent = stepMsgs[step][0];
    stepTimer = setInterval(()=>{
      elMsg.textContent = stepMsgs[step][i] || elMsg.textContent;
      if (i == stepMsgs[step].length-1) {
        clearInterval(stepTimer);
      }
      i++;
    }, 4000);
  }

  function updateProgressBarUI(progress) {
    elBar.style.width = progress + "%";
    elBox.querySelector('.sp_upload-status--waitbox__progress')?.setAttribute('aria-valuenow', Math.round(progress));
  }

  function startAutoBarUI(expSeconds = 18, maxSeconds = 60){
    expectedMs = Math.max(1, expSeconds * 1000);
    maxMs      = Math.max(expectedMs + 1000, maxSeconds * 1000); // mind. > expected
    startedAt  = Date.now();

    setStepsUI('processing');

    if(autoBarTimer) clearInterval(autoBarTimer);

    autoBarTimer = setInterval(()=>{
      if (isDone) { clearInterval(autoBarTimer); return; }

      elBox.classList.remove('is-error');
      elBox.classList.remove('is-done');

      const elapsed = Date.now() - startedAt;

      // Timeout -> Fehler
      if (elapsed >= maxMs && imageParams.imageProcessStatus == 'working') {
        clearInterval(autoBarTimer);
        UploadUI.error('Die Verarbeitung hat zu lange gedauert. <a href="javascript:location.reload();">klicke hier</a>');
        //UploadUI.error('Die Verarbeitung hat sehr lange gedauert. Evtl. gab es ein Problem.');
        return;
      }

      // Phase 1: 8% -> 92% in expectedMs
      if (elapsed <= expectedMs) {
        const t = elapsed / expectedMs; // 0..1
        const target = startProgress + (92 - startProgress) * t; // linear (gerne easen, wenn gewünscht)
        progress = Math.max(progress,target);
      } else {
        // Phase 2: 92% -> max 99% langsam bis maxMs
        const over = elapsed - expectedMs;
        const span = maxMs - expectedMs;
        const t2 = Math.min(1, over / span); // 0..1
        const target = 92 + (99 - 92) * t2; // nie 100 erreichen
        progress = Math.max(progress,target);
      }

      // UI anwenden
      elBar.style.width = progress + "%";
      elBox.querySelector('.sp_upload-status--waitbox__progress').setAttribute('aria-valuenow', Math.round(progress));

      if(progress == 92) {
        setStepsUI('preview');
      }
    }, 200); // smooth & leichtgewichtig
  }

  function stopAllTimers(){
    if(funTimer) clearInterval(funTimer);
    if(autoBarTimer) clearInterval(autoBarTimer);
    funTimer = autoBarTimer = null;
  }


  // === Öffentliche API (angepasst) ===
  window.UploadUI = {
    start(opts = {}){
      // opts: { expectedDuration: 25, maxDuration: 45 }
      //const exp = Number(opts.expectedDuration ?? 25);
      //const max = Number(opts.maxDuration ?? 45);
      //elBox.classList.remove('is-done','is-error');
      elBox.classList.remove('is-error');
      elBox.classList.remove('is-done');

      console.log('UploadUI: start()');

      isDone = false;
      progress = startProgress;
      elBar.style.width = progress + "%";
      setStepsUI('uploading');
      startFunFacts();
    },
    setStep(step){ setStepsUI(step); },
    setMessage(txt){ elMsg.textContent = txt; },
    updateProgressBar(progress){ updateProgressBarUI(progress);},
    startAutoBar(){ startAutoBarUI();},
    complete(){
      isDone = true;
      stopAllTimers();
      setStepsUI('uploading');
      progress = 100;
      elBar.style.width = "100%";
      elMsg.textContent = "Fertig! Vorschau wird geladen …";
      elFun.textContent = "✨ Gleich erscheint deine Live-Vorschau.";
      elBox.classList.add('is-done');
    },
    error(msg){
      isDone = true;
      stopAllTimers();
      elBox.classList.add('is-error');
      elMsg.innerHTML = msg || "Oops - da ist etwas schiefgelaufen. Bitte versuche es erneut.";
      elFun.innerHTML = "Wenn Dein Bild nicht angezeigt wird, versuche es noch mal.";
      elBar.style.width = "0%";
    },
    reset() {
      resetUi();
    }
  };
})();


//======================================================================
// Application entry
//======================================================================
function initCustomizer() {

  if (!isPageType('products')) {
    return;
  }

  if (!customizationData) {
    trackCustomEvent('NOT CUSTOMIZABLE','customizationData empty');
    return;
  }

  imageParams = customizationData.imageParams;

  // save storage/cookie key to dom so that it is available in cartItems (needed for edit link)
  $('[name="properties[_imageParamsCookieKey]"]').val(getImageParamsCookieKey());
  //$('[name="properties[_mockupVersion]"]').val(customizationData.mockupVersion || '');

  const meta = JSON.stringify({
    ua: navigator.userAgent,
    ref: document.referrer || null,
    res: `${window.screen.width}x${window.screen.height}`,
    tz: Intl.DateTimeFormat().resolvedOptions().timeZone
  });

  $('[name="properties[_meta]"]').val(meta);

  var url = location.search.substring(1),
      urlParams = url ? queryStringToObject(url) : {},
      cookieParams = getImageParamsFromCookie(getImageParamsCookieKey());

  if (cookieParams) {

    try {

      cookieParams = queryStringToObject(cookieParams);
      
      delete cookieParams.ver;

      // product tag overrides cookie
      delete cookieParams.printProduct;

      //======================================================================
      // SIGNPOST related actions
      //======================================================================
      if (imageParams.productType === 'signpost') {

        if (!isPersonalizationOffProductPage()) {
          // background does not override default params on pageload
          delete cookieParams.background;
          delete cookieParams.personalizationOff;
        }     

        if (!customizationData.hasCustomImages) {
          delete cookieParams.bgIsMask;
          delete imageParams.bgIsMask;
        }

        // cookieParams.personsAmount might be empty if "personalization off product page" has beeen visited before
        // so we restore default
        cookieParams.personsAmount = cookieParams.personsAmount || imageParams.personsAmount;
      }

      if (imageParams.productType === 'signpost2') {

        //if (!isPersonalizationOffProductPage()) {
          // background does not override default params on pageload
          delete cookieParams.background;
          delete cookieParams.personalizationOff;
        //}     

        /*if (!customizationData.hasCustomImages) {
          delete cookieParams.bgIsMask;
          delete imageParams.bgIsMask;
        }*/

        // cookieParams.personsAmount might be empty if "personalization off product page" has beeen visited before
        // so we restore default
        cookieParams.personsAmount = cookieParams.personsAmount || imageParams.personsAmount;
      }

      if (imageParams.productType === 'familyhearts' ||
          imageParams.productType === 'familyhands' ||
          imageParams.productType === 'familytree' ||
          imageParams.productType === 'couplehands' ||
          imageParams.productType === 'simplebg' ||
          imageParams.productType === 'simplemask' ||
          imageParams.productType === 'mothersday' ||
          imageParams.productType === 'mothersdaymask') {
        // style does not override default params on pageload
        delete cookieParams.style;
      }

      if (imageParams.productType === 'lettermask') {
        // background does not override default params on pageload
        delete cookieParams.word;
      }

      // this makes sure these params always come from tags even after an update
      if (imageParams.productType === 'watercolor') {
        delete cookieParams.aiStyle;
        delete cookieParams.mask;
        delete cookieParams.bg;
      }

      /*
      /* merge default imageParams with imageParams that have been previously stored in cookie
      /*_______________________________________________________________________________________*/
      if (imageParams.productType === cookieParams.productType) {
        $.extend(imageParams,cookieParams);
      }

    } catch (e) {
      // cookie data is messed up so delete cookie
	  spLocalStorageRemove('sp_image_params');
    }

    /*
    /* url params override default and cookie params
    /* unknown params like fbclid are filtered here
    /*_______________________________________________________________________________________*/
    for (var prop in imageParams) {
      if (urlParams[prop]) {
        imageParams[prop] = urlParams[prop];
      }
    }

    // line param can exist in url but is not needed in imageParams
    delete imageParams.line;

  } else {
    document.querySelector('[id^="MediaGallery"]').classList.remove('initializing');
    initPinchZoom('.pinch-zoom');
  }

  initCustomizationUI(cookieParams,urlParams);
  initFileUpload();
}

function initCustomizationUI(cookieParams,urlParams) {

  // COMMON: prevent submit on enter
  $(document).on('keydown', '.sp_options-container input[type="text"]', function(event) {
    // prevent submit when enter key is pressed
    if (event.originalEvent.which === 13 || event.originalEvent.keyCode === 13 || event.originalEvent.key === 'Enter') {
      event.preventDefault();
      return false;
    }
  });

  // COMMON: observe input fields
  $(document).on('input', 'input[type="text"][data-observed],textarea[data-observed]', debounce(function(event) {
    allIntputFieldsToImageParams();
    fetchPreviewImage();
  },500));

  // COMMON: observe selects
  initObservedSelects();
  
  if (customizationData.imageParams.productType === 'signpost') {
  	initSignpostUI(cookieParams);
  }

  if (customizationData.imageParams.productType === 'signpost2') {
  	initSignpost2UI(cookieParams);
  }

  if (customizationData.imageParams.productType === 'chaos') {
  	initChaosUI(cookieParams);
  }

  if (customizationData.imageParams.productType === 'familyhearts' ||
      customizationData.imageParams.productType === 'familyhands' ||
      customizationData.imageParams.productType === 'newborn' ||
      customizationData.imageParams.productType === 'couplehands' ||
      customizationData.imageParams.productType === 'simplebg' ||
      customizationData.imageParams.productType === 'picturetree' ||
      customizationData.imageParams.productType === 'mothersday') {
  	initSharedUI(cookieParams);
  }

  if (customizationData.imageParams.productType === 'familytree' || customizationData.imageParams.productType === 'familytree_upload') {
  	initFamilytreeUI(cookieParams);
  }

  if (customizationData.imageParams.productType === 'familytree2') {
  	initFamilytree2UI(cookieParams);
  }
  
  if (customizationData.imageParams.productType === 'newborn2') {
    initNewborn2UI(cookieParams);
  }
  
  if (customizationData.imageParams.productType === 'mothersdaymask') {
    initMothersdaymaskUI(cookieParams);
  }

  if (customizationData.imageParams.productType === 'familyboots') {
    initFamilybootsUI(cookieParams);
  }

  if (customizationData.imageParams.productType === 'familychucks') {
    initFamilychucksUI(cookieParams);
  }
  
  if (customizationData.imageParams.productType === 'familyhearts2') {
    initFamilyhearts2UI(cookieParams);
  }

  if (customizationData.imageParams.productType === 'lettermask') {
    initLettermaskUI(cookieParams);
  }

  if (customizationData.imageParams.productType === 'ourstory') {
    initOurstoryUI(cookieParams);
  }
  
  if (customizationData.imageParams.productType === 'wordmask') {
    initWordmaskUI(cookieParams);
  }
  if (customizationData.imageParams.productType === 'watercolor' || customizationData.imageParams.productType === 'aiartwork') {
    initWatercolorUI(cookieParams);
  }

  if (customizationData.imageParams.productType === 'wordcollage') {
    initWorcollageUI(cookieParams);
  }

  if (customizationData.imageParams.productType === 'heartmap' || customizationData.imageParams.productType === 'heartmap2' || customizationData.imageParams.productType === 'zuhause') {
    initHeartmapUI(cookieParams,urlParams);
  }

  if (customizationData.imageParams.productType === 'simplemask') {
    initSimplemaskUI(cookieParams);
  }

  if (customizationData.imageParams.productType === 'streetsigncouple') {
    initStreetsigncoupleUI(cookieParams);
  }
  
  if (customizationData.imageParams.productType === 'zodiacsigns') {
    initZodiacsignsUI(cookieParams);
  }

  if (customizationData.imageParams.productType === 'planner') {
    initPlannerUI(cookieParams);
  }

  if (customizationData.imageParams.productType === 'polaroids') {
    initPolaroidsUI(cookieParams);
  }

  // 'beachchairs' doesn't need a special UI
  if (customizationData.imageParams.productType === 'beachchairs') {
    if (cookieParams) {
      prefillInputFields();
      fetchPreviewImage();
    }
  }

  handleFloatingFrameSwatches.activateSwatch();
}

(function setupCustomizationData() {

  var jsonElement = document.getElementById('ProductJson-product-template');

  if (!jsonElement) return;

  var productData = JSON.parse(jsonElement.textContent);

  if (productData.tags.includes('tib')) {
    isTibProduct = true;
    return;
  }

  // set some params based on default values coming from product tags
  productData.tags.forEach(function(tag) {

    // if current tag is not a productType
    if (!products[tag]) return;

    customizationData = products[tag];
    customizationData.imageParams.productType = tag;
    customizationData.tags = productData.tags;
    customizationData.imageParams.orientation = 'h'; // default

    // for "old" canvases printProduct is set here not via tag
    customizationData.imageParams.printProduct = 'canvas';
    
    // re-iterate all tags
    productData.tags.forEach(function(tag) {
     
      if (customizationData.styles && Array.isArray(customizationData.styles) && customizationData.styles.includes(tag)) {
        // detect style
        customizationData.imageParams.style = tag;
      }

      if (tag == 'vertical') {
        customizationData.imageParams.orientation = 'v';
      }

      if (tag == 'has_image_upload_form') {
        customizationData.hasImageUploadForm = true;
      }
      
      /*
      * do productType related things
      */
      if (customizationData.imageParams.productType === 'signpost') {
        // set default background based on product tag
        if (customizationData.backgrounds[tag]) {
          customizationData.imageParams.background = tag;
        }
        // image is bw?
        if (tag === 'bw') {
          customizationData.imageParams.tone = 'bw';
        }

        if (tag === 'bg_is_mask') {
          customizationData.imageParams.bgIsMask = 1;
          customizationData.hasCustomImages = 1;
        }
      }

      if (customizationData.imageParams.productType === 'signpost2') {
        // set default background based on product tag
        if (customizationData.backgrounds[tag]) {
          customizationData.imageParams.background = tag;
        }
        // image is bw?
        if (tag === 'bw') {
          customizationData.imageParams.tone = 'bw';
        }
      }

      if (customizationData.imageParams.productType === 'lettermask') {
        var prefix = 'letters-';
        if (tag.indexOf(prefix) > -1) {
          customizationData.imageParams.word = tag.replace(prefix,'')
        }
      }

      var printProductPrefix = 'printproduct-';
      if (tag.indexOf(printProductPrefix) > -1) {
        customizationData.imageParams.printProduct = tag.replace(printProductPrefix,'')
      }

      // e.g. default-imageparam-headline-mama
      if (tag.indexOf('default-imageparam-') > -1) {
        var tagParts = tag.split('-'),
            imageParam = tagParts[tagParts.length - 2],
            val = tagParts[tagParts.length - 1];
        customizationData.imageParams[imageParam] = val;
      }

      if (tag.indexOf('aistyle-') > -1) {
        customizationData.imageParams.aiStyle = tag.split('-')[1];
      }
    });
  });

  if (customizationData.imageParams.productType === 'signpost' || customizationData.imageParams.productType === 'signpost2') {
    if (!customizationData.hasImageUploadForm) {
      delete customizationData.imageParamAsKey;
    }
  }

  //======================================================================
  // Init
  //======================================================================
  var urlParams = queryStringToObject(location.search.substring(1));

  if (urlParams.transportUid) {
    // new uid -> fresh start
    if(urlParams.transportUid != getUid()) {
      spLocalStorageRemove('sp_image_params');
      spLocalStorageRemove('sp_image_params_cart_items');
      spLocalStorageSet('sp_uid',urlParams.transportUid);
    }
    delete urlParams.transportUid;
    let newUrl = location.origin + location.pathname,
        paramsString = objectToQueryString(urlParams);
    if (paramsString) newUrl = newUrl + '?' + paramsString;
    window.history.pushState({},document.title,newUrl);
  }

  // are we in "edit mode"?
  if (allowEditMode && urlParams.line) {

    // [data-allow-edit-mode] @see sp_customizer.css    
    $('product-form').data('allow-edit-mode',1);

    handleCartItems.fetchLineItem(urlParams.line).then((item) => {
      // if e.g. line=2 retrieves a cart item
      if (item) {
        handleCartItems.setCartItemKey(item.properties._cartItemKey);
        // update cookieParams with params that had been stored in cart item properties       
        setImageParamsToCookie(item.properties._imageParamsCookieKey,objectToQueryString(item.properties._params));
      } else {
        // if no cart item is found (e.g. deleted in different tab)
        // remove line param from browser url
        const url = new URL(window.location.href),
              params = new URLSearchParams(url.search);
        params.delete('line');
        window.history.replaceState({},'',`${url.pathname}?${params}`);
      }
      initCustomizer();
    });
  } else {
    initCustomizer();
  }

  if (customizationData) {
    offerHint();
    handleBottomATC();
    initTrustBox();
    initCustomEventTracking();
    //applyCouponOnATC(); // call after handleBottomATC(); 
  } else {
    if (!customizationData && isTibProduct) {
      initTibProduct();
    }
  }

})();


//======================================================================
// delete cart items older than 7 days
//======================================================================
(async () => {
  const SEVEN_DAYS = 7 * 24 * 60 * 60; // 604.800 Sekunden
  const cartRes = await fetch('/cart.js');
  const cart = await cartRes.json();
  const now = Math.floor(Date.now() / 1000);
  const updates = {};
  cart.items.forEach((item, index) => {
    const addedAt = item.properties && item.properties._item_added_at
      ? parseInt(item.properties._item_added_at, 10)
      : null;

    if (addedAt && (now - addedAt) > SEVEN_DAYS) {
      // line-Index ist 1-basiert im Ajax API "updates" Objekt
      updates[item.key] = 0;
    }
  });

  if (Object.keys(updates).length) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ updates })
    });

    // optional: reload um UI zu aktualisieren
    //window.location.reload();
  }
})();